
import React from 'react';
import { ClaimDetail } from '../models/ClaimDetail.interface';
import { decimalRemove, setdefzeroval } from '../../../utils/inputValueFormat';
import { DropdownItem } from "../../../components/ConfigPage/models/Config.interface";
import { dropdownMappings } from "../../../services/dropdownApiRequest/dropdownApiRequests";
import { DROPDOWN_NAME } from "../../../constants/dropdownConstants";
import appConfig from '../../../constants/config';

import { elementDisplay, mandatoryInput, disableInput, elementSetAttribute, isElementVisible } from '../../../utils/elementControl';
import { checkAndAllowZeroAttach } from '../../../utils/attachmentControl';
import { checkNoAPEventCode } from '../../../components/FormInputComponents/ExceedraInputs';
import { calPerDiemDate } from '../../../components/FormInputComponents/PerDiemInputs';
import { changePerDiemTax, checkAndLoadTax, checkAndAutoCalTax, loadTaxCol, setDefaultTax, checkAndBind } from '../../../utils/taxChecking';
import { parse, parseISO, sub, isValid } from 'date-fns';
import { checkInputDecimal } from '../../../utils/inputValueFormat';
import { myToast, myToast as toast } from '../../../utils/myToast';
import { translate } from '../../../utils/translateUtils';
import { resetAPevent, resetProjectCode } from '../../../utils/projectCode';
import { format } from "date-fns";
import { isNullOrEmpty } from '../../../utils/formValidation';
import { canConstructReadableStream } from 'workbox-core/_private';
import { getGlobalLocation } from '../../../utils/globalManager';
import { getServiceOrderValue, soReset } from './serviceOrder';
import { load_IN_CustomFields } from './inCustom';
import { enableTaxDetailsForDE } from './deCustom';
import { disableVATnWHT_Section, enable_Disable_VAT_WHT_OnLoad, loadInvoice_Number, calculate_ClaimAmount, hideShowTaxableFields, employeeChildrenEducationFee, show_VAT_Section, enableBaseAmount, hide_VAT_Section, show_WHT_Section, hide_WHT_Section, show_WHT_Rates } from './thCustom';
import { smartRound } from '../../../utils/inputValueFormat';
import { getObjectClaimUserInfo } from '../../../utils/localStorage/localStorage';
import { postApiAxios } from '../../../utils/apiClient';
import endPoint from '../../../constants/endPoint';

// Saber, 20260923, SR-1023924: SPP_TXN_CLAIM_UPD @hotel was VARCHAR(50), so a saved hotel name
// can be shorter than the master-list option. Match the truncated value back to the full option.
function showMealInternalFollowUp(id_n: any) {
    const reveal = () => {
        elementDisplay(`#div_ddlLocalReceive${id_n}`, true, "div");
        elementDisplay(`#div_ddlNonLocalReceive${id_n}`, true, "div");
        elementDisplay(`#div_ddlLocalInvolve${id_n}`, true, "div");
        elementDisplay(`#div_ddlNonLocalInvolve${id_n}`, true, "div");
    };
    reveal();
    setTimeout(reveal, 0);
}

export function matchHotelOption(options: any[] | undefined, savedHotel: any) {
    if (!options || isNullOrEmpty(savedHotel)) return undefined;
    const saved = savedHotel.toString().trim();
    const exact = options.find((option: any) => option.value == saved || option.label == saved);
    if (exact) return exact;
    if (saved.length >= 50) {
        return options.find((option: any) =>
            option.value?.toString().startsWith(saved) || option.label?.toString().startsWith(saved)
        );
    }
    return undefined;
}

export function categoryOnChange(
    inputValues: { [key: string]: any | undefined },
    id_n: number | undefined,//saber,20251015
    handleInputChange: (id: string, value?: any) => Promise<void>,
    currentOnChangeInput: any,
    // objAttachment?:any,
    // objRequestor?:any
    bindDDL?: { [key: string]: any | undefined },
    handleBindDDL?: (id: string, value?: any) => void
){
    const objectRequestorString = localStorage.getItem('objRequestor');
    const objRequestor = !isNullOrEmpty(objectRequestorString) ? JSON.parse(objectRequestorString!) : null;
    const objAttachmentString = localStorage.getItem('objAttachment');
    const objAttachment = !isNullOrEmpty(objAttachmentString) ? JSON.parse(objAttachmentString!) : null;

    const isSameSavedCategory =
      !isNullOrEmpty(objAttachment?.subcategory_id) &&
      !isNullOrEmpty(currentOnChangeInput) &&
      currentOnChangeInput.toString() === objAttachment.subcategory_id.toString();

    // Reset VAT/WHT only when the user actually changes category.
    // On TH edit/QuickAdd load this reset calls calculate_ClaimAmount with
    // hidden_Init_claim_Amount=0 and overwrites the bound receipt amount.
    if (!isSameSavedCategory) {
    //reset
    subCatInputOnChange(
        inputValues,
        id_n,
        "ddlVAT",
        handleInputChange,
        0,
        bindDDL,
        handleBindDDL,
    );
    subCatInputOnChange(
        inputValues,
        id_n,
        "ddlWHT",
        handleInputChange,
        0,
        bindDDL,
        handleBindDDL,
    );
    subCatInputOnChange(
        inputValues,
        id_n,
        "ddlWHT2",
        handleInputChange,
        0,
        bindDDL,
        handleBindDDL,
    );
    }

    if (!isNullOrEmpty(currentOnChangeInput)) {
        elementDisplay(`#divProjectName_${id_n}`, true, "div");
        elementDisplay(`#divForm_${id_n}`, true, "div");  

        //Begin,Saber,20261013,INC-1050242 - Reload available forms for the selected category (as legacy GetDDLDataAvailableForm)
        if (handleBindDDL && objRequestor) {
            dropdownMappings[DROPDOWN_NAME.Form](objRequestor, inputValues?.[`form_mode`], false, objAttachment, currentOnChangeInput)
                .then((formOptions: any) => handleBindDDL(`formDDL`, formOptions))
                .catch((error: any) => console.error(error));
        }
        //End,Saber,20261013,INC-1050242

        if(currentOnChangeInput.toString() == "28" && objRequestor.country_code == "MY"){
            elementDisplay(`.others_txtRemarks`, true, "div");
        }
        else{
            elementDisplay(`.others_txtRemarks`, false, "div");
        }
      if (
        objAttachment.subcategory_id &&
        currentOnChangeInput.toString() !=
          objAttachment.subcategory_id.toString() &&
        document.querySelector<HTMLInputElement>(
          "input[name=paymentMode2]:checked"
        )?.value !== "cc"
      ) {

        // clearDetailFields(id_n!, inputValues, handleInputChange, objRequestor);
        loadSub(
          `ddlCategory${id_n}`,
          inputValues,
          handleInputChange,
          objRequestor,
          objAttachment,
          currentOnChangeInput,
          (id_num: string) => {
            setPaymentType2_visibility(
              currentOnChangeInput,
              objAttachment.transport_type,
              parseInt(id_num),
              inputValues,
              handleInputChange,
              parseInt(id_num),
              objRequestor,
              objAttachment,
              null,
              handleBindDDL,
              bindDDL
            );

            //reset and disable first
            enableRecoverable(
              false,
              parseInt(id_num),
              inputValues,
              handleInputChange,
              currentOnChangeInput,
              objAttachment,
              objRequestor
            );

            //AnP
            if (
              isExceedraEnabledCompany(objRequestor) &&
              (currentOnChangeInput.toString() == "17" ||
                currentOnChangeInput.toString() == "45")
            ) {
              enableRecoverable(
                false,
                parseInt(id_num),
                inputValues,
                handleInputChange,
                currentOnChangeInput,
                objAttachment,
                objRequestor
              );
            } else {
              elementDisplay(`#divCostCenter${id_num}`, true, "div");
              elementDisplay(`#divProjectCode_${id_num}`, true, "div");
              enableRecoverable(
                true,
                parseInt(id_num),
                inputValues,
                handleInputChange,
                currentOnChangeInput,
                objAttachment,
                objRequestor
              );
            }

            //Other Employee Benefits for OT Meal
            let tempcountrychk = appConfig.OTMealsCountry.split(",");
            if (
              tempcountrychk.includes(objRequestor.country_code) &&
              currentOnChangeInput.toString() == "3" &&
              objRequestor.country_code != ""
            ) {
              elementDisplay(`#divOTMealInfo${id_num}`, true, "div");
            } else {
              elementDisplay(`#divOTMealInfo${id_num}`, false, "div");
            }

            //Tech Allowance
            if (currentOnChangeInput.toString() == '49') {
                elementDisplay(`#disclaimerTechAllowance`, true, "div");
            }
            else{
                elementDisplay(`#disclaimerTechAllowance`, false, "div");
            }

            //Per Diem Control

            //Control Checking for country who can access per diem calculation function
            let temprequestor = objRequestor;
            let objClaimUserInfo = getObjectClaimUserInfo();
            let final_control_checking_user;

            if (!isNullOrEmpty(objClaimUserInfo)) {
              final_control_checking_user = objClaimUserInfo;
            } else if (!isNullOrEmpty(temprequestor)) {
              final_control_checking_user = temprequestor;
            } else {
            }

            let country_per_diem_control =
              appConfig.PerDiemControlCountry.split(",");

            if (objAttachment.iS_CC && objAttachment.iS_CC != "1") {
              if (
                country_per_diem_control.includes(
                  final_control_checking_user.country_code
                )
              ) {
                if (
                  currentOnChangeInput.toString() == "16" &&
                  final_control_checking_user.country_code != "CN"
                ) {
                  disableInput(`#txtClaimAmount${id_num}`, true, "text");
                } else if (
                  currentOnChangeInput.toString() == "42" &&
                  final_control_checking_user.country_code == "CA"
                ) {
                  //Canada Meal Allowance
                  disableInput(`#txtClaimAmount${id_num}`, true, "text");
                } else {
                  disableInput(`#txtClaimAmount${id_num}`, false, "text");  
                }
              }
            }

            //Chinea per diem special message shown
            if (
              final_control_checking_user.country_code == "CN" &&
              currentOnChangeInput.toString() == "16"
            ) {
              elementDisplay(`#divchinaperdieminfo${id_num}`, true, "div");
            } else {
              elementDisplay(`#divchinaperdieminfo${id_num}`, false, "div");
            }

            //Myammar per diem special message shown
            //Myammer disable currency code value
            if (
              final_control_checking_user.country_code == "MM" &&
              currentOnChangeInput.toString() == "16"
            ) {
              if (
                final_control_checking_user.company_code == "MM80" ||
                final_control_checking_user.company_code == "MM83"
              ) {
                elementDisplay(`#divMMperdieminfo${id_num}`, true, "div");
              } else if (final_control_checking_user.company_code == "MM82") {
                elementDisplay(`#divMMperdieminfo2${id_num}`, true, "div");
              }
            } else {
              elementDisplay(`#divMMperdieminfo${id_num}`, false, "div");
              elementDisplay(`#divMMperdieminfo2${id_num}`, false, "div");
              disableInput(`#ddlCurrency${id_num}`, false, "text");
            }

            if (objRequestor.country_code != "MM") {

              elementDisplay(`#APCevent_percent${id_num}`, false, "div");
              elementDisplay(`#APCevent_button${id_num}`, false, "div");
              elementDisplay(`#lblAPCeventIDpercentage${id_num}`, false, "div");
            }

            //Per diem claim - invoice/receipt date will hidden from user (global changes)
            if (
              currentOnChangeInput.toString() == "16" ||
              currentOnChangeInput.toString() == "41" ||
              currentOnChangeInput.toString() == "42" ||
              currentOnChangeInput.toString() == "51"
            ) {
              //Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic.

              elementDisplay(`#div_invoice_date${id_num}`, false, "div");
              handleInputChange(`isDateRange`, 1);
              handleInputChange(`txtDate${id_num}`, "");
              handleInputChange(`txtStartDate${id_num}`, "");
              handleInputChange(`txtEndDate${id_num}`, "");
              handleInputChange(`txtDateRange${id_num}`, "");
            } else {
              elementDisplay(`#div_invoice_date${id_num}`, true, "div");
            }

            if (
              currentOnChangeInput.toString() == "16" ||
              currentOnChangeInput.toString() == "51"
            ) {
              //Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic.
              handleInputChange(`hidtxtTaxable_amt_TH${id_num}_${id_num}`, 0);
            }

            // Load & display fields for India Customization.
            load_IN_CustomFields(
                id_n ,
                handleInputChange, 
                objAttachment
            );

            //End of per diem Control
            if (
              objRequestor.country_code == "DE" ||
              objRequestor.country_code == "PL" || //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
              objRequestor.company_code == "CH87" ||
              objRequestor.country_code == "VN"
            ) {
              enableTaxDetailsForDE(
                id_n, 
                currentOnChangeInput.toString(),
                inputValues,
                handleInputChange, 
                objRequestor, 
                objAttachment, 
                bindDDL!,
                handleBindDDL!,
                // Category changed from saved — reset tax values to defaults (isOnLoad = 0)
                0
              );
            } else {
              // Begin,Saber,20261007,INC-1030470 - category was just selected but is not yet in
              // the inputValues snapshot passed into this callback. loadTaxCol reads
              // ddlCategory from that snapshot, so a first-time category (credit-card import,
              // subcategory_id null) never bound a tax column.
              const categoryTaxInputs = { ...inputValues, [`ddlCategory${id_n}`]: currentOnChangeInput };
              setDefaultTax(id_n!, categoryTaxInputs, handleInputChange, window.location, objAttachment, objRequestor);
              loadTaxCol(id_n!, categoryTaxInputs, handleInputChange, window.location, objAttachment, objRequestor, inputValues[`isDateRange`] == "1" ? inputValues[`txtStartDate${id_n}`] : inputValues[`txtDate${id_n}`],handleBindDDL, bindDDL);
              // End,Saber,20261007,INC-1030470
            }

            resetAPevent(id_num);
            resetProjectCode(id_num);
            checkAndAllowZeroAttach(
              id_n!,
              inputValues,
              handleInputChange,
              currentOnChangeInput
            );
            checkAndDisablePersonalExpense(id_n, inputValues, objAttachment);

            //Thailand Tax feature
            if (objRequestor.country_code == "TH") {
              disableVATnWHT_Section(
                id_n, 
                inputValues,
                handleInputChange, 
              )
              enable_Disable_VAT_WHT_OnLoad(
                    id_n, 
                    inputValues,
                    handleInputChange, 
                    objAttachment, 
               );
              loadInvoice_Number(
                    id_n, 
                    inputValues,
                    handleInputChange, 
                    objAttachment
              );
              elementDisplay(`#divProjectName_${id_num}`, false, "div");
              elementDisplay(`#divAPCeventClaimable${id_num}`, false, "div");
            }

            if (objRequestor.country_code == "KH") {
              loadInvoice_Number(
                    id_n, 
                    inputValues,
                    handleInputChange, 
                    objAttachment
              );
            }

            // Begin, Saber, 20260514, SR-959286, CHN-20860, Load invoice number for MY (except MY98)
            if (objRequestor.country_code == "MY" || (window.location.pathname.includes("ExpReport") && objAttachment?.country == "MY")) {
              loadInvoice_Number(
                    id_n, 
                    inputValues,
                    handleInputChange, 
                    objAttachment,
                    window.location.pathname.includes("ExpReport")
              );
            }
            // End, Saber, 20260514, SR-959286, CHN-20860

            // Begin, Saber, 20260519, CHN-21547, Load invoice number for BN
            if (objRequestor.country_code == "BN" || (window.location.pathname.includes("ExpReport") && objAttachment?.country == "BN")) {
              loadInvoice_Number(
                    id_n, 
                    inputValues,
                    handleInputChange, 
                    objAttachment,
                    window.location.pathname.includes("ExpReport")
              );
            }
            // End, Saber, 20260519, CHN-21547, Load invoice number for BN

            if (objRequestor.country_code == "CN" || (window.location.pathname.includes("ExpReport") && objAttachment?.country == "CN")) {
                loadInvoice_Number(
                            id_n,
                            inputValues,
                            handleInputChange,
                            objAttachment,
                            window.location.pathname.includes("ExpReport")
                );
            }
            //Form Simplication START
            let formsimplification_companylist = localStorage.getItem(
              "Form_Simplification_Company"
            )
              ? localStorage.getItem("Form_Simplification_Company")?.split(",")
              : [];
            let isCompanyExists = false;
            if (
              formsimplification_companylist &&
              formsimplification_companylist.length > 0
            ) {
              for (let i = 0; i < formsimplification_companylist.length; i++) {
                let company_code = formsimplification_companylist[i];

                if (company_code == objRequestor.company_code) {
                  isCompanyExists = true;
                  break;
                }
              }
            }

            if (isCompanyExists) {
                // Hazel Amendments 20260716 Form simplification for CH84, Hide Form Name for IT COnsumable 
                if (currentOnChangeInput.toString() == "35"  && objRequestor.company_code == "CH84" ) {
        
                  elementDisplay(`#divForm_${id_num}`, false, "div");
                }
            
              if (currentOnChangeInput.toString() == "1") {
                if (
                  objRequestor.company_code != "JP80" &&
                  objRequestor.company_code != "JP86" &&
                  objRequestor.company_code.substring(0, 2) != "TH"
                ) {
                  elementDisplay(`#divForm_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divForm_${id_num}`, true, "div");
                }

                if (
                  objRequestor.company_code != "JP80" &&
                  objRequestor.company_code != "JP86" &&
                  objRequestor.company_code.substring(0, 2) != "TH"
                ) {
                  elementDisplay(`#divProjectName_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divProjectName_${id_num}`, true, "div");
                }
              }

              if (
                currentOnChangeInput.toString() == "2" ||
                currentOnChangeInput.toString() == "5"
              ) {
                if (
                  objRequestor.company_code != "JP80" &&
                  objRequestor.company_code != "JP86"
                ) {
                  elementDisplay(`#divForm_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divForm_${id_num}`, true, "div");
                }

                if (
                  objRequestor.company_code != "JP80" &&
                  objRequestor.company_code != "JP86" &&
                  objRequestor.company_code.substring(0, 2) != "TH"
                ) {
                  elementDisplay(`#divProjectName_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divProjectName_${id_num}`, true, "div");
                }
              }

              if (
                currentOnChangeInput.toString() == "15" ||
                currentOnChangeInput.toString() == "17" ||
                currentOnChangeInput.toString() == "22" ||
                currentOnChangeInput.toString() == "29" ||
                currentOnChangeInput.toString() == "32" ||
                currentOnChangeInput.toString() == "45"
              ) {
                if (objRequestor.company_code.substring(0, 2) != "TH") {
                  elementDisplay(`#divForm_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divForm_${id_num}`, true, "div");
                }

                if (objRequestor.company_code.substring(0, 2) != "TH") {
                  elementDisplay(`#divProjectName_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divProjectName_${id_num}`, true, "div");
                }
              }

              if (
                currentOnChangeInput.toString() == "16" ||
                currentOnChangeInput.toString() == "51"
              ) {
                //Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic.
                elementDisplay(`#divForm_${id_num}`, false, "div");

                if (objRequestor.company_code.substring(0, 2) != "TH") {
                  elementDisplay(`#divProjectName_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divProjectName_${id_num}`, true, "div");
                }
              }

              if (currentOnChangeInput.toString() == "21") {
                if (
                  objRequestor.company_code.substring(0, 2) != "TH" ||
                  objRequestor.company_code != "FR80" ||
                  objRequestor.company_code != "ES80"
                ) {
                  elementDisplay(`#divForm_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divForm_${id_num}`, true, "div");
                }

                if (
                  objRequestor.company_code.substring(0, 2) != "TH" ||
                  objRequestor.company_code != "FR80" ||
                  objRequestor.company_code != "ES80"
                ) {
                  elementDisplay(`#divProjectName_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divProjectName_${id_num}`, true, "div");
                }
              }
            }

            //Form Simplication END

            // CH84: Hide Project Name for all categories
            if (objRequestor.company_code == "CH84") {
              elementDisplay(`#divProjectName_${id_num}`, false, "div");
              // CH84: Hide Hotel Name for all categories
              elementDisplay(`#hotel${id_num}`, false, "div");
              mandatoryInput(`#ddlHotel${id_num}`, false, "select");
              elementDisplay(`#othHotel${id_num}`, false, "div");
              mandatoryInput(`#txtHotel${id_num}`, false, "text");
            }

            if (
              objRequestor.company_code == "AU84" ||
              objRequestor.company_code == "AU85" ||
              objRequestor.company_code == "NZ91" ||
              objRequestor.isWbsElement == "1" ||
              objRequestor.isWbsElement == "true" ||
              objRequestor.isWbsElement == true
            ) {
              if (
                !document
                  .querySelector<HTMLElement>(`#divProjectCode_${id_num}`)
                  ?.classList?.contains("d-none")
              ) {
                elementDisplay(`#divProjectName_${id_num}`, false, "div");
              }
            }

            //  Enable internal code for selected Category
            if (
              objAttachment.subcategory_id &&
              objAttachment.subcategory_id.toString() !==
                currentOnChangeInput.toString()
            ) {
              showInternalCode(
                parseInt(id_num),
                inputValues,
                handleInputChange,
                objAttachment.subcategory_id.toString(),
                objRequestor,
                objAttachment
              );
            }

            //Cost Center code hidden when service order is visible
            if (
              !document
                .querySelector<HTMLElement>(`#div_ServiceOrder${id_num}`)
                ?.classList?.contains("d-none")
            ) {
              //$('#divCostCenter' + id_num).hide();
            }

            if (currentOnChangeInput.toString() == "47") {
              disableInput(`#txtClaimAmount${id_num}`, true, "text");
            }

            if (
              currentOnChangeInput.toString() == "46" ||
              currentOnChangeInput.toString() == "47"
            ) {
              elementDisplay(`#divCostCenter${id_num}`, false, "div");
            }
          }
        );
      } else {
        loadSub(
          `ddlCategory${id_n}`,
          inputValues,
          handleInputChange,
          objRequestor,
          objAttachment,
          currentOnChangeInput,
          (id_num: string) => {
            //console.log(objRequestor);
            setPaymentType2_visibility(
              currentOnChangeInput.toString(),
              objAttachment.transport_type,
              parseInt(id_num),
              inputValues,
              handleInputChange,
              parseInt(id_num),
              objRequestor,
              objAttachment,
              null,
              handleBindDDL,
              bindDDL
            );

            //AnP
            if (
              isExceedraEnabledCompany(objRequestor) &&
              (currentOnChangeInput.toString() == "17" ||
                currentOnChangeInput.toString() == "45")
            ) {
              enableRecoverable(
                false,
                parseInt(id_num),
                inputValues,
                handleInputChange,
                currentOnChangeInput,
                objAttachment,
                objRequestor
              );
            } else {
              elementDisplay(`#divCostCenter${id_num}`, true, "div");
              elementDisplay(`#divProjectCode_${id_num}`, true, "div");
              enableRecoverable(
                true,
                parseInt(id_num),
                inputValues,
                handleInputChange,
                currentOnChangeInput,
                objAttachment,
                objRequestor
              );
            }

            //Tech Allowance
            if (currentOnChangeInput.toString() == '49') {
                elementDisplay(`#disclaimerTechAllowance`, true, "div");
            }
            else{
                elementDisplay(`#disclaimerTechAllowance`, false, "div");
            }

            //Per Diem Control

            //Control Checking for country who can access per diem calculation function
            let temprequestor = objRequestor;
            let objClaimUserInfo = getObjectClaimUserInfo();
            let final_control_checking_user = null;

            if (!isNullOrEmpty(objClaimUserInfo)) {
              final_control_checking_user = objClaimUserInfo;
            } else if (!isNullOrEmpty(temprequestor)) {
              final_control_checking_user = temprequestor;
            } else {
            }

            let country_per_diem_control =
              appConfig.PerDiemControlCountry.split(",");

            if (objAttachment && objAttachment.iS_CC != "1") {
              if (
                country_per_diem_control.includes(
                  final_control_checking_user.country_code
                )
              ) {
                if (
                  currentOnChangeInput.toString() == "16" &&
                  final_control_checking_user.country_code != "CN"
                ) {
                  disableInput(`#txtClaimAmount${id_num}`, true, "text");
                } else if (
                  currentOnChangeInput.toString() == "42" &&
                  final_control_checking_user.country_code == "CA"
                ) {
                  //Canada Meal Allowance
                  disableInput(`#txtClaimAmount${id_num}`, true, "text");
                } else {
                  disableInput(`#txtClaimAmount${id_num}`, false, "text"); 
                }
              }
            }

            //Chinea per diem special message shown
            if (
              final_control_checking_user.country_code == "CN" &&
              currentOnChangeInput.toString() == "16"
            ) {
              elementDisplay(`#divchinaperdieminfo${id_num}`, true, "div");
            } else {
              elementDisplay(`#divchinaperdieminfo${id_num}`, false, "div");
            }

            //Myammar per diem special message shown
            //Myammar disabled currency code
            if (
              final_control_checking_user.country_code == "MM" &&
              currentOnChangeInput.toString() == "16"
            ) {
              if (
                final_control_checking_user.company_code == "MM80" ||
                final_control_checking_user.company_code == "MM83"
              ) {
                elementDisplay(`#divMMperdieminfo${id_num}`, true, "div");
              } else if (final_control_checking_user.company_code == "MM82") {
                elementDisplay(`#divMMperdieminfo2${id_num}`, true, "div");
              }

              disableInput(`#ddlcurrency${id_num}`, true, "text");
            } else {
              elementDisplay(`#divMMperdieminfo${id_num}`, false, "div");
              elementDisplay(`#divMMperdieminfo2${id_num}`, false, "div");
              disableInput(`#ddlcurrency${id_num}`, false, "text");
            }

            //Per diem claim - invoice/receipt date will hidden from user (global changes)
            if (
              currentOnChangeInput.toString() == "16" ||
              currentOnChangeInput.toString() == "41" ||
              currentOnChangeInput.toString() == "42" ||
              currentOnChangeInput.toString() == "51"
            ) {
              //Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic.

              elementDisplay(`#div_invoice_date${id_num}`, false, "div");
              handleInputChange(`isDateRange`, 1);
              handleInputChange(`txtDate${id_num}`, "");
              handleInputChange(`txtStartDate${id_num}`, "");
              handleInputChange(`txtEndDate${id_num}`, "");
              handleInputChange(`txtDateRange${id_num}`, "");
            } else {
              elementDisplay(`#div_invoice_date${id_num}`, true, "div");
            }

            if (
              currentOnChangeInput.toString() == "16" ||
              currentOnChangeInput.toString() == "51"
            ) {
              //Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic.
              handleInputChange(`hidtxtTaxable_amt_TH${id_num}_${id_num}`, 0);
            }

            // Load & display fields for India Customization.
            load_IN_CustomFields(
                id_n,
                handleInputChange, 
                objAttachment
            );

            if (objRequestor.country_code != "MM") {
              elementDisplay(`#APCevent_percent${id_num}`, false, "div");
              elementDisplay(`#APCevent_button${id_num}`, false, "div");
              elementDisplay(`#lblAPCeventIDpercentage${id_num}`, false, "div");
            }

            //End of per diem Control

            //Other Employee Benefits for OT Meal
            let tempcountrychk = appConfig.OTMealsCountry.split(",");
            if (
              tempcountrychk.includes(objRequestor.country_code) &&
              currentOnChangeInput.toString() == "3" &&
              objRequestor.country_code != ""
            ) {
              elementDisplay(`#divOTMealInfo${id_num}`, true, "div");
            } else {
              elementDisplay(`#divOTMealInfo${id_num}`, false, "div");
            }
            if (
              objRequestor.country_code == "DE" ||
              objRequestor.country_code == "PL" || //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
              objRequestor.company_code == "CH87" ||
              objRequestor.country_code == "VN"
            ) {
              enableTaxDetailsForDE(
                id_n, 
                currentOnChangeInput.toString(),
                inputValues,
                handleInputChange, 
                objRequestor, 
                objAttachment, 
                bindDDL!,
                handleBindDDL!,
                // Hazel Amendments 20251218 - Fixes for value retreival missing for DE Tax details
                1 // Important to render and bind the Invoice / receipt amount value , (Normal VAT  , Reduced VAT , VAT Exempted)  's base amount field value
              );
            } else {
              // Begin,Saber,20261007,INC-1030470 - same stale ddlCategory snapshot as the
              // category-changed branch. Credit-card lines with a null saved category take this
              // branch, so tax must be loaded against the category the user just picked.
              const categoryTaxInputs = { ...inputValues, [`ddlCategory${id_n}`]: currentOnChangeInput };
              setDefaultTax(id_n!, categoryTaxInputs, handleInputChange, window.location, objAttachment, objRequestor);
              loadTaxCol(id_n!, categoryTaxInputs, handleInputChange, window.location, objAttachment, objRequestor, inputValues[`isDateRange`] == "1" ? inputValues[`txtStartDate${id_n}`] : inputValues[`txtDate${id_n}`],handleBindDDL, bindDDL);
              checkAndAutoCalTax(id_n!, categoryTaxInputs, handleInputChange, objRequestor, objAttachment);
              // End,Saber,20261007,INC-1030470
            }

            resetAPevent(id_num);
            resetProjectCode(id_num);

            if (
              objRequestor.country_code == "DE" ||
              objRequestor.country_code == "PL" || //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
              objRequestor.company_code == "CH87" ||
              objRequestor.country_code == "VN"
            ) {
            } else {
              
              checkAndBind(
                    parseInt(id_num!),
                    inputValues,
                    handleInputChange,
                    objRequestor,
                    objAttachment,
                    inputValues[`form_mode`],
                    handleBindDDL,
                    bindDDL
                );
            }

            //}

            //CheckAndAllowZeroAttachment
            //Only work for credit card item since all item is already populated
            checkAndAllowZeroAttach(
              id_n!,
              inputValues,
              handleInputChange,
              currentOnChangeInput
            );
            checkAndDisablePersonalExpense(id_n, inputValues, objAttachment);

            //console.log("cashadvanced here");
            if (
              currentOnChangeInput.toString() == "46" ||
              currentOnChangeInput.toString() == "47"
            ) {
              //console.log("cashadvanced");
              elementDisplay(`#divCostCenter${id_num}`, false, "div");
            }

            //Thailand Tax feature
            if (objRequestor.country_code == "TH") {
              enable_Disable_VAT_WHT_OnLoad(
                    id_n, 
                    inputValues,
                    handleInputChange, 
                    objAttachment, 
              );
              loadInvoice_Number(
                    id_n, 
                    inputValues,
                    handleInputChange, 
                    objAttachment
              );
              elementDisplay(`#divProjectName_${id_num}`, false, "div");
            }

             if (objRequestor.country_code == "KH") {
              loadInvoice_Number(
                    id_n, 
                    inputValues,
                    handleInputChange, 
                    objAttachment
              );
              elementDisplay(`#divProjectName_${id_num}`, false, "div");
            }

            // Begin, Saber, 20260514, SR-959286, CHN-20860, Load invoice number for MY (except MY98)
            if (objRequestor.country_code == "MY" || (window.location.pathname.includes("ExpReport") && objAttachment?.country == "MY")) {
              loadInvoice_Number(
                    id_n, 
                    inputValues,
                    handleInputChange, 
                    objAttachment,
                    window.location.pathname.includes("ExpReport")
              );
            }
            // End, Saber, 20260514, SR-959286, CHN-20860

            // Begin, Saber, 20260519, CHN-21547, Load invoice number for BN
            if (objRequestor.country_code == "BN" || (window.location.pathname.includes("ExpReport") && objAttachment?.country == "BN")) {
              loadInvoice_Number(
                    id_n, 
                    inputValues,
                    handleInputChange, 
                    objAttachment,
                    window.location.pathname.includes("ExpReport")
              );
            }
            // End, Saber, 20260519, CHN-21547, Load invoice number for BN

            if (objRequestor.country_code == "CN" || (window.location.pathname.includes("ExpReport") && objAttachment?.country == "CN")) {
                loadInvoice_Number(
                            id_n,
                            inputValues,
                            handleInputChange,
                            objAttachment,
                            window.location.pathname.includes("ExpReport")
                );
            }

            if (
              objRequestor.company_code == "AU84" ||
              objRequestor.company_code == "AU85" ||
              objRequestor.company_code == "NZ91" ||
              objRequestor.isWbsElement == "1" ||
              objRequestor.isWbsElement == "true" ||
              objRequestor.isWbsElement == true
            ) {
              if (
                !document
                  .querySelector<HTMLElement>(`#divProjectCode_${id_num}`)
                  ?.classList.contains("d-none")
              ) {
                elementDisplay(`#divProjectName_${id_num}`, false, "div");
              }
            }

            //  Enable internal code for selected Category
            if (
              objAttachment.subcategory_id &&
              objAttachment.subcategory_id.toString() !==
                currentOnChangeInput.toString()
            ) {
              showInternalCode(
                parseInt(id_num),
                inputValues,
                handleInputChange,
                objAttachment.subcategory_id.toString(),
                objRequestor,
                objAttachment
              );
            }

            if (
              objRequestor.country_code == "TH" &&
              document.querySelector<HTMLInputElement>(
                `#txtClaimAmount${id_num}`
              )?.disabled == false &&
              objAttachment.iS_CC == "1"
            ) {
              disableInput(`#txtClaimAmount${id_num}`, true, "text");
            }

            if (currentOnChangeInput.toString() == "47") {
              disableInput(`#txtClaimAmount${id_num}`, true, "text");
            }

            //Form Simplication START
            let formsimplification_companylist = localStorage.getItem(
              "Form_Simplification_Company"
            )
              ? localStorage.getItem("Form_Simplification_Company")?.split(",")
              : [];
            let isCompanyExists = false;
            if (
              formsimplification_companylist &&
              formsimplification_companylist.length > 0
            ) {
              for (let i = 0; i < formsimplification_companylist.length; i++) {
                let company_code = formsimplification_companylist[i];

                if (company_code == objRequestor.company_code) {
                  isCompanyExists = true;
                  break;
                }
              }
            }

            if (isCompanyExists) {
                // Hazel Amendments 20260716 Form simplification for CH84, Hide Form Name for IT COnsumable 
                if (currentOnChangeInput.toString() == "35"  && objRequestor.company_code == "CH84" ) {
                  elementDisplay(`#divForm_${id_num}`, false, "div");
                }
                
              if (currentOnChangeInput.toString() == "1") {
                if (
                  objRequestor.company_code != "JP80" &&
                  objRequestor.company_code != "JP86" &&
                  objRequestor.company_code.substring(0, 2) != "TH"
                ) {
                  elementDisplay(`#divForm_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divForm_${id_num}`, true, "div");
                }

                if (
                  objRequestor.company_code != "JP80" &&
                  objRequestor.company_code != "JP86" &&
                  objRequestor.company_code.substring(0, 2) != "TH"
                ) {
                  elementDisplay(`#divProjectName_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divProjectName_${id_num}`, true, "div");
                }
              }

              if (
                currentOnChangeInput.toString() == "2" ||
                currentOnChangeInput.toString() == "5"
              ) {
                if (
                  objRequestor.company_code != "JP80" &&
                  objRequestor.company_code != "JP86"
                ) {
                  elementDisplay(`#divForm_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divForm_${id_num}`, true, "div");
                }

                if (
                  objRequestor.company_code != "JP80" &&
                  objRequestor.company_code != "JP86" &&
                  objRequestor.company_code.substring(0, 2) != "TH"
                ) {
                  elementDisplay(`#divProjectName_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divProjectName_${id_num}`, true, "div");
                }
              }

              if (
                currentOnChangeInput.toString() == "15" ||
                currentOnChangeInput.toString() == "17" ||
                currentOnChangeInput.toString() == "22" ||
                currentOnChangeInput.toString() == "23" ||
                currentOnChangeInput.toString() == "24" ||
                currentOnChangeInput.toString() == "25" ||
                currentOnChangeInput.toString() == "26" ||
                currentOnChangeInput.toString() == "28" ||
                currentOnChangeInput.toString() == "29" ||
                currentOnChangeInput.toString() == "32" ||
                currentOnChangeInput.toString() == "45"
              ) {
                if (objRequestor.company_code.substring(0, 2) != "TH") {
                  elementDisplay(`#divForm_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divForm_${id_num}`, true, "div");
                }

                if (objRequestor.company_code.substring(0, 2) != "TH") {
                  elementDisplay(`#divProjectName_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divProjectName_${id_num}`, true, "div");
                }
              }

              if (
                currentOnChangeInput.toString() == "16" ||
                currentOnChangeInput.toString() == "51"
              ) {
                //Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic.
                elementDisplay(`#divForm_${id_num}`, false, "div");

                if (objRequestor.company_code.substring(0, 2) != "TH") {
                  elementDisplay(`#divProjectName_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divProjectName_${id_num}`, true, "div");
                }
              }

              if (currentOnChangeInput.toString() == "21") {
                if (
                  objRequestor.company_code.substring(0, 2) != "TH" ||
                  objRequestor.company_code != "FR80" ||
                  objRequestor.company_code != "ES80"
                ) {
                  elementDisplay(`#divForm_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divForm_${id_num}`, true, "div");
                }

                if (
                  objRequestor.company_code.substring(0, 2) != "TH" ||
                  objRequestor.company_code != "FR80" ||
                  objRequestor.company_code != "ES80"
                ) {
                  elementDisplay(`#divProjectName_${id_num}`, false, "div");
                } else {
                  elementDisplay(`#divProjectName_${id_num}`, true, "div");
                }
              }
            }

            //Form Simplication END

            // CH84: Hide Project Name for all categories
            if (objRequestor.company_code == "CH84") {
              elementDisplay(`#divProjectName_${id_num}`, false, "div");
              // CH84: Hide Hotel Name for all categories
              elementDisplay(`#hotel${id_num}`, false, "div");
              mandatoryInput(`#ddlHotel${id_num}`, false, "select");
              elementDisplay(`#othHotel${id_num}`, false, "div");
              mandatoryInput(`#txtHotel${id_num}`, false, "text");
            }

            if (objAttachment && objAttachment.iS_CC == "1") {
              disableInput(`#ddlCurrency${id_num}`, true, "text");
              elementDisplay(`#ExchangeRate${id_num}`, false, "div");
              elementDisplay(`#ExchangeAmount${id_num}`, false, "div");
            }
          }
        );
      }

      const Invoice_receipt_date = document.querySelector<HTMLLabelElement>(
        '[data-tag="Invoice_receipt_date"]'
      );
      const Invoice_receipt_amount = document.querySelector<HTMLLabelElement>(
        '[data-tag="Invoice_receipt_amount"]'
      );
      if (currentOnChangeInput.toString() == "46") {
        if (objRequestor.country_code == "MM") {
          handleInputChange("isDateRange", 0);
        }
        if (Invoice_receipt_date) {
          Invoice_receipt_date.textContent = translate("Advance Request Date");
        }
        if (Invoice_receipt_amount) {
          Invoice_receipt_amount.textContent = translate(
            "Advance Request Amount"
          );
        }
      } else {
        if (Invoice_receipt_date) {
          Invoice_receipt_date.textContent = translate(
            "Invoice / receipt date"
          );
        }
        if (Invoice_receipt_amount) {
          Invoice_receipt_amount.textContent = translate(
            "Invoice / receipt amount"
          );
        }
      }

      const companiesNoRecoverable = appConfig.NoRecoverableCompany.split(",");
      const countriesNoRecoverable = appConfig.NoRecoverableCountry.split(",");

      for (let a = 0; a < companiesNoRecoverable.length; a++) {
        let company_code = companiesNoRecoverable[a];

        if (company_code == objRequestor.company_code) {
          elementDisplay(`divRecoverable${id_n}`, false, "div");
          break;
        }
      }

      for (let a = 0; a < countriesNoRecoverable.length; a++) {
        let country_code = countriesNoRecoverable[a];

        if (country_code == objRequestor.country_code) {
          elementDisplay(`divRecoverable${id_n}`, false, "div");
          break;
        }
      }
    }
   
}


export function loadSub (
    id: string, 
    inputValues: { [key: string]: any | undefined }, 
    handleInputChange: (id: string, value?: any) => Promise<void>,
    objRequestor:any,
    objAttachment:any,
    categoryId:any,
    callback: (id_num: string) => void)
{
    // Simulate some logic here
    let cat_id_n = id.slice(-1) == "0" ? 10 : id.slice(-1);
    //Hide Expand Addition
    if(isNullOrEmpty(categoryId)){
        elementDisplay(`#AddSub${cat_id_n}`, false, "div");
        elementDisplay(`#clAdd${cat_id_n}`, false, "div");
        elementDisplay(`#clRmk${cat_id_n}`, false, "div");
        elementDisplay(`#angleDown${cat_id_n}`, false, "div");
    }

    elementDisplay(`#divHiddenSubCategory${cat_id_n}`, false, "div");
    //Corporate Credit card
    if (objAttachment && objAttachment.iS_CC == "1") {
        disableInput(`#txtClaimAmount${cat_id_n}`, true, "text");
    } else {
        disableInput(`#txtClaimAmount${cat_id_n}`, false, "text");
    }

    //TH
    hideShowTaxableFields(
        parseInt(cat_id_n.toString()), 
        inputValues,
        handleInputChange, 
        objRequestor, 
        appConfig.HideShowTaxableFieldsCountry,
        inputValues[`form_mode`]
    );

    employeeChildrenEducationFee(
        parseInt(cat_id_n.toString()), 
        handleInputChange, 
        objRequestor, 
        objRequestor.country_code,
        categoryId
    )


    // Hide form field for MedCompli Category 
    if (categoryId && categoryId.toString() == "60") {   
       elementDisplay(`#divForm_${cat_id_n}`, false, "div");
    }

    //Form Simplication START
    let formsimplification_companylist = localStorage.getItem('Form_Simplification_Company') ? localStorage.getItem('Form_Simplification_Company')?.split(',') : [""];
    let isCompanyExists = false;
    if(formsimplification_companylist && formsimplification_companylist?.length > 0){
        for (let a = 0; a < formsimplification_companylist?.length; a++) {

            let company_code = formsimplification_companylist[a];

            if (company_code == objRequestor.company_code) {

                isCompanyExists = true;
                break;
            }
        }
    }

    if (categoryId && (categoryId.toString() == "28" && objRequestor.country_code == "MY")) {
        mandatoryInput(`#txtRemarks${cat_id_n}`, true , "text");
    }
    mandatoryInput(`#txtRemarks${cat_id_n}`, true , "text");

    // Saber Amendment 20260818 [#SR-1022951]: Align legacy base behavior for Form required in category 46 (PH/KH/LA).
    if (categoryId && categoryId.toString() == '46' && (objRequestor.country_code == "PH" || objRequestor.country_code == "KH" || objRequestor.country_code == "LA")) {
        mandatoryInput(`#ddlForm${cat_id_n}`, true, "select");
    } else {
        mandatoryInput(`#ddlForm${cat_id_n}`, false, "select");
    }

    callback(cat_id_n.toString());
    
    // if (isCompanyExists) {
    //     if (((categoryId.toString() == "2" || categoryId.toString()== "15") && (objRequestor.company_code == "ES80" || objRequestor.company_code == "FR80" || objRequestor.company_code.substring(0, 2) == 'MM'))) {
    //         $('#txtRemarks' + cat_id_n).prop('required', true);
    //     } else if (((categoryId.toString() == "17" || categoryId.toString() == "29") && (objRequestor.company_code.substring(0, 2) == 'MM'))) {
    //         $('#txtRemarks' + cat_id_n).prop('required', true);
    //     } else if (((categoryId.toString() == "21") && (objRequestor.company_code.substring(0, 2) == 'MM' || objRequestor.company_code.substring(0, 2) == 'JP'))) {
    //         $('#txtRemarks' + cat_id_n).prop('required', true);
    //     } else if (((categoryId.toString() == "22") && (objRequestor.company_code == "MY98" || objRequestor.company_code == "JP80" || objRequestor.company_code == "JP86"))) {
    //         $('#txtRemarks' + cat_id_n).prop('required', true);
    //     } else if (((categoryId.toString() == "5" || categoryId.toString() == "25" || categoryId.toString() == "4") && (objRequestor.company_code.substring(0, 2) == 'MM' || objRequestor.company_code == "FR80" || objRequestor.company_code == "ES80"))) {
    //         $('#txtRemarks' + cat_id_n).prop('required', true);
    //     } else if (((categoryId.toString() == "26" || categoryId.toString() == "28") && (objRequestor.company_code == "FR80" || objRequestor.company_code == "ES80"))) {
    //         $('#txtRemarks' + cat_id_n).prop('required', true);
    //     } else if (((categoryId.toString() == "30" || categoryId.toString() == "1" || categoryId.toString() == "3" || categoryId.toString() == "6") && (objRequestor.company_code.substring(0, 2) == 'MM' || objRequestor.company_code == "ES80"))) {
    //         $('#txtRemarks' + cat_id_n).prop('required', true);
    //     } else {
    //         isCompanyExists = false;
    //     }
    // }

    // if (objRequestor.company_code == 'CH84') {
    //     if (categoryId.toString() == "1" || categoryId.toString() == "2" || categoryId.toString() == "3" || categoryId.toString() == "4" || categoryId.toString() == "5" || categoryId.toString() == "15" || categoryId.toString() == "16" || categoryId.toString() == "25" || categoryId.toString() == "26" || categoryId.toString() == "28" || categoryId.toString() == "29" || categoryId.toString() == "30" || categoryId.toString() == "35" || categoryId.toString() == "45") {
    //         $('#txtRemarks' + cat_id_n).prop('required', true);
    //     }
    // }
    // if (objRequestor.company_code == 'CH80' || objRequestor.company_code == 'CH81' || objRequestor.company_code == 'CH82' || objRequestor.company_code == 'CH87' || objRequestor.company_code == 'CH9B'
    //     || objRequestor.company_code == 'MY98' || objRequestor.company_code == 'MM80' || objRequestor.company_code == 'MM82' || objRequestor.company_code == 'MM83' || objRequestor.company_code == 'ES80') {
    //     if (categoryId.toString() == "2" || categoryId.toString() == "6") {
    //         $('#txtRemarks' + cat_id_n).prop('required', true);
    //         isCompanyExists = true;
    //     }
    // }
    //Form Simplication END
    // Add asterisk to Remarks if the subcatergory is Tech Allowance
    // if ((categoryId.toString() == '49' && objRequestor.country_code == "MY") || isCompanyExists) {
    //     if (document.getElementById("Remark_asterisk")) {
    //         document.getElementById("Remark_asterisk").remove();
    //     }
    //     document.querySelector('[data-tag="Description_and_business_reason"]').insertAdjacentHTML('beforeend', '<span id="Remark_asterisk" style="color:red;">*</span>');
    // } else if (categoryId.toString() == "28" && objRequestor.country_code == "MY") {
    //     document.querySelector('[data-tag="Description_and_business_reason"]').insertAdjacentHTML('beforeend', '<span id="Remark_asterisk" style="color:red;"> - Please provide explanation on the type of expense and purpose. &nbsp;*</span>');
    // }
    // else if (document.querySelector('[data-tag="Description_and_business_reason"]') && document.querySelector('[data-tag="Description_and_business_reason"]').children.length > 0) {
    //     if (document.querySelector('[data-tag="Description_and_business_reason"]').children[0].contains(document.getElementById('Remark_asterisk'))) {
    //         document.querySelector('[data-tag="Description_and_business_reason"]').removeChild(document.getElementById('Remark_asterisk'));
    //     }
    //     const element = document.getElementById('Remark_required');
    //     if (element != undefined) {
    //         element.parentNode.removeChild(element);
    //     }
    // }
    // else if (document.querySelector('[data-tag="Claim_description"]') && document.querySelector('[data-tag="Claim_description"]').children.length > 0) {
    //     if (document.querySelector('[data-tag="Claim_description"]').children[0].contains(document.getElementById('Remark_asterisk'))) {
    //         document.querySelector('[data-tag="Claim_description"]').removeChild(document.getElementById('Remark_asterisk'));
    //     }
    //     const element = document.getElementById('Remark_required');
    //     if (element != undefined) {
    //         element.parentNode.removeChild(element);
    //     }
    // }

    // if (categoryId.toString() == '46' && (objRequestor.country_code == "PH" || objRequestor.country_code == "KH" || objRequestor.country_code == "LA")) {
    //     if (document.getElementById("Form_asterisk")) {
    //         document.getElementById("Form_asterisk").remove();
    //     }
    //     $('#lblFormName').append(' <span id="Form_asterisk" style="color:red;">*</span>');
    //     $('#ddlForm1').prop('required', true);
    // } else {
    //     if (document.getElementById("Form_asterisk")) {
    //         document.getElementById("Form_asterisk").remove();
    //     }
    //     $('#ddlForm1').prop('required', false);
    // }

    //Remove of detail type division to reset
    //This code will only used if any code is appended on top bar of division
    // $('#detailtype' + cat_id_n).remove();
    // $('#IdofDeceasedPerson' + cat_id_n).remove();
    // $(objSubCategory).each(function (id_n, d) {
    //     //Corporate Credit card
    //     if (objAttachment.iS_CC == "1") {
    //         $("#txtClaimAmount" + cat_id_n).prop("disabled", true); // Prevent user to edit claim amount
    //         $("#txtClaimAmount" + cat_id_n).addClass("show-border"); //Add border
    //     } else {
    //         $("#txtClaimAmount" + cat_id_n).prop("disabled", false); // Default setting - user can edit
    //         $("#txtClaimAmount" + cat_id_n).removeClass("show-border"); //Removeborder
    //     }

    //     let recipientTemplateLink = "@ConfigurationManager.AppSettings("RecipientTemplate")";
    //     let cashAdvanceConsentFormTemplateLink = "@ConfigurationManager.AppSettings("CashAdvanceConsentForm")";
    //     GetInputSyntax(d.input_id, cat_id_n, d.id, recipientTemplateLink, cashAdvanceConsentFormTemplateLink, function (syntax, syntaxSubCategory) {
    //         //Expand Addition
    //         if (d.input_id == null || d.input_id == '') {
    //             $('#AddSub' + cat_id_n).css('display', 'none');
    //             $('#clAdd' + cat_id_n).removeClass("show");
    //             $('#clRmk' + cat_id_n).addClass("show");
    //         }
    //         //Add disputed transaction (personal expense) check box for old record only
    //         //Old record which had been submitted will only see this expansion column
    //         else if (d.input_id == '77') {
    //             let tempobjattachment = JSON.parse(localStorage.getItem("objAttachment"))
    //             if (tempobjAttachment.iS_CC == 1
    //                 //&& tempobjAttachment.personal_expense != null && tempobjAttachment.personal_expense != "" && tempobjAttachment.personal_expense != undefined
    //             ) {
    //                 $('#AddSub' + cat_id_n).css('cssText', 'display: block !important');
    //                 $('#clAdd' + cat_id_n).addClass("show");
    //                 $('#clRmk' + cat_id_n).removeClass("show");
    //                 let sub_syntax = '<div class="mb-3">' + syntax + '</div>'
    //                 $('#dvd' + cat_id_n).append(sub_syntax);

    //                 if (syntaxSubCategory.length > 0) {
    //                     $('#divHiddenSubCategory' + cat_id_n).css('cssText', 'display: block !important');
    //                     $('#divHiddenSubCategory' + cat_id_n).append(syntaxSubCategory);

    //                 }

    //                 //Expand remarks section when status is pending
    //                 if (typeof currentStatus2 === 'undefined') { }
    //                 else {
    //                     if (currentStatus2 == "3") {

    //                         $('#clRmk' + cat_id_n).addClass("show");
    //                     }
    //                 }
    //             }
    //         }
    //         //Current medical expenses does not show any extra information
    //         else if (d.input_id == '83') {
    //             $('#AddSub' + cat_id_n).css('display', 'none');
    //             $('#clAdd' + cat_id_n).removeClass("show");
    //             let sub_syntax = '<div class="mb-3">' + syntax + '</div>'
    //             $('#dvd' + cat_id_n).append(sub_syntax);

    //             if (syntaxSubCategory.length > 0) {
    //                 $('#divHiddenSubCategory' + cat_id_n).css('cssText', 'display: block !important');
    //                 $('#divHiddenSubCategory' + cat_id_n).append(syntaxSubCategory);

    //             }

    //             //Expand remarks section when status is pending
    //             if (typeof currentStatus2 === 'undefined') { }
    //             else {
    //                 if (currentStatus2 == "3") {

    //                     $('#clRmk' + cat_id_n).addClass("show");
    //                 }
    //             }
    //         }
    //         else {
    //                 $('#AddSub' + cat_id_n).css('cssText', 'display: block !important');
    //                 $('#clAdd' + cat_id_n).addClass("show");
    //                 $('#clRmk' + cat_id_n).removeClass("show");
    //                 let sub_syntax = '<div class="mb-3">' + syntax + '</div>'
    //                 $('#dvd' + cat_id_n).append(sub_syntax);

    //             if (syntaxSubCategory.length > 0) {
    //                 $('#divHiddenSubCategory' + cat_id_n).css('cssText', 'display: block !important');
    //                 $('#divHiddenSubCategory' + cat_id_n).append(syntaxSubCategory);
    //                 AddTHTaxFields(cat_id_n, objRequestor, "@ConfigurationManager.AppSettings("THonly")");

    //             }

    //                 //Expand remarks section when status is pending
    //                 if (typeof currentStatus2 === 'undefined') { }
    //                 else {
    //                     if (currentStatus2 == "3") {

    //                         $('#clRmk' + cat_id_n).addClass("show");
    //                     }
    //             }

    //         }

    //         })
    //     //}
    //     BindInputSysntax(d.input_id, cat_id_n, objAttachment, "@ConfigurationManager.AppSettings("FlexiClaimCSSC")"
    //         , 0, "@ConfigurationManager.AppSettings("InternalOrderEvent")");

    //     if (d.input_id == 75) {
    //         $('#ddlNonDKSHInvolve' + cat_id_n).trigger("change");
    //         $('#chkExceedraNoCode' + cat_id_n).trigger("change");
    //     }
    // })

    // $('#ddlDKSHInvolve' + cat_id_n).trigger("change");
    // $('#ddlNonDKSHReceive' + cat_id_n).trigger("change");
    // $('#ddlNonDKSHInvolve' + cat_id_n).trigger("change");
    
};

export function  clearDetailFields(
    id_n: number | undefined,
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
    objRequestor:any
) {
    elementDisplay(`#recoverable${id_n}`, false, "div");

    if (!isNullOrEmpty(inputValues[`txtRecoverable${id_n}`])) {
       handleInputChange(`ddlRecoverable${id_n}`, "0"); 
    }
    handleInputChange(`txtCash${id_n}`, "1");
    handleInputChange(`ddlCreditCardStatement${id_n}`, "");
    subCatInputOnChange(inputValues, id_n, "ddlCreditCardStatement", handleInputChange, inputValues[`ddlCreditCardStatement${id_n}`]);

    for (let ccCounter = 2; ccCounter < 21; ccCounter++) {
        elementDisplay(`#cc${ccCounter}_${id_n}`, false, "div");

    }
    handleInputChange(`txtCreditCard${id_n}`, 1);
    handleInputChange(`txtCash${id_n}`, "cash");
    // handleInputChange(`txtDate${id_n}`, "");

    elementDisplay(`#cc_statement${id_n}`, false, "div");

    handleInputChange(`ddlCurrency${id_n}`, objRequestor.currency_code);
    handleInputChange(`txtExchangeRate${id_n}`, parseFloat("1.00").toFixed(5));
}


export function  bindCCInfo(
    id_n: number | undefined,
    value:string,
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
    objRequestor:any,
    objCreditCard:any
) {
    // let id_n = inputId.substr(-1) == "0" ? "10" : inputId.substr(-1);
    if (isNullOrEmpty(value)) {
        disableInput(`#ddlCurrency${id_n}`, false, "select");
        disableInput(`#txtClaimAmount${id_n}`, false, "text");
        disableInput(`#txtDate${id_n}`, false, "text");
        disableInput(`#txtExchangeRate${id_n}`, false, "text");
        disableInput(`#txtExchangeAmount${id_n}`, false, "text");

        handleInputChange(`ddlCurrency${id_n}`, objRequestor.currency_code);
        handleInputChange(`txtClaimAmount${id_n}`, "");
        handleInputChange(`txtExchangeRate${id_n}`, parseFloat("1.00").toFixed(5));
        handleInputChange(`txtExchangeAmount${id_n}`, "");
        handleInputChange(`txtRemarks${id_n}`, "");
        handleInputChange(`txtMerchantName${id_n}`, "");
    }
    else {
        disableInput(`#txtClaimAmount${id_n}`, true, "text"); 
        if(!isNullOrEmpty(objCreditCard)){
            for (let a = 0; a < objCreditCard.length; a++) {
                if (objCreditCard[a].id == value) {

                    handleInputChange(`txtDate${id_n}`, objCreditCard[a].txn_date);
                    disableInput(`#txtDate${id_n}`, true, "text");

                    handleInputChange(`ddlCurrency${id_n}`, objCreditCard[a].foreign_curr_symbol);
                    disableInput(`#ddlCurrency${id_n}`, true, "select");

                    handleInputChange(`txtClaimAmount${id_n}`, objCreditCard[a].foreign_curr_amt);
                    disableInput(`#txtClaimAmount${id_n}`, true, "text");

                    handleInputChange(`txtExchangeRate${id_n}`, parseFloat(objCreditCard[a].foreign_exc_rate).toFixed(5));
                    disableInput(`#txtExchangeRate${id_n}`, true, "text");

                    handleInputChange(`txtExchangeAmount${id_n}`, objCreditCard[a].act_claim_amt);
                    disableInput(`#txtExchangeAmount${id_n}`, true, "text");

                    handleInputChange(`txtMerchantName${id_n}`, objCreditCard[a].txn_desc);
                }
            }
        }

    }
}


export function isExceedraEnabledCompany(objRequestor:any) {

    let isExceedraEnabled = false;
    if (objRequestor && objRequestor.isExcreeda.toString() != "0") {
        isExceedraEnabled = true;
    }
    return isExceedraEnabled;
}

//Saber,2026-10-09 , legacy EnableRecoverable: in New mode default to Recoverable=Yes, Client, Special GL J with the employee's client vendor code
async function applyClientRecoverableDefault(numberOfPage: number,
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
    objRequestor: any) {
    //Legacy GetConfig drops emp_id for category 46 without form (except KH/PH/LA/ID), so no client vendor is returned
    if (isNullOrEmpty(inputValues[`ddlForm1`]) && inputValues[`ddlCategory1`] == "46" &&
        !["KH", "PH", "LA", "ID"].includes(objRequestor.country_code)) {
        return;
    }
    try {
        const result = await postApiAxios(appConfig.connectionString.ws + endPoint.Configuration, {
            "config_text": "ClientRecoverable",
            "country_code": objRequestor.country_code,
            "company_code": objRequestor.company_code,
            "emp_id": objRequestor.personnel_number
        });
        if (result && result.length > 0) {
            subCatInputOnChange(inputValues, numberOfPage, "ddlRecoverable", handleInputChange, "1");
            handleInputChange(`ddlRecoverable${numberOfPage}`, 1);
            handleInputChange(`txtRecoverable${numberOfPage}`, result[0].confiG_VALUE);
            handleInputChange(`txtRecoverable${numberOfPage}_text`, result[0].confiG_VALUE);
            handleInputChange(`ddlRecoverableSpecialGL${numberOfPage}`, "J");
        }
    } catch (error) {
        console.log(error);
    }
}

export function enableRecoverable(enable:boolean, numberOfPage:number, 
                                inputValues: { [key: string]: any | undefined }, 
                                handleInputChange: (id: string, value?: any) => Promise<void>,
                                categoryId:any,
                                objAttachment?:any,
                                objRequestor?:any) {

    let formsimplification_companylist = localStorage.getItem('Form_Simplification_Company') ? localStorage.getItem('Form_Simplification_Company')?.split(',') : [];
    if(formsimplification_companylist && formsimplification_companylist.length > 0){
        for (let i = 0; i < formsimplification_companylist.length; i++) {

                let company_code = formsimplification_companylist[i];

                if (company_code == objRequestor.company_code) {

                    if (objRequestor.company_code == 'CH84') {
                        enable = false;
                        break;
                    }
                }
            }
    }
   

    if (enable == true) {
        elementDisplay(`#divRecoverable${numberOfPage}`, true, "div");  

        //When user load claim page
        //Recoverable Control for Malaysia country only (Non-cssc)
        //If found out user is malaysia and ee subgroup id start with BL or C, their recoverable drop down list will default to yes
        if (!isNullOrEmpty(categoryId)) {
            if (objRequestor.country_code == 'MY' && objRequestor.company_code != "MY98" && objRequestor.company_code != "MY8B" && objRequestor.company_code != "MY90") {
                if (objRequestor.ee_subgroup_id == "BL" || objRequestor.ee_subgroup_id.startsWith("C")) {
                    subCatInputOnChange(inputValues, numberOfPage, "ddlRecoverable", handleInputChange, "1");
                    handleInputChange(`ddlRecoverable${numberOfPage}`, 1);
                    disableInput(`#ddlRecoverable${numberOfPage}`, true, "select");  
                } else {
                    //reset back
                    disableInput(`#ddlRecoverable${numberOfPage}`, false, "select");
                }
            } else {
                //reset back
                disableInput(`#ddlRecoverable${numberOfPage}`, false, "select");
            }
        } else {
            //reset back
            disableInput(`#ddlRecoverable${numberOfPage}`, false, "select");
        }

        if (inputValues[`form_mode`] && inputValues[`form_mode`].toString().toLowerCase() == 'new') {
            applyClientRecoverableDefault(numberOfPage, inputValues, handleInputChange, objRequestor);
        }

        if (inputValues[`ddlRecoverable${numberOfPage}`] == "1") {

            if (inputValues[`txtRecoverable${numberOfPage}`] == "Others") {
                elementDisplay(`#divRecoverableOthers${numberOfPage}`, true, "div");  
                mandatoryInput(`#ddlRecoverableOthers${numberOfPage}`, true, "select");  
            }

            if (inputValues[`radio_coverable1_${numberOfPage}`] == "1") {
                elementDisplay(`#divRecoverableSpecialGL_${numberOfPage}`, true, "div");  
                mandatoryInput(`#ddlRecoverableSpecialGL${numberOfPage}`, true, "select");  
                mandatoryInput(`#txtRecoverable${numberOfPage}`, true, "text");  

            } else if (inputValues[`radio_coverable2_${numberOfPage}`] == "1") {
                elementDisplay(`#divRecoverableInterComp${numberOfPage}`, true, "div");  
                mandatoryInput(`#txtInterCompRecoverable${numberOfPage}`, true, "select"); 
            }
            else{

            }

        }

        //to handle View mode which will disable to drop down recoverable being edited
        if (inputValues[`form_mode`] && inputValues[`form_mode`].toLowerCase() == 'view') {
            disableInput(`#ddlRecoverable${numberOfPage}`, true, "select");
            handleInputChange(`ddlRecoverable${numberOfPage}`, objAttachment.client_recoverable);
            
            //Hide attachment link on view mode.
            elementDisplay(`.DeleteLink`, false, "div");  
        }
        else if(inputValues[`form_mode`] && inputValues[`form_mode`].toLowerCase() == 'edit'){
            handleInputChange(`ddlRecoverable${numberOfPage}`, !isNullOrEmpty(objAttachment.client_recoverable) ? objAttachment.client_recoverable : inputValues[`ddlRecoverable${numberOfPage}`]);
            if (objRequestor.country_code == 'MY' && objRequestor.company_code != "MY98" && objRequestor.company_code != "MY8B" && objRequestor.company_code != "MY90") {
                if (objRequestor.ee_subgroup_id == "BL" || objRequestor.ee_subgroup_id.startsWith("C")) {
                    subCatInputOnChange(inputValues, numberOfPage, "ddlRecoverable", handleInputChange, "1");
                    handleInputChange(`ddlRecoverable${numberOfPage}`, 1);
                    disableInput(`#ddlRecoverable${numberOfPage}`, true, "select");  
                } else {
                    //reset back
                    disableInput(`#ddlRecoverable${numberOfPage}`, false, "select");
                }
            } else {
                //reset back
                disableInput(`#ddlRecoverable${numberOfPage}`, false, "select");
            }
        }
        else{}

        if (!isNullOrEmpty(objAttachment.recoverableSpecialGLCode)) {
            //Bind special GL code value
            handleInputChange(`ddlRecoverableSpecialGL${numberOfPage}`, objAttachment.recoverableSpecialGLCode);
        }

    }
    else {
        elementDisplay(`#divRecoverable${numberOfPage}`, false, "div");  
        elementDisplay(`#divRecoverableOthers${numberOfPage}`, false, "div");  
        elementDisplay(`#divRadioRecoverable${numberOfPage}`, false, "div");  

        elementDisplay(`#divRecoverableSpecialGL_${numberOfPage}`, false, "div");  
        handleInputChange(`ddlRecoverableSpecialGL${numberOfPage}`, "0");
        mandatoryInput(`#ddlRecoverableSpecialGL${numberOfPage}`, false, "select"); 

        mandatoryInput(`#txtRecoverable${numberOfPage}`, false, "text"); 

        handleInputChange(`ddlRecoverable${numberOfPage}`, "0");
        handleInputChange(`ddlRecoverableOthers${numberOfPage}`, "");

        mandatoryInput(`#ddlRecoverableOthers${numberOfPage}`, false, "select"); 

        elementDisplay(`#divRecoverableInterComp${numberOfPage}`, false, "div");  
        mandatoryInput(`#txtInterCompRecoverable${numberOfPage}`, false, "text"); 
        handleInputChange(`txtInterCompRecoverable${numberOfPage}`, "");
    }


    let companiesNoRecoverable = appConfig.NoRecoverableCompany.split(',');
    let countriesNoRecoverable = appConfig.NoRecoverableCountry.split(','); 

    for (let i = 0; i < companiesNoRecoverable.length; i++) {

        let company_code = companiesNoRecoverable[i];

        if (company_code == objRequestor.company_code) {
            elementDisplay(`[data-name="divRecoverable"]`, false, "div");  
            break;
        }
    }

    for (let i = 0; i < countriesNoRecoverable.length; i++) {

        let country_code = countriesNoRecoverable[i];

        if (country_code == objRequestor.country_code) {

            elementDisplay(`[data-name="divRecoverable"]`, false, "div");   
            break;
        }
    }

    //if (objRequestor.company_code == 'MY98') {

    //    $('[name=divRecoverable]').hide();
    //}

    if (categoryId == 48) {
        elementDisplay(`.DeleteLink`, true, "div");  
    }
}


export async function subCatInputOnChange(
    inputValues: { [key: string]: any | undefined },
    id_n: number | undefined,
    inputId: any,
    handleInputChange: (id: string, value?: any) => Promise<void>,
    currentOnChangeInput: any,
    bindDDL?: { [key: string]: any },
    handleBindDDL?:(id: string, value?: any) => void,
    objDDL?: any,
    addValue?:any,
    isLoadRestore?: boolean, //Begin/End,saber,20260827,INC-1028107
) {
    // useEffect(() => {
    const objectRequestorString = localStorage.getItem('objRequestor');
    const objectRequestor = !isNullOrEmpty(objectRequestorString) ? JSON.parse(objectRequestorString!) : null;
    const objAttachmentString = localStorage.getItem('objAttachment');
    const objAttachment = !isNullOrEmpty(objAttachmentString) ? JSON.parse(objAttachmentString!) : null;

    // const ddlLocalInvolve = document.querySelector<HTMLSelectElement>(`#ddlLocalInvolve${id_n}`);
    // const ddlNonLocalInvolve = document.querySelector<HTMLSelectElement>(`#ddlNonLocalInvolve${id_n}`);
    // const localInvolve = document.querySelector<HTMLElement>(`#LocalInvolve${id_n}`);
    // const nonLocalInvolve = document.querySelector<HTMLElement>(`#NonLocalInvolve${id_n}`);
    // const clsNonLocalInvolve = document.querySelector<HTMLElement>(`.NonLocalInvolve${id_n}`);
    // const txtPublicInvolve = document.querySelector<HTMLInputElement>(`#txtPublicInvolve${id_n}`);
    // const txtHealthcareInvolve = document.querySelector<HTMLInputElement>(`#txtHealthcareInvolve${id_n}`);
    // const txtNonDKSHInvolve = document.querySelector<HTMLInputElement>(`#txtNonDKSHInvolve${id_n}`);
    // const recipientType = document.querySelector<HTMLElement>(`.RecipientType${id_n}`);
    // const ddlAccommodationType = document.querySelector<HTMLSelectElement>(`#ddlAccommodationType${id_n}`);
    // const ddlAccommodationType_asterisk = document.querySelector<HTMLSelectElement>(`.ddlAccommodationType${id_n}_asterisk`);
    // const ddlTravelRefNo = document.querySelector<HTMLSelectElement>(`#ddlTravelRefNo${id_n}`);
    // const ddlTravelRefNo_asterisk = document.querySelector<HTMLSelectElement>(`.ddlTravelRefNo${id_n}_asterisk`);

    // const headCountPOHCPInvolve = document.querySelector<HTMLElement>(`.HeadCountPOHCPInvolve${id_n}`);
    // const amountProvidedToExternalRecipient = document.querySelector<HTMLElement>(`.AmountProvidedToExternalRecipient${id_n}`);
    // const businessRationaleProvideToExternal = document.querySelector<HTMLElement>(`.BusinessRationaleProvideToExternal${id_n}`);
    // const ddlRecipientType = document.querySelector<HTMLSelectElement>(`#ddlRecipientType${id_n}`);
    // const txtHeadCountPOHCPInvolve = document.querySelector<HTMLInputElement>(`#txtHeadCountPOHCPInvolve${id_n}`);
    // const txtAmountProvidedToExternalRecipient = document.querySelector<HTMLInputElement>(`#txtAmountProvidedToExternalRecipient${id_n}`);
    // const txtBusinessRationaleProvideToExternal = document.querySelector<HTMLInputElement>(`#txtBusinessRationaleProvideToExternal${id_n}`);
    const gift_recipient_download = document.querySelector<HTMLElement>(`#gift_recipient_download${id_n}`);

    const country = document.querySelector<HTMLElement>(`#country${id_n}`);
    const othCountry = document.querySelector<HTMLElement>(`#othCountry${id_n}`);
    const city = document.querySelector<HTMLElement>(`#city${id_n}`);
    const othCity = document.querySelector<HTMLElement>(`#othCity${id_n}`);
    const hotel = document.querySelector<HTMLElement>(`#hotel${id_n}`);
    const othHotel = document.querySelector<HTMLElement>(`#othHotel${id_n}`);
    const departureCountry = document.querySelector<HTMLElement>(`#DepartureCountry${id_n}`);
    const othDepartureCountry = document.querySelector<HTMLElement>(`#othDepartureCountry${id_n}`);
    const arrivalCountry = document.querySelector<HTMLElement>(`#arrivalCountry${id_n}`);
    const othArrivalCountry = document.querySelector<HTMLElement>(`#othArrivalCountry${id_n}`);
    const departureCity = document.querySelector<HTMLElement>(`#departureCity${id_n}`);
    const othDepartureCity = document.querySelector<HTMLElement>(`#othDepartureCity${id_n}`);
    const arrivalCity = document.querySelector<HTMLElement>(`#arrivalCity${id_n}`);
    const othArrivalCity = document.querySelector<HTMLElement>(`#othArrivalCity${id_n}`);

    const addDepartureCountry = document.querySelector<HTMLElement>(`#addDepartureCountry${id_n}`);
    const othAddDepartureCountry = document.querySelector<HTMLElement>(`#othAddDepartureCountry${id_n}`);
    const addArrivalCountry = document.querySelector<HTMLElement>(`#addArrivalCountry${id_n}`);
    const othAddArrivalCountry = document.querySelector<HTMLElement>(`#othAddArrivalCountry${id_n}`);

    const addDepartureCity = document.querySelector<HTMLElement>(`#addDepartureCity${id_n}`);
    const othAddDepartureCity = document.querySelector<HTMLElement>(`#othAddDepartureCity${id_n}`);
    const addArrivalCity = document.querySelector<HTMLElement>(`#addArrivalCity${id_n}`);
    const othAddArrivalCity = document.querySelector<HTMLElement>(`#othAddArrivalCity${id_n}`);


    const airline = document.querySelector<HTMLElement>(`#airline${id_n}`);
    const othAirline = document.querySelector<HTMLElement>(`#othAirline${id_n}`);
    const addAirline = document.querySelector<HTMLElement>(`#addAirline${id_n}`);
    const othAddAirline = document.querySelector<HTMLElement>(`#othAddAirline${id_n}`);
    let taxcompulsorychk = localStorage.getItem("TaxCompulsory");


    switch (inputId) {
        case "ddlCurrency":
            if(!isNullOrEmpty(currentOnChangeInput)){
                if ((currentOnChangeInput == 'THB' || inputValues[`ddlCategory${id_n}`] == 3 || inputValues[`ddlCategory${id_n}`]  == 1) && objectRequestor.country_code == 'TH') {
                    //enableVATnWHT_Section(i);
                    enable_Disable_VAT_WHT_OnLoad(
                        id_n,
                        { ...inputValues, [`ddlCurrency${id_n}`]: currentOnChangeInput },
                        handleInputChange,
                        objAttachment,
                    );
                    loadInvoice_Number(
                        id_n,
                        { ...inputValues, [`ddlCurrency${id_n}`]: currentOnChangeInput },
                        handleInputChange,
                        objAttachment
                    );
                } else {
                    disableVATnWHT_Section(
                        id_n, 
                        { ...inputValues, [`ddlCurrency${id_n}`]: currentOnChangeInput },
                        handleInputChange, 
                    )

                    elementDisplay(`.divTHB`, false, "div");
                    handleInputChange(`txtInvoiceNum${id_n}`, "");
                }

                
                // Re-check Load Invoice number if user is from KH 
                loadInvoice_Number(
                        id_n,
                        { ...inputValues, [`ddlCurrency${id_n}`]: currentOnChangeInput },
                        handleInputChange,
                        objAttachment
                );

                // Begin, Saber, 20260514, SR-959286, CHN-20860, Load invoice number for MY (except MY98)
                loadInvoice_Number(
                        id_n,
                        { ...inputValues, [`ddlCurrency${id_n}`]: currentOnChangeInput },
                        handleInputChange,
                        objAttachment,
                        window.location.pathname.includes("ExpReport")
                );
                // End, Saber, 20260514, SR-959286, CHN-20860

                // Begin, Saber, 20260519, CHN-21547, Load invoice number for BN
                loadInvoice_Number(
                        id_n,
                        { ...inputValues, [`ddlCurrency${id_n}`]: currentOnChangeInput },
                        handleInputChange,
                        objAttachment,
                        window.location.pathname.includes("ExpReport")
                );
                // End, Saber, 20260519, CHN-21547, Load invoice number for BN

                hideShowTaxableFields(
                    id_n, 
                    { ...inputValues, [`ddlCurrency${id_n}`]: currentOnChangeInput },
                    handleInputChange, 
                    objectRequestor, 
                    appConfig.HideShowTaxableFieldsCountry,
                    inputValues[`form_mode`]
                );
                employeeChildrenEducationFee(
                    id_n, 
                    handleInputChange, 
                    objectRequestor, 
                    objectRequestor.country_code,
                    inputValues[`ddlCategory${id_n}`]
                );
                //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
                if (objectRequestor.country_code != "DE" && objectRequestor.country_code != "PL" && objectRequestor.company_code != 'CH87' && objectRequestor.country_code != "VN") {
                    //Load tax column when currency is changed
                    loadTaxCol(id_n!, { ...inputValues, [`ddlCurrency${id_n}`]: currentOnChangeInput }, handleInputChange, window.location, objAttachment, objectRequestor, inputValues[`isDateRange`] == "1" ? inputValues[`txtStartDate${id_n}`] : inputValues[`txtDate${id_n}`],handleBindDDL, bindDDL);

                    //If More than one tax rate is present, this wont automatically till user choose one
                    checkAndAutoCalTax(id_n!, { ...inputValues, [`ddlCurrency${id_n}`]: currentOnChangeInput }, handleInputChange, objectRequestor, objAttachment);
                }
                //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
else if (objectRequestor.country_code == "DE" || objectRequestor.country_code == "PL" || objectRequestor.company_code == "CH87" || objectRequestor.country_code == "VN") {
                    let detailType = 0;
                    if (!isNullOrEmpty(inputValues[`ddlPhoneType${id_n}`]) && inputValues[`ddlPhoneType${id_n}`] != 0){
                        detailType = inputValues[`ddlPhoneType${id_n}`] ;
                    }
                    else if (!isNullOrEmpty(inputValues[`ddlTransportType${id_n}`]) && inputValues[`ddlTransportType${id_n}`] != 0){
                        detailType = inputValues[`ddlTransportType${id_n}`] ;
                    }
                        
                    enableTaxDetailsForDE(
                        id_n,
                        inputValues[`ddlCategory${id_n}`],
                        { ...inputValues, [`ddlCurrency${id_n}`]: currentOnChangeInput },
                        handleInputChange,
                        objectRequestor,
                        objAttachment,
                        bindDDL!,
                        handleBindDDL!,
                        0,
                        detailType
                    );
                }
            }
            break;
        case "ddlTravelRefNo":

            if (currentOnChangeInput == '' || currentOnChangeInput.toUpperCase() == "NO PRE-APPROVAL") {
                elementDisplay(`#div_Link${id_n}`, false, "div");
            } else {

                if (objDDL.length > 0 && !isNullOrEmpty(objAttachment)) {
                    // Hazel Amendments 20260206 - Filter by text OR id since travel_ref_no can be either
                    const objTravelRefNo = objDDL.filter((e: any) => e.text == currentOnChangeInput || e.id == currentOnChangeInput);

                    if (objTravelRefNo.length > 0) {
                    elementSetAttribute(`#link${id_n}`, "href", objTravelRefNo[0].travelurllink, "a");
                    elementSetAttribute(`#link${id_n}`, "text", "Click here to view travel request detail", "a");
                    elementSetAttribute(`#link${id_n}`, "target", '_blank', "a");

                    elementDisplay(`#div_Link${id_n}`, true, "div");
                    }
                }
            }
            if (document.querySelector<HTMLElement>(`.Accommodation${id_n}`)) {

                elementDisplay(`.Accommodation${id_n}`, true, "div");
                elementDisplay(`.Country${id_n}`, true, "div");
                elementDisplay(`.City${id_n}`, true, "div");

                mandatoryInput(`#ddlCountry${id_n}`, false, "select");
                mandatoryInput(`#ddlCity${id_n}`, false, "select");
                mandatoryInput(`#ddlHotel${id_n}`, false, "select");

            } else {
                // Flight?.classList.remove(`d-none`);
                elementDisplay(`.Flight${id_n}`, true, "div");


                mandatoryInput(`#ddlDepartureCountry${id_n}`, true, 'select');
                mandatoryInput(`#ddlDepartureCity${id_n}`, true, 'select');
                mandatoryInput(`#ddlArrivalCountry${id_n}`, true, 'select');
                mandatoryInput(`#ddlArrivalCity${id_n}`, true, 'select');
                mandatoryInput(`#ddlTravelClass${id_n}`, true, 'select');
                mandatoryInput(`#ddlAirline${id_n}`, true, 'select');


            }

            break;
        case "ddlCountry":
            if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString().toUpperCase() == 'OTH') {
                country!.style.marginBottom = "0px";
                elementDisplay(`#othCountry${id_n}`, true, "div");
                othCountry!.style.marginBottom = "0px";
                elementDisplay(`#txtCountry${id_n}`, true, "text");
                mandatoryInput(`#txtCountry${id_n}`, true, "text");

            } else {

                elementDisplay(`#othCountry${id_n}`, false, "div");
                if (!isNullOrEmpty(inputValues[`txtCountry${id_n}`])) { handleInputChange(`txtCountry${id_n}`, ''); }
                mandatoryInput(`#txtCountry${id_n}`, false, "text");
            }

            //Begin,saber,20260827,INC-1028107 - Skip changePerDiemTax when merely restoring a saved
            //country during claim load (isLoadRestore) - it was clobbering the tax checkbox state
            //that bindTaxCol already correctly restored from the saved taxamount columns.
            if (!isNullOrEmpty(objectRequestor) && !isLoadRestore) {
                // inputValues[ddlCountry{id_n}] is still the pre-selection value here since
                // handleInputChange's state update hasn't committed yet; merge in the just-picked
                // country so changePerDiemTax's country-match check isn't compared against stale data.
                changePerDiemTax(id_n!, { ...inputValues, [`ddlCountry${id_n}`]: currentOnChangeInput }, handleInputChange, objectRequestor);
            }
            //End,saber,20260827,INC-1028107



            //GetCity Callback
            handleInputChange(`ddlCity${id_n}`, '');
            // handleInputChange(`newDDLCallbackTrigger`, currentOnChangeInput);
            // handleInputChange(`newDDLCallback`, 'ddlCity');
            handleBindDDL && handleBindDDL(`cityDDL`,await dropdownMappings[DROPDOWN_NAME.City]({ country_code: currentOnChangeInput }));

            if (!isNullOrEmpty(objAttachment) && !isNullOrEmpty(objAttachment.city)) {
                inputValues[`ddlCity${id_n}`] != objAttachment.city && handleInputChange(`ddlCity${id_n}`, objAttachment.city);
                handleInputChange(`txtCity${id_n}`, objAttachment.other_city);

                if (objAttachment.subcategory_id != inputValues[`ddlCategory${id_n}`]) {
                    handleInputChange(`ddlCity${id_n}`, '');
                }

                if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString().toUpperCase() == 'OTH') {
                    inputValues[`ddlCity${id_n}`] != 'OTHER' && handleInputChange(`ddlCity${id_n}`, 'OTHER');
                    city!.style.marginBottom = "0px";
                    othCity!.style.marginBottom = "0px";
                    elementDisplay(`#othCity${id_n}`, true, "div");
                    mandatoryInput(`#txtCity${id_n}`, true, "text");
                    elementDisplay(`#txtCity${id_n}`, true, "text");

                } else {
                    if (inputValues[`ddlCity${id_n}`] == 'OTHER') {
                        city!.style.marginBottom = "0px";
                        othCity!.style.marginBottom = "0px";
                        elementDisplay(`#othCity${id_n}`, true, "div");
                        mandatoryInput(`#txtCity${id_n}`, true, "text");
                        elementDisplay(`#txtCity${id_n}`, true, "text");
                    }
                    else {
                        elementDisplay(`#othCity${id_n}`, false, "div");
                        mandatoryInput(`#txtCity${id_n}`, false, "text");
                        inputValues[`txtCity${id_n}`] != '' && handleInputChange(`txtCity${id_n}`, '');
                    }
                }
            }

            //GetHotel Callback
            // Saber, 20260923, SR-1023924: Legacy rebinds the hotel list for the selected country, then sets ddlHotel to objAttachment.hotel.
            // Do not clear a saved hotel just because it is already in the new list.
            const newHotelList = await dropdownMappings[DROPDOWN_NAME.Hotel]({ country_code: currentOnChangeInput });
            const savedHotel = objAttachment?.hotel || inputValues[`ddlHotel${id_n}`];
            const matchedHotel = matchHotelOption(newHotelList, savedHotel);
            const resolvedHotel = matchedHotel?.value ?? savedHotel;
            let hotelOptions = newHotelList;
            if (!isNullOrEmpty(savedHotel) && !matchedHotel) {
                hotelOptions = [
                    ...(newHotelList ?? []),
                    { value: savedHotel, label: savedHotel },
                ];
            }
            handleBindDDL && handleBindDDL(`hotelDDL`, hotelOptions);
            if (!isNullOrEmpty(resolvedHotel) && inputValues[`ddlHotel${id_n}`] != resolvedHotel) {
                handleInputChange(`ddlHotel${id_n}`, resolvedHotel);
            }

            if ((!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString().toUpperCase() == 'OTH') || resolvedHotel == 'OTHER') {
                handleInputChange(`ddlHotel${id_n}`, 'OTHER');
                hotel!.style.marginBottom = "0px";
                othHotel!.style.marginBottom = "0px";
                elementDisplay(`#othHotel${id_n}`, true, "div");
                elementDisplay(`#txtHotel${id_n}`, true, "text");
                mandatoryInput(`#txtHotel${id_n}`, true, "text");
            } else {
                elementDisplay(`#othHotel${id_n}`, false, "div");
                mandatoryInput(`#txtHotel${id_n}`, false, "text");

            }
            break;
        case "ddlCity":
            if (city) {
                if (currentOnChangeInput.toString().toUpperCase() == 'OTHER') {
                    city!.style.marginBottom = "0px";
                    othCity!.style.marginBottom = "0px";
                    elementDisplay(`#othCity${id_n}`, true, "div");
                    mandatoryInput(`#txtCity${id_n}`, true, "text");
                } else {
                    elementDisplay(`#othCity${id_n}`, false, "div");
                    mandatoryInput(`#txtCity${id_n}`, false, "text");
                    inputValues[`txtCity${id_n}`] != '' && handleInputChange(`txtCity${id_n}`, '');
                }
            }
            break;
        case "ddlTransportType":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                setDefaultTax(id_n!, inputValues, handleInputChange, window.location, objAttachment, objectRequestor);
                elementDisplay(`#othTransportType${id_n}`, false, "text");
                handleInputChange(`txtTransportType${id_n}`, "");
                mandatoryInput(`#txtTransportType${id_n}`, false, "text");

                hideShowTaxableFields(
                    id_n,
                    { ...inputValues, [`ddlTransportType${id_n}`]: currentOnChangeInput },
                    handleInputChange,
                    objectRequestor,
                    appConfig.HideShowTaxableFieldsCountry,
                    inputValues[`form_mode`]
                );

                setPaymentType2_visibility(inputValues[`ddlCategory${id_n}`], currentOnChangeInput, id_n, { ...inputValues, [`ddlTransportType${id_n}`]: currentOnChangeInput }, handleInputChange, id_n, objectRequestor, objAttachment, null, handleBindDDL, bindDDL);
                if (objectRequestor.company_code == appConfig.FlexiClaimCSSC &&
                    (currentOnChangeInput == '1' || //Taxi / Rideshare
                        currentOnChangeInput == '3' || //Public transport
                        currentOnChangeInput == '6' || //Parking and toll
                        currentOnChangeInput == '9' || //Parking
                        currentOnChangeInput == '10')) { //Toll
                    elementDisplay(`#flexiTransport${id_n}`, true, "div");
                    //Begin,saber,20261021,SR-1061801 - MY98 transport Flexi Claim is optional, same as legacy.
                    mandatoryInput(`#chkFlexiTransport${id_n}`, false, "checkbox");
                    //End,saber,20261021,SR-1061801

                } else {

                    elementDisplay(`#flexiTransport${id_n}`, false, "div");
                    mandatoryInput(`#chkFlexiTransport${id_n}`, false, "checkbox");
                    handleInputChange(`chkFlexiTransport${id_n}`, "0");
                }

                // if (currentOnChangeInput == '2' || currentOnChangeInput == '6') {
                //     handleInputChange(`isDateRange`, 1);
                //     handleInputChange(`txtDate${id_n}`, '');
                //     handleInputChange(`txtStartDate${id_n}`, '');
                //     handleInputChange(`txtEndDate${id_n}`, '');

                // } else {
                //     handleInputChange(`isDateRange`, 0);
                //     handleInputChange(`txtDate${id_n}`, '');
                //     handleInputChange(`txtStartDate${id_n}`, '');
                //     handleInputChange(`txtEndDate${id_n}`, '');
                // }

                // //Thailand Special feature
                if (objectRequestor && objectRequestor.country_code == 'TH') {
                    enable_Disable_VAT_WHT_OnLoad(
                        id_n,
                        { ...inputValues, [`ddlTransportType${id_n}`]: currentOnChangeInput },
                        handleInputChange,
                        objAttachment,
                    );
                    loadInvoice_Number(
                        id_n,
                        { ...inputValues, [`ddlTransportType${id_n}`]: currentOnChangeInput },
                        handleInputChange,
                        objAttachment
                    );
                    if (!isNullOrEmpty(currentOnChangeInput)) {
                        if (currentOnChangeInput.toString() == "2" && inputValues[`ddlCurrency${id_n}`] == 'THB') {
                            elementDisplay(`#dvTHMileage${id_n}`, true, "div");
                            mandatoryInput(`#txtTaxableamount${id_n}`, true, "text");
                            mandatoryInput(`#txtNontaxableamount${id_n}`, true, "text");
                            disableInput(`#txtClaimAmount${id_n}`, true, "text");
                        }
                        else {
                            elementDisplay(`#dvTHMileage${id_n}`, false, "div");
                            mandatoryInput(`#txtTaxableamount${id_n}`, false, "text");
                            mandatoryInput(`#txtNontaxableamount${id_n}`, false, "text");
                            disableInput(`#txtClaimAmount${id_n}`, false, "text");

                            //To handle all claim item in team mode for superior to check surbordinate claim item
                            const params = new URLSearchParams(window.location.search);
                            const currentMode = params.get("mode");
                            if (!isNullOrEmpty(currentMode) && currentMode?.toLowerCase() == 'team') {
                                disableInput(`#txtClaimAmount${id_n}`, true, "text");
                            }
                        }

                    }

                }
                //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
                if (objectRequestor && objectRequestor.country_code == "DE" || objectRequestor.country_code == "PL" || objectRequestor.company_code == "CH87" || objectRequestor.country_code == "VN") {
                    let IsOnLoad = 0;
                    if (objAttachment.transport_type && objAttachment.transport_type == currentOnChangeInput) {
                        IsOnLoad = 1;
                    }

                    handleBindDDL &&
                        enableTaxDetailsForDE(
                            id_n,
                            inputValues[`ddlCategory${id_n}`],
                            { ...inputValues, [`ddlTransportType${id_n}`]: currentOnChangeInput },
                            handleInputChange,
                            objectRequestor,
                            objAttachment,
                            bindDDL!,
                            handleBindDDL!,
                            IsOnLoad,
                            currentOnChangeInput
                        );

                }
                else {
                    //Corporate credit card binding
                    //Load Tax column
                    // Begin,Saber,20261007,INC-1030470 - keep the category already selected on the
                    // form. Transport rates are keyed by subcategory + detail; a stale empty
                    // ddlCategory skips the rate and leaves tax amount at 0.
                    const transportTaxInputs = {
                      ...inputValues,
                      [`ddlTransportType${id_n}`]: currentOnChangeInput,
                      [`ddlCategory${id_n}`]: inputValues[`ddlCategory${id_n}`] ?? objAttachment?.subcategory_id,
                    };
                    checkAndBind(
                        id_n!,
                         transportTaxInputs,
                        handleInputChange,
                        objectRequestor,
                        objAttachment,
                        inputValues[`form_mode`],
                        handleBindDDL,
                        bindDDL
                    );
                    loadTaxCol(id_n!, transportTaxInputs, handleInputChange, window.location, objAttachment, objectRequestor, inputValues[`isDateRange`] == "1" ? inputValues[`txtStartDate${id_n}`] : inputValues[`txtDate${id_n}`],handleBindDDL, bindDDL);
                    checkAndAutoCalTax(id_n!, transportTaxInputs, handleInputChange, objectRequestor, objAttachment);
                    // End,Saber,20261007,INC-1030470
                }

                //Check zero attachment 
                checkAndAllowZeroAttach(id_n, { ...inputValues, [`ddlTransportType${id_n}`]: currentOnChangeInput }, handleInputChange, currentOnChangeInput);

                //  Enable internal code for selected transport type
                if (objAttachment.transport_type && objAttachment.transport_type != currentOnChangeInput) {
                    showInternalCode(id_n, { ...inputValues, [`ddlTransportType${id_n}`]: currentOnChangeInput }, handleInputChange, currentOnChangeInput, objectRequestor, objAttachment);
                }


                //Form Simplication START
                let formsimplification_companylist = !isNullOrEmpty(localStorage.getItem('Form_Simplification_Company')) ? localStorage.getItem('Form_Simplification_Company')?.split(',') : [];
                let isCompanyExists = false;
                if (formsimplification_companylist && formsimplification_companylist?.length > 0) {
                    for (let ind = 0; ind < formsimplification_companylist.length; ind++) {

                        let company_code = formsimplification_companylist[ind];

                        if (company_code == objectRequestor.company_code) {

                            isCompanyExists = true;
                        }
                    }
                }

                if (isCompanyExists) {
                    if ((currentOnChangeInput == '4' && objectRequestor.company_code.substring(0, 2) == 'TH') || (currentOnChangeInput != '4' && objectRequestor.company_code != 'JP80' && objectRequestor.company_code != 'JP86')) {
                        elementDisplay(`#divForm_${id_n}`, false, "div");
                    } else {
                        elementDisplay(`#divForm_${id_n}`, true, "div");
                    }

                    if (objectRequestor.company_code != 'JP80' && objectRequestor.company_code != 'JP86' && objectRequestor.company_code.substring(0, 2) != 'TH') {
                        elementDisplay(`#divProjectName_${id_n}`, false, "div");
                    } else {
                        elementDisplay(`#divProjectName_${id_n}`, true, "div");
                    }

                    if ((currentOnChangeInput == '4' && (objectRequestor.company_code != 'MY98' || objectRequestor.company_code != 'JP80' || objectRequestor.company_code != 'JP86')) || objectRequestor.company_code.substring(0, 2) == 'TH') {
                        elementDisplay(`#city${id_n}`, false, "div");
                        mandatoryInput(`#ddlCity${id_n}`, false, "select");
                    } else {
                        elementDisplay(`#city${id_n}`, true, "div");
                        mandatoryInput(`#ddlCity${id_n}`, true, "select");
                    }
                }

            }
           
            break;
        case "ddlHotel":
            if (currentOnChangeInput == '' || currentOnChangeInput == null) {
                mandatoryInput(`#ddlHotel${id_n}`, false, "select");
            }
            if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString().toUpperCase() == 'OTHER') {
                hotel!.style.marginBottom = "0px";
                othHotel!.style.marginBottom = "0px";
                elementDisplay(`#othHotel${id_n}`, true, "div");
                mandatoryInput(`#txtHotel${id_n}`, true, "text");
            } else {
                inputValues[`txtHotel${id_n}`] != '' && handleInputChange(`txtHotel${id_n}`, '');
                elementDisplay(`#othHotel${id_n}`, false, "div");
                mandatoryInput(`#txtHotel${id_n}`, false, "text");
            }
            break;
        case "txtCheckInDate":
            getNumberOfNight(id_n, inputValues, handleInputChange, currentOnChangeInput, inputValues[`txtCheckOutDate${id_n}`]);
            break;
        case "txtCheckOutDate":
            getNumberOfNight(id_n, inputValues, handleInputChange, inputValues[`txtCheckInDate${id_n}`], currentOnChangeInput);
            break;
        case "ddlDKSHInvolve":
            
        // Both Hospitality(Meals) and Gift will use together on this ddlDKSHInvolve 
        // Hospitality(Meals) -> ddlLocalInvolve and ddlNonLocalInvolve
        // Gift->  ddlLocalReceive and ddlNonLocalReceive
        // Begin,Saber,20261007,SR-1016479: show local/non-local questions when Internal = Yes.
        // The subcategory fields are still mounting when this runs, so a single
        // elementDisplay can miss them and leave the questions hidden.

        let ddlLocalInvolve = inputValues[`ddlLocalInvolve${id_n}`];
        let ddlNonLocalInvolve = inputValues[`ddlNonLocalInvolve${id_n}`];

        // Begin,Saber,20261007,SR-1016479 - JP defaults local employees to Yes. The caller may not have written that yet.
        if (objectRequestor?.country_code == "JP" && (isNullOrEmpty(ddlLocalInvolve) || ddlLocalInvolve == "0")) {
            ddlLocalInvolve = "1";
            handleInputChange(`ddlLocalInvolve${id_n}`, "1");
        }
        // End,Saber,20261007,SR-1016479

        if(objAttachment.subcategory_id == 6){
            ddlLocalInvolve = inputValues[`ddlLocalReceive${id_n}`];
            ddlNonLocalInvolve = inputValues[`ddlNonLocalReceive${id_n}`];
        }
          
        if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString() == "1") {
            showMealInternalFollowUp(id_n);
            // elementDisplay(`label[for="ddlLocalReceive${id_n}"]`, true, "div");
            // elementDisplay(`label[for="ddlNonLocalReceive${id_n}"]`, true, "div");
        } else {

            elementDisplay(`#div_ddlLocalReceive${id_n}`, false, "div");
            elementDisplay(`#div_ddlNonLocalReceive${id_n}`, false, "div");
            elementDisplay(`#div_ddlLocalInvolve${id_n}`, false, "div");
            elementDisplay(`#div_ddlNonLocalInvolve${id_n}`, false, "div");
            // elementDisplay(`label[for="ddlLocalReceive${id_n}"]`, false, "div");
            // elementDisplay(`label[for="ddlNonLocalReceive${id_n}"]`, false, "div");

            if (ddlLocalInvolve != "0") {
                ddlLocalInvolve = "0";
                handleInputChange(`ddlLocalInvolve${id_n}`, ddlLocalInvolve);
            }
            if (ddlNonLocalInvolve != "0") {
                ddlNonLocalInvolve = "0";
                handleInputChange(`ddlNonLocalInvolve${id_n}`, ddlNonLocalInvolve);
            }

            }

            // if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString() == "1") {
            //     elementDisplay(`#div_ddlLocalInvolve${id_n}`, true, "div");
            //     elementDisplay(`#div_ddlNonLocalInvolve${id_n}`, true, "div");
            //     // elementDisplay(`label[for="ddlLocalReceive${id_n}"]`, true, "div");
            //     // elementDisplay(`label[for="ddlNonLocalReceive${id_n}"]`, true, "div");
            // } else {

            //     elementDisplay(`#div_ddlLocalInvolve${id_n}`, false, "div");
            //     elementDisplay(`#div_ddlNonLocalInvolve${id_n}`, false, "div");
            //     // elementDisplay(`label[for="ddlLocalReceive${id_n}"]`, false, "div");
            //     // elementDisplay(`label[for="ddlNonLocalReceive${id_n}"]`, false, "div");

            //     if (inputValues[`ddlLocalInvolve${id_n}`] != "0") {
            //         handleInputChange(`ddlLocalInvolve${id_n}`, "0");
            //     }
            //     if (inputValues[`ddlNonLocalInvolve${id_n}`] != "0") {
            //         handleInputChange(`ddlNonLocalInvolve${id_n}`, "0");
            //     }
            // }

            // For subcategory 6 (Gifts), use ddlLocalReceive/ddlNonLocalReceive instead of ddlLocalInvolve/ddlNonLocalInvolve
            if (objAttachment && objAttachment.subcategory_id == 6) {
                subCatInputOnChange(inputValues, id_n, "ddlLocalReceive", handleInputChange, ddlLocalInvolve, bindDDL,
                    handleBindDDL,);
                subCatInputOnChange(inputValues, id_n, "ddlNonLocalReceive", handleInputChange, ddlNonLocalInvolve, bindDDL,
                    handleBindDDL,);
            } else {
                subCatInputOnChange(inputValues, id_n, "ddlLocalInvolve", handleInputChange, ddlLocalInvolve, bindDDL,
                    handleBindDDL,);
                subCatInputOnChange(inputValues, id_n, "ddlNonLocalInvolve", handleInputChange, ddlNonLocalInvolve, bindDDL,
                    handleBindDDL,);
            }
            // End,Saber,20261007,SR-1016479
            break;
        case "ddlDKSHInvolveLocalReceive":

            if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString() == "1") {
                elementDisplay(`#div_ddlLocalReceive${id_n}`, true, "div");
                elementDisplay(`#div_ddlNonLocalReceive${id_n}`, true, "div");
            } else {
                elementDisplay(`#div_ddlLocalReceive${id_n}`, false, "div");
                elementDisplay(`#div_ddlNonLocalReceive${id_n}`, false, "div");

                if (inputValues[`ddlNonLocalReceive${id_n}`] != "0") {
                    handleInputChange(`ddlNonLocalReceive${id_n}`, "0");
                }
                if (inputValues[`ddlLocalReceive${id_n}`] != "0") {
                    handleInputChange(`ddlLocalReceive${id_n}`, "0");
                }

                subCatInputOnChange(inputValues, id_n, "ddlLocalReceive", handleInputChange, inputValues[`ddlLocalReceive${id_n}`], bindDDL,
          handleBindDDL,);
                subCatInputOnChange(inputValues, id_n, "ddlNonLocalReceive", handleInputChange, inputValues[`ddlNonLocalReceive${id_n}`],bindDDL,
          handleBindDDL,);

            }
            break;
        case "ddlLocalReceive":

            if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString() == "1") {
                elementDisplay(`#LocalReceive${id_n}`, true, "div");
                mandatoryInput(`#txtLocalReceive${id_n}`, true, "text");

            } else {
                elementDisplay(`#LocalReceive${id_n}`, false, "div");
                mandatoryInput(`#txtLocalReceive${id_n}`, false, "text");
                handleInputChange(`txtLocalReceive${id_n}`, "");
            }

            break;
        case "ddlNonLocalReceive":

            if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString() == "1") {
                elementDisplay(`#NonLocalReceive${id_n}`, true, "div");
                mandatoryInput(`#txtNonLocalReceive${id_n}`, true, "text");

            } else {
                elementDisplay(`#NonLocalReceive${id_n}`, false, "div");
                mandatoryInput(`#txtNonLocalReceive${id_n}`, false, "text");
                handleInputChange(`txtNonLocalReceive${id_n}`, "");
            }

            break;
        case "ddlNonDKSHReceive":

            if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString() == "1") {
                elementDisplay(`.NonDKSHReceive${id_n}`, true, "div");
                mandatoryInput(`#txtPublicReceive${id_n}`, true, "text");
                mandatoryInput(`#txtHealthcareReceive${id_n}`, true, "text");
                mandatoryInput(`#txtNonDKSHReceive${id_n}`, true, "text");
                elementDisplay(`.RecipientType${id_n}`, true, "div");
                elementDisplay(`.AmountProvidedToExternalRecipient${id_n}`, true, "div");
                elementDisplay(`.BusinessRationaleProvideToExternal${id_n}`, true, "div");

                subCatInputOnChange(inputValues, id_n, "ddlRecipientType", handleInputChange, inputValues[`ddlRecipientType${id_n}`],bindDDL,
          handleBindDDL,);

                mandatoryInput(`#txtBusinessRationaleProvideToExternal${id_n}`, true, "text");
                mandatoryInput(`#ddlRecipientType${id_n}`, true, "select");
                elementDisplay(`.HeadCountPOHCPInvolve${id_n}`, true, "div");
                mandatoryInput(`#txtHeadCountPOHCPInvolve${id_n}`, true, "text");

            } else {
                elementDisplay(`.NonDKSHReceive${id_n}`, false, "div");
                handleInputChange(`txtPublicReceive${id_n}`, "");
                handleInputChange(`txtHealthcareReceive${id_n}`, "");
                handleInputChange(`txtNonDKSHReceive${id_n}`, "");

                mandatoryInput(`#txtPublicReceive${id_n}`, false, "text");
                mandatoryInput(`#txtHealthcareReceive${id_n}`, false, "text");
                mandatoryInput(`#txtNonDKSHReceive${id_n}`, false, "text");

                elementDisplay(`.RecipientType${id_n}`, false, "div");
                elementDisplay(`.AmountProvidedToExternalRecipient${id_n}`, false, "div");
                elementDisplay(`.BusinessRationaleProvideToExternal${id_n}`, false, "div");
                elementDisplay(`#gift_recipient_download${id_n}`, false, "div");
                mandatoryInput(`#txtBusinessRationaleProvideToExternal${id_n}`, false, "text");
                mandatoryInput(`#ddlRecipientType${id_n}`, false, "select");

                elementDisplay(`.HeadCountPOHCPInvolve${id_n}`, false, "div");
                mandatoryInput(`#txtHeadCountPOHCPInvolve${id_n}`, false, "text");
            }

            break;
        case "ddlLocalInvolve":
            if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString() == "1") {
                elementDisplay(`#LocalInvolve${id_n}`, true, "div");
                mandatoryInput(`#txtLocalInvolve${id_n}`, true, "text");


            } else {
                handleInputChange(`txtLocalInvolve${id_n}`, "");
                elementDisplay(`#LocalInvolve${id_n}`, false, "div");
                mandatoryInput(`#txtLocalInvolve${id_n}`, false, "text");
            }
            break;
        case "ddlNonLocalInvolve":
            // if (nonLocalInvolve) {
            //     const txtNonLocalInvolve = document.querySelector<HTMLInputElement>(`#txtNonLocalInvolve${id_n}`);
            //     if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString() == "1") {
            //         nonLocalInvolve.classList.remove(`d-none`);
            //         nonLocalInvolve.style.marginBottom = '0.5rem';
            //         nonLocalInvolve.style.marginTop = '0.5rem';
            //         txtNonLocalInvolve!.required = true;

            //     } else {
            //         nonLocalInvolve.classList.add(`d-none`);
            //         txtNonLocalInvolve!.value = "";
            //         handleInputChange(`txtNonLocalInvolve`, "");
            //         txtNonLocalInvolve!.required = false;
            //     }
            // }
            if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString() == "1") {
                elementDisplay(`#NonLocalInvolve${id_n}`, true, "div");
                mandatoryInput(`#txtNonLocalInvolve${id_n}`, true, "text");


            } else {
                handleInputChange(`txtNonLocalInvolve${id_n}`, "");
                elementDisplay(`#NonLocalInvolve${id_n}`, false, "div");
                mandatoryInput(`#txtNonLocalInvolve${id_n}`, false, "text");
            }

            break;
        case "ddlNonDKSHInvolve":
            if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString() == "1") {
                elementDisplay(`.NonDKSHInvolve${id_n}`, true, "div");
                mandatoryInput(`#txtPublicInvolve${id_n}`, true, "text");
                mandatoryInput(`#txtHealthcareInvolve${id_n}`, true, "text");
                mandatoryInput(`#txtNonDKSHInvolve${id_n}`, true, "text");
                elementDisplay(`.RecipientType${id_n}`, true, "div");
                elementDisplay(`.HeadCountPOHCPInvolve${id_n}`, true, "div");
                elementDisplay(`.AmountProvidedToExternalRecipient${id_n}`, true, "div");
                elementDisplay(`.BusinessRationaleProvideToExternal${id_n}`, true, "div");

                mandatoryInput(`#ddlRecipientType${id_n}`, true, "select");
                mandatoryInput(`#txtHeadCountPOHCPInvolve${id_n}`, true, "text");
                mandatoryInput(`#txtAmountProvidedToExternalRecipient${id_n}`, true, "text");
                mandatoryInput(`#txtBusinessRationaleProvideToExternal${id_n}`, true, "text");

            } else {
                elementDisplay(`.NonDKSHInvolve${id_n}`, false, "div");
                handleInputChange(`txtPublicInvolve${id_n}`, "");
                handleInputChange(`txtHealthcareInvolve${id_n}`, "");
                handleInputChange(`txtNonDKSHInvolve${id_n}`, "");

                mandatoryInput(`#txtHealthcareInvolve${id_n}`, true, "text");
                mandatoryInput(`#txtPublicInvolve${id_n}`, true, "text");
                mandatoryInput(`#txtNonDKSHInvolve${id_n}`, true, "text");

                elementDisplay(`.RecipientType${id_n}`, false, "div");
                elementDisplay(`.HeadCountPOHCPInvolve${id_n}`, false, "div");
                elementDisplay(`.AmountProvidedToExternalRecipient${id_n}`, false, "div");
                elementDisplay(`.BusinessRationaleProvideToExternal${id_n}`, false, "div");
                elementDisplay(`#gift_recipient_download${id_n}`, false, "div");

                mandatoryInput(`#ddlRecipientType${id_n}`, false, "select");
                mandatoryInput(`#txtHeadCountPOHCPInvolve${id_n}`, false, "text");
                mandatoryInput(`#txtAmountProvidedToExternalRecipient${id_n}`, false, "text");
                mandatoryInput(`#txtBusinessRationaleProvideToExternal${id_n}`, false, "text");

                let no_value = 0;

                for (let iCounter = 1; iCounter < 5; iCounter++) {
                    if (!isNullOrEmpty(inputValues[`ddlCC${iCounter}_${id_n}`])) {
                        no_value = 1;
                    }
                }

            }
            subCatInputOnChange(inputValues, id_n, "ddlRecipientType", handleInputChange, inputValues[`ddlRecipientType${id_n}`],bindDDL,
          handleBindDDL,);
            break;
        case "ddlDepartureCountry":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                //GetDepartureCity Callback
                if(isNullOrEmpty(objDDL) || objDDL?.length == 0){
                    inputValues[`ddlDepartureCity${id_n}`] != '' && handleInputChange(`ddlDepartureCity${id_n}`, '');
                    // handleInputChange(`newDDLCallbackTrigger`, currentOnChangeInput);
                    // handleInputChange(`newDDLCallback`, 'ddlDepartureCity');
                    handleBindDDL && handleBindDDL(`departureCityDDL`,await dropdownMappings[DROPDOWN_NAME.City]({ country_code: currentOnChangeInput }));
                }
                

                if (currentOnChangeInput.toString().toUpperCase() == 'OTH') {
                    departureCountry!.style.marginBottom = "0px";
                    othDepartureCountry!.style.marginBottom = "0px";
                    elementDisplay(`#othDepartureCountry${id_n}`, true, "div");
                    mandatoryInput(`#txtDepartureCountry${id_n}`, true, "text");

                    inputValues[`ddlDepartureCity${id_n}`] != "OTHER" && handleInputChange(`ddlDepartureCity${id_n}`, "OTHER");
                    departureCity!.style.marginBottom = "0px";
                    othDepartureCity!.style.marginBottom = "0px";
                    elementDisplay(`#othDepartureCity${id_n}`, true, "div");
                    mandatoryInput(`#txtDepartureCity${id_n}`, true, "text");
                } else {
                    inputValues[`txtDepartureCountry${id_n}`] != '' && handleInputChange(`txtDepartureCountry${id_n}`, '');
                    elementDisplay(`#othDepartureCountry${id_n}`, false, "div");
                    mandatoryInput(`#txtDepartureCountry${id_n}`, false, "text");

                    if (!isNullOrEmpty(objAttachment)) {
                        inputValues[`ddlDepartureCity${id_n}`] != objAttachment.departure_city && handleInputChange(`ddlDepartureCity${id_n}`, objAttachment.departure_city);
                        inputValues[`txtDepartureCity${id_n}`] != objAttachment.other_departure_city && handleInputChange(`txtDepartureCity${id_n}`, objAttachment.other_departure_city);
                    }
                    elementDisplay(`#othDepartureCity${id_n}`, false, "div");
                    mandatoryInput(`#txtDepartureCity${id_n}`, false, "text");
                }

            }


            break;
        case "ddlDepartureCity":
            if (currentOnChangeInput.toString().toUpperCase() == 'OTHER') {
                departureCity!.style.marginBottom = "0px";
                othDepartureCity!.style.marginBottom = "0px";
                elementDisplay(`#othDepartureCity${id_n}`, true, "div");
                mandatoryInput(`#txtDepartureCity${id_n}`, true, "text");
            } else {
                inputValues[`txtDepartureCity${id_n}`] != '' && handleInputChange(`txtDepartureCity${id_n}`, '');
                elementDisplay(`#othDepartureCity${id_n}`, false, "div");
                mandatoryInput(`#txtDepartureCity${id_n}`, false, "text");
            }
            break;
        case "ddlArrivalCountry":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                //GetDepartureCity Callback
                if(isNullOrEmpty(objDDL) || objDDL?.length == 0){
                    inputValues[`ddlArrivalCity${id_n}`] != '' && handleInputChange(`ddlArrivalCity${id_n}`, '');
                    // handleInputChange(`newDDLCallbackTrigger`, currentOnChangeInput);
                    // handleInputChange(`newDDLCallback`, 'ddlArrivalCity');
                    handleBindDDL && handleBindDDL(`arrivalCityDDL`,await dropdownMappings[DROPDOWN_NAME.City]({ country_code: currentOnChangeInput }));
                    
                }

                if (currentOnChangeInput.toString().toUpperCase() == 'OTH') {
                    arrivalCountry!.style.marginBottom = "0px";
                    othArrivalCountry!.style.marginBottom = "0px";
                    elementDisplay(`#othArrivalCountry${id_n}`, true, "div");
                    mandatoryInput(`#txtArrivalCountry${id_n}`, true, "text");

                    inputValues[`ddlArrivalCity${id_n}`] != "OTHER" && handleInputChange(`ddlArrivalCity${id_n}`, "OTHER");
                    departureCity!.style.marginBottom = "0px";
                    othDepartureCity!.style.marginBottom = "0px";
                    elementDisplay(`#othArrivalCity${id_n}`, true, "div");
                    mandatoryInput(`#txtArrivalCity${id_n}`, true, "text");
                } else {
                    inputValues[`txtArrivalCountry${id_n}`] != '' && handleInputChange(`txtArrivalCountry${id_n}`, '');
                    elementDisplay(`#othArrivalCountry${id_n}`, false, "div");
                    mandatoryInput(`#txtArrivalCountry${id_n}`, false, "text");

                    if (!isNullOrEmpty(objAttachment)) {
                        inputValues[`ddlArrivalCity${id_n}`] != objAttachment.departure_city && handleInputChange(`ddlArrivalCity${id_n}`, objAttachment.arrival_city);
                        inputValues[`txtArrivalCity${id_n}`] != objAttachment.other_arrival_city && handleInputChange(`txtArrivalCity${id_n}`, objAttachment.other_arrival_city);
                    }
                    elementDisplay(`#othArrivalCity${id_n}`, false, "div");
                    mandatoryInput(`#txtArrivalCity${id_n}`, false, "text");
                }

            }
            break;
        case "ddlArrivalCity":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                if (currentOnChangeInput.toString().toUpperCase() == 'OTHER') {
                    arrivalCity!.style.marginBottom = "0px";
                    othArrivalCity!.style.marginBottom = "0px";
                    elementDisplay(`#othArrivalCity${id_n}`, true, "div");
                    mandatoryInput(`#txtArrivalCity${id_n}`, true, "text");
                } else {
                    inputValues[`txtArrivalCity${id_n}`] != '' && handleInputChange(`txtArrivalCity${id_n}`, '');
                    elementDisplay(`#othArrivalCity${id_n}`, false, "div");
                    mandatoryInput(`#txtArrivalCity${id_n}`, false, "text");
                }
            }
            break;
        case "ddlAirline":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                if (currentOnChangeInput.toString().toUpperCase() == 'OTHER' || currentOnChangeInput.toString() == "9999") {
                    airline!.style.marginBottom = "0px";
                    othAirline!.style.marginBottom = "0px";
                    elementDisplay(`#othAirline${id_n}`, true, "div");
                    mandatoryInput(`#txtAirline${id_n}`, true, "text");
                } else {
                    inputValues[`txtAirline${id_n}`] != '' && handleInputChange(`txtAirline${id_n}`, '');
                    elementDisplay(`#othAirline${id_n}`, false, "div");
                    mandatoryInput(`#txtAirline${id_n}`, false, "text");
                }
            }
            break;
        case "ddlAddFlightLeg":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                if (currentOnChangeInput.toString() == '1') {
                elementDisplay(`.AddFlightLeg${id_n}`, true, "div");
                elementDisplay(`#othAddAirline${id_n}`, false, "div");
                elementDisplay(`#othAddDepartureCountry${id_n}`, false, "div");
                elementDisplay(`#othAddDepartureCity${id_n}`, false, "div");
                elementDisplay(`#othAddArrivalCountry${id_n}`, false, "div");
                elementDisplay(`#othAddArrivalCity${id_n}`, false, "div");

                mandatoryInput(`#ddlAddDepartureCountry${id_n}`, true, "select");
                mandatoryInput(`#ddlAddDepartureCity${id_n}`, true, "select");
                mandatoryInput(`#ddlAddArrivalCountry${id_n}`, true, "select");
                mandatoryInput(`#ddlAddArrivalCity${id_n}`, true, "select");

                } else {
                    elementDisplay(`.AddFlightLeg${id_n}`, false, "div");

                    inputValues[`txtAddDepartureDate${id_n}`] != '' && handleInputChange(`txtAddDepartureDate${id_n}`, '');
                    inputValues[`ddlAddDepartureCountry${id_n}`] != '' && handleInputChange(`ddlAddDepartureCountry${id_n}`, '');
                    inputValues[`txtAddDepartureCountry${id_n}`] != '' && handleInputChange(`txtAddDepartureCountry${id_n}`, '');
                    inputValues[`ddlAddDepartureCity${id_n}`] != '' && handleInputChange(`ddlAddDepartureCity${id_n}`, '');
                    inputValues[`txtAddDepartureCity${id_n}`] != '' && handleInputChange(`txtAddDepartureCity${id_n}`, '');

                    inputValues[`txtAddArrivalDate${id_n}`] != '' && handleInputChange(`txtAddArrivalDate${id_n}`, '');
                    inputValues[`ddlAddArrivalCountry${id_n}`] != '' && handleInputChange(`ddlAddArrivalCountry${id_n}`, '');
                    inputValues[`txtAddArrivalCountry${id_n}`] != '' && handleInputChange(`txtAddArrivalCountry${id_n}`, '');
                    inputValues[`ddlAdArrivalCity${id_n}`] != '' && handleInputChange(`ddlAdArrivalCity${id_n}`, '');
                    inputValues[`txtAddArrivalCity${id_n}`] != '' && handleInputChange(`txtAddArrivalCity${id_n}`, '');

                    inputValues[`ddlAddAirline${id_n}`] != '' && handleInputChange(`ddlAddAirline${id_n}`, '');
                    inputValues[`txtAddAirline${id_n}`] != '' && handleInputChange(`txtAddAirline${id_n}`, '');
                }

            }
            break;
        case "ddlAddDepartureCountry":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                //GetAddDepartureCity Callback
                if(isNullOrEmpty(objDDL) || objDDL?.length == 0){
                    inputValues[`ddlAddDepartureCity${id_n}`] != '' && handleInputChange(`ddlAddDepartureCity${id_n}`, '');
                    // handleInputChange(`newDDLCallbackTrigger`, currentOnChangeInput);
                    // handleInputChange(`newDDLCallback`, 'ddlAddDepartureCity');
                    handleBindDDL && handleBindDDL(`addDepartureCityDDL`,await dropdownMappings[DROPDOWN_NAME.City]({ country_code: currentOnChangeInput }));
                }
                

                if (currentOnChangeInput.toString().toUpperCase() == 'OTH') {
                    addDepartureCountry!.style.marginBottom = "0px";
                    othAddDepartureCountry!.style.marginBottom = "0px";
                    elementDisplay(`#othAddDepartureCountry${id_n}`, true, "div");
                    mandatoryInput(`#txtAddDepartureCountry${id_n}`, true, "text");

                    inputValues[`ddlAddDepartureCity${id_n}`] != "OTHER" && handleInputChange(`ddlAddDepartureCity${id_n}`, "OTHER");
                    addDepartureCity!.style.marginBottom = "0px";
                    othAddDepartureCity!.style.marginBottom = "0px";
                    elementDisplay(`#othAddDepartureCity${id_n}`, true, "div");
                    mandatoryInput(`#txtAddDepartureCity${id_n}`, true, "text");
                } else {
                    inputValues[`txtAddDepartureCountry${id_n}`] != '' && handleInputChange(`txtAddDepartureCountry${id_n}`, '');
                    elementDisplay(`#othAddDepartureCountry${id_n}`, false, "div");
                    mandatoryInput(`#txtAddDepartureCountry${id_n}`, false, "text");

                    if (!isNullOrEmpty(objAttachment)) {
                        inputValues[`ddlAddDepartureCity${id_n}`] != objAttachment.add_departure_city && handleInputChange(`ddlAddDepartureCity${id_n}`, objAttachment.add_departure_city);
                        inputValues[`othAddDepartureCity${id_n}`] != objAttachment.add_other_departure_city && handleInputChange(`othAddDepartureCity${id_n}`, objAttachment.add_other_departure_city);
                    }
                    elementDisplay(`#othAddDepartureCity${id_n}`, false, "div");
                    mandatoryInput(`#txtAddDepartureCity${id_n}`, false, "text");
                }

            }

            break;
        case "ddlAddDepartureCity":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                if (currentOnChangeInput.toUpperCase() == 'OTHER') {
                    addDepartureCity!.style.marginBottom = "0px";
                    othAddDepartureCity!.style.marginBottom = "0px";
                    elementDisplay(`#othAddDepartureCity${id_n}`, true, "div");
                    mandatoryInput(`#txtAddDepartureCity${id_n}`, true, "text");
                } else {
                    inputValues[`txtAddDepartureCity${id_n}`] != '' && handleInputChange(`txtAddDepartureCity${id_n}`, '');
                    elementDisplay(`#othAddDepartureCity${id_n}`, false, "div");
                    mandatoryInput(`#txtAddDepartureCity${id_n}`, false, "text");
                }
            }

            break;
        case "ddlAddArrivalCountry":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                //GetAddArrivalCity Callback
                if(isNullOrEmpty(objDDL) || objDDL?.length == 0){
                    inputValues[`ddlAddArrivalCity${id_n}`] != '' && handleInputChange(`ddlAddArrivalCity${id_n}`, '');
                    // handleInputChange(`newDDLCallbackTrigger`, currentOnChangeInput);
                    // handleInputChange(`newDDLCallback`, 'ddlAddArrivalCity');
                    handleBindDDL && handleBindDDL(`addArrivalCityDDL`,await dropdownMappings[DROPDOWN_NAME.City]({ country_code: currentOnChangeInput }));
                }
                

                if (currentOnChangeInput == 'OTH') {
                    addArrivalCountry!.style.marginBottom = "0px";
                    othAddArrivalCountry!.style.marginBottom = "0px";
                    elementDisplay(`#othAddArrivalCountry${id_n}`, true, "div");
                    mandatoryInput(`#txtAddArrivalCountry${id_n}`, true, "text");

                    inputValues[`ddlAddArrivalCity${id_n}`] != "OTHER" && handleInputChange(`ddlAddArrivalCity${id_n}`, "OTHER");
                    addArrivalCity!.style.marginBottom = "0px";
                    othAddArrivalCity!.style.marginBottom = "0px";
                    elementDisplay(`#othAddArrivalCity${id_n}`, true, "div");
                    mandatoryInput(`#txtAddArrivalCity${id_n}`, true, "text");
                } else {
                    inputValues[`txtAddArrivalCountry${id_n}`] != '' && handleInputChange(`txtAddArrivalCountry${id_n}`, '');
                    elementDisplay(`#othAddArrivalCountry${id_n}`, false, "div");
                    mandatoryInput(`#txtAddArrivalCountry${id_n}`, false, "text");

                    if (!isNullOrEmpty(objAttachment)) {
                        inputValues[`ddlAddArrivalCity${id_n}`] != objAttachment.add_arrival_city && handleInputChange(`ddlAddArrivalCity${id_n}`, objAttachment.add_arrival_city);
                        inputValues[`othAddArrivalCity${id_n}`] != objAttachment.add_other_arrival_city && handleInputChange(`othAddArrivalCity${id_n}`, objAttachment.add_other_arrival_city);
                    }
                    elementDisplay(`#othAddArrivalCity${id_n}`, false, "div");
                    mandatoryInput(`#txtAddArrivalCity${id_n}`, false, "text");
                }

            }
            break;
        case "ddlAddArrivalCity":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                if (currentOnChangeInput.toString().toUpperCase() == 'OTHER') {
                    addArrivalCity!.style.marginBottom = "0px";
                    othAddArrivalCity!.style.marginBottom = "0px";
                    elementDisplay(`#othAddArrivalCity${id_n}`, true, "div");
                    mandatoryInput(`#txtAddArrivalCity${id_n}`, true, "text");
                } else {
                    inputValues[`txtAddArrivalCity${id_n}`] != '' && handleInputChange(`txtAddArrivalCity${id_n}`, '');
                    elementDisplay(`#othAddArrivalCity${id_n}`, false, "div");
                    mandatoryInput(`#txtAddArrivalCity${id_n}`, false, "text");
                }
            }
            
            break;
        case "ddlAddAirline":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                if (currentOnChangeInput.toString().toUpperCase() == 'OTHER' || currentOnChangeInput.toString() == "9999") {
                    addAirline!.style.marginBottom = "0px";
                    othAddAirline!.style.marginBottom = "0px";
                    elementDisplay(`#othAddAirline${id_n}`, true, "div");
                    mandatoryInput(`#txtAddAirline${id_n}`, true, "text");
                } else {
                    inputValues[`txtAddAirline${id_n}`] != '' && handleInputChange(`txtAddAirline${id_n}`, '');
                    elementDisplay(`#othAddAirline${id_n}`, false, "div");
                    mandatoryInput(`#txtAddAirline${id_n}`, false, "text");
                }
            }

            break;
        case "ddlPhoneType":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                if (objectRequestor.company_code == appConfig.FlexiClaimCSSC && currentOnChangeInput == 1) {

                    //elementDisplay(`#flexiMobile${id_n}`, true, 'div');
                    mandatoryInput(`#chkFlexiMobile${id_n}`, true, 'checkbox');

                    if (objAttachment.is_flexi == 1) {
                        handleInputChange(`chkFlexiMobile${id_n}`, 1);
                    }
                    else {

                        handleInputChange(`chkFlexiMobile${id_n}`, 0);
                    }

                    //when submitting new claim
                    if (typeof objAttachment.is_flexi === 'undefined') {

                        if (currentOnChangeInput == 1)
                            handleInputChange(`chkFlexiMobile${id_n}`, 1);
                    }
                } else {

                    elementDisplay(`#flexiMobile${id_n}`, false, 'div');
                    mandatoryInput(`#chkFlexiMobile${id_n}`, true, 'checkbox');
                    handleInputChange(`chkFlexiMobile${id_n}`, 0);
                }

                setDefaultTax(id_n!, inputValues, handleInputChange, window.location, objAttachment, objectRequestor);
                //Thailand Tax & Invoice feature
                if (objectRequestor.country_code == 'TH') {
                    enable_Disable_VAT_WHT_OnLoad(
                        id_n, 
                        { ...inputValues, [`ddlPhoneType${id_n}`]: currentOnChangeInput },
                        handleInputChange, 
                        objAttachment, 
                    );
                    loadInvoice_Number(
                        id_n, 
                        { ...inputValues, [`ddlPhoneType${id_n}`]: currentOnChangeInput },
                        handleInputChange, 
                        objAttachment
                    );
                }

                //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
                if (objectRequestor.country_code == "DE" || objectRequestor.country_code == "PL" || objectRequestor.company_code == "CH87" || objectRequestor.country_code == "VN") {
                    let IsOnLoad = 0;
                    if (objAttachment.phone_type_id == currentOnChangeInput){
                        IsOnLoad = 1;
                    }
                        
                    handleBindDDL &&
                    enableTaxDetailsForDE(
                        id_n, 
                        inputValues[`ddlCategory${id_n}`],
                        { ...inputValues, [`ddlPhoneType${id_n}`]: currentOnChangeInput },
                        handleInputChange, 
                        objectRequestor, 
                        objAttachment, 
                        bindDDL!,
                        handleBindDDL!,
                        IsOnLoad,
                        currentOnChangeInput
                    );
                }
                else {
                    checkAndBind(
                        id_n!,
                         { ...inputValues, [`ddlPhoneType${id_n}`]: currentOnChangeInput },
                        handleInputChange,
                        objectRequestor,
                        objAttachment,
                        inputValues[`form_mode`],
                        handleBindDDL,
                        bindDDL
                    );
                    // //Load Tax column
                    loadTaxCol(id_n!, { ...inputValues, [`ddlPhoneType${id_n}`]: currentOnChangeInput }, handleInputChange, window.location, objAttachment, objectRequestor, inputValues[`isDateRange`] == "1" ? inputValues[`txtStartDate${id_n}`] : inputValues[`txtDate${id_n}`],handleBindDDL, bindDDL);
                    checkAndAutoCalTax(id_n!, { ...inputValues, [`ddlPhoneType${id_n}`]: currentOnChangeInput }, handleInputChange, objectRequestor, objAttachment);
                }
                //Check zero attachment 
                checkAndAllowZeroAttach(id_n, { ...inputValues, [`ddlPhoneType${id_n}`]: currentOnChangeInput }, handleInputChange, currentOnChangeInput);


            }

            break;
        case "chkFlexiMobile":
            if (currentOnChangeInput == "1") {
                mandatoryInput(`#chkFlexiMobile${id_n}`, false, "checkbox");
            }
            else {
                mandatoryInput(`#chkFlexiMobile${id_n}`, true, "checkbox");
            }
            break;
        case "ddlExceedraNoCode":
            checkNoAPEventCode(inputValues,handleInputChange, currentOnChangeInput, inputValues[`chkClaimable${id_n}`], id_n);
            if (currentOnChangeInput == "0") {
                //clear the value of the fields of cost center
                for (let iCounter = 1; iCounter < 5; iCounter++) {
                    disableInput(`#ddlCC${iCounter}_${id_n}`, true, "select");
                    disableInput(`#txtCCPercent${iCounter}_${id_n}`, true, "text");
                }
            }
            else {
                 //clear the value of the fields of cost center
                for (let iCounter = 1; iCounter < 5; iCounter++) {
                   disableInput(`#ddlCC${iCounter}_${id_n}`, false, "select");
                   disableInput(`#txtCCPercent${iCounter}_${id_n}`, false, "text");
                }
            }       
            break;
        case "chkClaimable":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                checkNoAPEventCode(inputValues, handleInputChange, inputValues[`ddlExceedraNoCode${id_n}`], currentOnChangeInput, id_n);
            }
            break;
        case "txtClientVendorCode":

            break;
        case "ddlRecipientType":
            if (isNullOrEmpty(currentOnChangeInput)) {
                gift_recipient_download?.classList.add(`d-none`);
                elementDisplay(`#gift_recipient_download${id_n}`, false, "div");
            } else {
                elementDisplay(`#gift_recipient_download${id_n}`, true, "div");
                if (currentOnChangeInput != "OTH" ) {
                    elementDisplay(`.HeadCountPOHCPInvolve${id_n}`, true, "div");
                    mandatoryInput(`#txtHeadCountPOHCPInvolve${id_n}`, true, "text");
                }
                else {
                    elementDisplay(`.HeadCountPOHCPInvolve${id_n}`, false, "div");
                    mandatoryInput(`#txtHeadCountPOHCPInvolve${id_n}`, false, "text");

                }
            }

            break;
        case "ddlAccommodationType":
            if (objectRequestor.country_code == 'MY' && objectRequestor.company_code != 'MY9B)') {
 
                if (currentOnChangeInput && (currentOnChangeInput.toString() == "1" || currentOnChangeInput.toString() == "2" )) {
                    elementDisplay(`#divForm_${id_n}`, false, "div");
                } else {
                    elementDisplay(`#divForm_${id_n}`, true, "div");
                }

                if (isNullOrEmpty(currentOnChangeInput)) {
                    elementDisplay(`#divForm_${id_n}`, false, "div");
                }

            }
            if (currentOnChangeInput && currentOnChangeInput.toString() == "1") {
                elementDisplay(`#div_TravelRefNo`, false, "div");
                mandatoryInput(`#ddlTravelRefNo${id_n}`, false, "div");
                // Only reset if accommodation type 1 requires hiding TravelRefNo
                handleInputChange(`ddlTravelRefNo${id_n}`, "");
                handleInputChange(`ddlTravelRefNo${id_n}_optionLabel_hide`, "");
            } else {
                elementDisplay(`#div_TravelRefNo`, true, "div");
                mandatoryInput(`#ddlTravelRefNo${id_n}`, true, "div");
                // Saber, 20260923, SR-1023924: Keep "No pre-approval" in the list. Legacy removes that option for accommodation
                // type <> 1, but a native <select> still shows the already-selected value.
                // react-select renders blank when the selected option is filtered out of options.
                handleInputChange(`ddlTravelRefNo${id_n}_optionLabel_hide`, "");
            }
            break;
        // Hazel Amendments 20260113 #CHN-19146 - MM new category - Other oerating expense type 
        case "ddlOtherOperatingExpenseType":
            // Handle other operating expense type changes similar to transport type
            if (!isNullOrEmpty(currentOnChangeInput)) {
                // Load tax columns and perform necessary validations
                loadTaxCol(id_n!, { ...inputValues, [`ddlOtherOperatingExpenseType${id_n}`]: currentOnChangeInput }, handleInputChange, window.location, objAttachment, objectRequestor, inputValues[`isDateRange`] == "1" ? inputValues[`txtStartDate${id_n}`] : inputValues[`txtDate${id_n}`], handleBindDDL, bindDDL);
                checkAndAutoCalTax(id_n!, { ...inputValues, [`ddlOtherOperatingExpenseType${id_n}`]: currentOnChangeInput }, handleInputChange, objectRequestor, objAttachment);
            }
            break;
        case "txtBaseAmount":
             if (isNullOrEmpty(inputValues[`hidden_Init_claim_Amount${id_n}`]) || (parseFloat(currentOnChangeInput) > parseFloat(inputValues[`hidden_Init_claim_Amount${id_n}`])))
            {
                myToast.warning(translate("VAT base amount shall not be higher than receipt amount"));
                handleInputChange(`txtBaseAmount${id_n}`, "")
            }
            else{
                //TH
                calculate_ClaimAmount(
                    id_n, 
                    "txtBaseAmount",
                    {...inputValues, [`txtBaseAmount${id_n}`]: currentOnChangeInput},
                    handleInputChange, 
                );
            }
                
            break;
        case "txtWHTAmount":
            if (isNullOrEmpty(inputValues[`hidden_Init_claim_Amount${id_n}`]) || (parseFloat(currentOnChangeInput) > parseFloat(inputValues[`hidden_Init_claim_Amount${id_n}`])))
            {
                    myToast.warning(translate("WHT base amount shall not be higher than receipt amount"));
                    handleInputChange(`txtWHTAmount${id_n}`, "")
            }
            else{
                //TH
                calculate_ClaimAmount(
                    id_n, 
                    "txtWHTAmount",
                    {...inputValues, [`txtWHTAmount${id_n}`]: currentOnChangeInput},
                    handleInputChange, 
                );
            }
                
            break;
        case "txtWHTAmount2":
             if (parseFloat(currentOnChangeInput) > parseFloat(inputValues[`hidden_Init_claim_Amount${id_n}`])) {
                    myToast.warning(translate("WHT base amount shall not be higher than receipt amount"));
                    handleInputChange(`txtWHTAmount2${id_n}`, "")
            }
            else{
                //TH
                calculate_ClaimAmount(
                    id_n, 
                    "txtWHTAmount2",
                    {...inputValues, [`txtWHTAmount2${id_n}`]: currentOnChangeInput},
                    handleInputChange, 
                );
            } 
            break;
        case "txtClaimAmount":
            handleInputChange(`hidden_Init_claim_Amount${id_n}`, currentOnChangeInput);
            handleInputChange(`hidIsClaim_Amount_Changed`, 1);

            // if (inputValues[`txtCreditCard${id_n}`] == 0) {
            //     if (validateClaimAmount(id_n!, inputValues, handleInputChange, currentOnChangeInput) == false) {
            //         return;
            //     }
            // }
            if (!isNullOrEmpty(currentOnChangeInput)){
                calConvertAmt(id_n!, inputValues, handleInputChange, currentOnChangeInput, addValue);

                //If two or more tax rate is presented, this wont autorun till user choose one value
                // let inputidname = `txtClaimAmount${id_n}`;
                // let pagenumber = inputidname.slice(-1) == "0" ? 10 : parseInt(inputidname.slice(-1));

                checkAndAutoCalTax(id_n!,inputValues,handleInputChange,objectRequestor,objAttachment);

                //Check for Non-Attachment Condition
                checkAndAllowZeroAttach(id_n!,inputValues,handleInputChange,currentOnChangeInput);

                if(!isNullOrEmpty(inputValues[`txtRoundTripDay${id_n}`])){
                    subCatInputOnChange(
                        inputValues,
                        id_n,
                        "txtRoundTripDay",
                        handleInputChange,
                        inputValues["txtRoundTripDay"],
                        bindDDL,
                        handleBindDDL,
                    );
                } 
            }
            break;
        case "hidTaxChk":
            // taxcompulsorychk = localStorage.getItem("TaxCompulsory");
            // //Hide Check box
            // if (currentOnChangeInput == 1) {
            //     if (taxcompulsorychk == "No") {
            //         $("#taxcodechecking" + i).hide();
            //         $("#txtcoderate" + i).val(0.00);
            //     } else if (taxcompulsorychk == "Yes") {
            //         let numoftax = 0
            //         let numofhidetax = 1 //Initially start with one since user had click one to hide
            //         let divTaxChkBoxes = document.querySelectorAll<HTMLElement>(".div_TaxChkBox");
            //         //Find out how many element tax which got value
            //         //Then find out how many is being hide
            //         //At least one must be show in the user interface
            //         for (let k = 1; k < (divTaxChkBoxes.length + 1); k++) {
            //             if (inputValues[`ddlTaxCode${k}_${id_n}`] > 0) {
            //                 numoftax = numoftax + 1;
            //                 if ($("#ddlTaxCode" + k + "_" + j).prop("checked")) {
            //                     numofhidetax = numofhidetax + 1;
            //                 }
            //             }
            //         }

            //         if (numoftax > 1) {
            //             if ((numoftax - numofhidetax) >= 1) {
            //                 $("#taxcodechecking" + i).hide();
            //                 $('#txtcoderate' + i).val(0.00);
            //             }

            //             if ((numoftax - numofhidetax) == 1) {
            //                 $('input[type=checkbox][name=hidetaxchkbox]:not(:checked)').attr("disabled", "true");
            //             }
            //         }
            //     }
            // } else {
            //     CalTaxAmount("ddlTaxCode" + id_n, "txtcoderate" + i);
            //     $("#taxcodechecking" + i).show();
            //     $('input[type=checkbox][name=hidetaxchkbox]:not(:checked)').removeAttr("disabled");
            // }
            break;
        case "ddlTaxCodeCN":
            taxcompulsorychk = localStorage.getItem("TaxCompulsory");
            let divTaxChkBoxes = document.querySelectorAll<HTMLElement>(".div_TaxChkBox");
            for (let k2 = 1; k2 < (divTaxChkBoxes.length + 1); k2++) {

                let k = k2;

                //user did not select any tax / optional tax
                if (currentOnChangeInput == 0) {
                    if (taxcompulsorychk == "No") {
                        handleInputChange(`txtcoderateCN_${id_n}`, 0.00);
                        disableInput(`#txtcoderateCN_${id_n}`, true, "text");
                        // //if tax is 0 make the txtcode uneditable
                        // $('#txtcoderateCN_' + j).attr("disabled", "true");
                        // //find unchecked taxbox and check it to make it 0.00
                        // if ($("#hideTaxChk" + k + "_" + j).prop("checked") == false) {
                        //     $("#hideTaxChk" + k + "_" + j).prop('checked', true).triggerHandler('click');
                        // }
                        // if(inputValues[`hideTaxChk${k}_${id_n}`] == 0){
                        //     handleInputChange(`hideTaxChk${k}_${id_n}`, 1);
                        //     subCatInputOnChange(
                        //         inputValues,
                        //         id_n,
                        //         "hidTaxChk",
                        //         handleInputChange,
                        //         1,
                        //         bindDDL,
                        //         handleBindDDL,
                        //     );
                            
                        // }
                    }
                } else {
                    //if tax is not 0 make txtcoderate editable
                    disableInput(`#txtcoderateCN_${id_n}`, false, "text");
                }

                if (inputValues[`ddlTaxCode${k}_${id_n}`] != currentOnChangeInput) {
                    //check for tax that do not match and check as not applicable
                    if (inputValues[`hideTaxChk${k}_${id_n}`] == 0) {
                        handleInputChange(`hideTaxChk${k}_${id_n}`, 1);
                        // $("#hideTaxChk" + k + "_" + j).prop('checked', true).triggerHandler('click');
                    }

                } else {
                    //check for tax that match and uncheck
                    if (inputValues[`hideTaxChk${k}_${id_n}`] == 1) {
                        handleInputChange(`hideTaxChk${k}_${id_n}`, 0);
                        // $("#hideTaxChk" + k + "_" + j).prop('checked', false).triggerHandler('click');
                        elementDisplay(`#taxcodechecking${k}_${id_n}`, false, "div");
                    }
                }
            }
            checkAndAutoCalTax(id_n!,inputValues,handleInputChange,objectRequestor,objAttachment);
            break;
        case "ddlForm":          
            if (currentOnChangeInput && objDDL.length > 0) {
                const index = objDDL.find((p:any) => p.value == currentOnChangeInput).index;
                if (index > -1) {

                    handleInputChange(`txtClaimAmount${id_n}`, objDDL[index].amount);
                    handleInputChange(`txtBusinessRationaleProvideToExternal${id_n}`, objDDL[index].reason);
                }
                if (objDDL[index] && objDDL[index].name.includes("Medical Advance IOU")) {
                    subCatInputOnChange(inputValues, id_n, "ddlCashAdvanceType", handleInputChange, "A01",bindDDL,
                    handleBindDDL,);
                    disableInput(`#ddlCashAdvanceType${id_n}`, true, "select");
                } else if (objDDL[index] && objDDL[index].name.includes("Medical Cash Advance")) {
                    subCatInputOnChange(inputValues, id_n, "ddlCashAdvanceType", handleInputChange, "A02",bindDDL,
                    handleBindDDL,);
                    disableInput(`#ddlCashAdvanceType${id_n}`, true, "select");
                } else {
                    disableInput(`#ddlCashAdvanceType${id_n}`, false, "select");
                }
            }
            break;
        case "ddlCashAdvanceType":
            // Saber Amendment 20260818 [#SR-1022951]: Align PH override where A02 does not require Form.
            if (
                objectRequestor?.country_code == "PH" &&
                inputValues[`ddlCategory${id_n}`]?.toString() == "46"
            ) {
                if (currentOnChangeInput == "A02") {
                    mandatoryInput(`#ddlForm${id_n}`, false, "select");
                } else {
                    mandatoryInput(`#ddlForm${id_n}`, true, "select");
                }
            }
            break;
         case "ddlGiftCountry":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                //GetGiftCity Callback
                inputValues[`ddlGiftCity${id_n}`] != '' && handleInputChange(`ddlGiftCity${id_n}`, '');
                // handleInputChange(`newDDLCallback`, 'ddlGiftCity');
                handleBindDDL && handleBindDDL(`giftCityDDL`,await dropdownMappings[DROPDOWN_NAME.City]({ country_code: currentOnChangeInput }));


                if (currentOnChangeInput == 'OTH') {
                    elementDisplay(`#othGiftCountry${id_n}`, true, "div");
                    mandatoryInput(`#txtGiftCountry${id_n}`, true, "text");

                    inputValues[`ddlGiftCity${id_n}`] != "OTHER" && handleInputChange(`ddlGiftCity${id_n}`, "OTHER");
                    elementDisplay(`#othGiftCity${id_n}`, true, "div");
                    mandatoryInput(`#txtGiftCity${id_n}`, true, "text");
                } else {
                    elementDisplay(`#othGiftCountry${id_n}`, false, "div");
                    mandatoryInput(`#txtGiftCountry${id_n}`, false, "text");

                    if (!isNullOrEmpty(objAttachment)) {
                        inputValues[`ddlGiftCity${id_n}`] != objAttachment?.gift_city && handleInputChange(`ddlGiftCity${id_n}`, objAttachment?.gift_city);
                        inputValues[`txtGiftCity${id_n}`] != objAttachment?.other_gift_city && handleInputChange(`txtGiftCity${id_n}`, objAttachment?.other_gift_city);
                    }

                    elementDisplay(`#othGiftCity${id_n}`, false, "div");
                    mandatoryInput(`#txtGiftCity${id_n}`, false, "text");
                }

            }
            break;
        case "ddlGiftCity":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                if (currentOnChangeInput.toUpperCase() == 'OTHER') {
                    elementDisplay(`#othGiftCity${id_n}`, true, "div");
                    mandatoryInput(`#txtGiftCity${id_n}`, true, "text");
                } else {
                    inputValues[`txtGiftCity${id_n}`] != '' && handleInputChange(`txtGiftCity${id_n}`, '');
                    elementDisplay(`#othGiftCity${id_n}`, false, "div");
                    mandatoryInput(`#txtGiftCity${id_n}`, false, "text");
                }
            }
            break;
        case "txtStartDateTime":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                const endDateTime = !isNullOrEmpty(inputValues[`txtEndDateTime${id_n}`]) ? inputValues[`txtEndDateTime${id_n}`] : new Date();
                calPerDiemDate(id_n, inputValues, handleInputChange, currentOnChangeInput, endDateTime);
                handleInputChange(`txtStartDate${id_n}`, currentOnChangeInput);
            }
            break;
        case "txtEndDateTime":
            if (!isNullOrEmpty(currentOnChangeInput)) {
                const startDateTime = !isNullOrEmpty(inputValues[`txtStartDateTime${id_n}`]) ? inputValues[`txtStartDateTime${id_n}`] : new Date();
                calPerDiemDate(id_n, inputValues, handleInputChange, startDateTime, currentOnChangeInput);
                handleInputChange(`txtEndDate${id_n}`, currentOnChangeInput);
            }
            break;
        case "txtPerDiemLocationSPR":
            if(!isNullOrEmpty(currentOnChangeInput)){
                
                let local_currency_code = inputValues[`${currentOnChangeInput}_currency_code`];
                let foreign_currency_code = inputValues[`${currentOnChangeInput}_currency_code`];
                let location_type = inputValues[`${currentOnChangeInput}_location_type`];

                if (location_type == 'LOCAL') {
                    handleInputChange(`ddlCurrency${id_n}`, local_currency_code);
                } else if (location_type == 'ABROAD') {
                    handleInputChange(`ddlCurrency${id_n}`, foreign_currency_code);
                }
            }
            break;
        case "ddlCreditCardStatement":
            if(!isNullOrEmpty(currentOnChangeInput)){
                bindCCInfo(id_n,currentOnChangeInput, inputValues, handleInputChange, objectRequestor, objDDL);
            }
            break;
        case "chkbx_TaxNotApply":
            if (objectRequestor.country_code == 'IN') {
                if(!isNullOrEmpty(currentOnChangeInput)){
                    if (currentOnChangeInput == "1") {
                        elementDisplay(`.div_TaxNotApplicable${id_n}`, false, "div");
                        mandatoryInput(`#txtVendorGSTNumber_IN_${id_n}`, false, "text");
                        mandatoryInput(`#txt_InvoiceNumber_IN_${id_n}`, false, "text");
                        mandatoryInput(`#txt_E_InvoiceNumber_IN_${id_n}`, false, "text");
                    } else {
                        elementDisplay(`.div_TaxNotApplicable${id_n}`, true, "div");
                        mandatoryInput(`#txtVendorGSTNumber_IN_${id_n}`, true, "text");
                        mandatoryInput(`#txt_InvoiceNumber_IN_${id_n}`, true, "text");
                        mandatoryInput(`#txt_E_InvoiceNumber_IN_${id_n}`, true, "text");
                    }
                }
            }
            break;
        case "ddlDetailType":
            if(objectRequestor.country_code == 'TH' || objectRequestor.country_code == 'LA' || objectRequestor.country_code == 'JP'){                
            //     if (!isNullOrEmpty(currentOnChangeInput)) {

            //         let selectedText = bindDDL?.[`detailTypeDDL`]?.find((option: any) => option.value.toString() == currentOnChangeInput).label;
            //         if (!isNullOrEmpty(selectedText) && selectedText.replace(/'/g, "") == "Death benefit for staffs family") { //Terk Amendment 20250624 #SR-752550 // //Terk Amendment 20250624 #SR-804750
            //             elementDisplay(".divIdOfDeceasedPerson" , true , "div");
            //         }
            //         else {
            //             elementDisplay(".divIdOfDeceasedPerson" , false , "div");
            //             handleInputChange(`txtIdofDeceasedPerson${id_n}`, "");
            //         }

            //         //Thailand Invoice feature
            //         if (objectRequestor.country_code == 'TH') {
            //             enable_Disable_VAT_WHT_OnLoad(
            //                 id_n,
            //                 inputValues,
            //                 handleInputChange,
            //                 objAttachment,
            //             );

            //             loadInvoice_Number(
            //                 id_n,
            //                 inputValues,
            //                 handleInputChange,
            //                 objAttachment
            //             );
            //         }
            //     }

            //     if (!isNullOrEmpty(objAttachment?.detail_type)) {
            //         handleInputChange(`ddlDetailType${id_n}`, objAttachment?.detail_type);
            //     }
            //     if (!isNullOrEmpty(objAttachment?.idofdeceasedperson)) {
            //         handleInputChange(`txtIdofDeceasedPerson${id_n}`, objAttachment?.idofdeceasedperson);
            //         let selectedText = bindDDL?.[`detailTypeDDL`]?.find((option: any) => option.value.toString() == objAttachment?.idofdeceasedperson).label;
            //         if (!isNullOrEmpty(selectedText) && selectedText.replace(/'/g, "") == "Death benefit for staffs family") { //Terk Amendment 20250624 #SR-752550 // //Terk Amendment 20250624 #SR-804750
            //             mandatoryInput(`#txtIdofDeceasedPerson${id_n}` , true , "text");
            //         }
            //     }
            // }
                // Hazel Amendment 20251103 - Refactor invoice field for TH and KH 
                await updateDetailType(id_n!, currentOnChangeInput.toString(), inputValues, handleInputChange, objAttachment,bindDDL );
            }
            if (!isNullOrEmpty(currentOnChangeInput) && currentOnChangeInput.toString() == '11') {
                elementDisplay(`#FromStation${id_n}`, true, "div");
                mandatoryInput(`#txtFromStation${id_n}`, true, "text");
                elementDisplay(`#ToStation${id_n}`, true, "div");
                mandatoryInput(`#txtToStation${id_n}`, true, "text");
                elementDisplay(`#TicketType${id_n}`, true, "div");
                mandatoryInput(`#ddlTicketType${id_n}`, true, "select");
                elementDisplay(`#StartTripDate${id_n}`, true, "div");
                mandatoryInput(`#txtStartTripDate${id_n}`, true, "text");
                elementDisplay(`#EndTripDate${id_n}`, true, "div");
                mandatoryInput(`#txtEndTripDate${id_n}`, true, "text");

                if (objAttachment) {
                    if (objAttachment.start_trip_date == null) {
                        handleInputChange(`txtStartTripDate${id_n}`, "");
                    }
                    if (objAttachment.end_trip_date == null) {
                        handleInputChange(`txtEndTripDate${id_n}`, "");
                    }
                }
            } else {
                elementDisplay(`#FromStation${id_n}`, false, "div");
                mandatoryInput(`#txtFromStation${id_n}`, false, "text");
                elementDisplay(`#ToStation${id_n}`, false, "div");
                mandatoryInput(`#txtToStation${id_n}`, false, "text");
                elementDisplay(`#TicketType${id_n}`, false, "div");
                mandatoryInput(`#ddlTicketType${id_n}`, false, "select");
                handleInputChange(`ddlTicketType${id_n}`, "");
                elementDisplay(`#StartTripDate${id_n}`, false, "div");
                mandatoryInput(`#txtStartTripDate${id_n}`, false, "text");
                elementDisplay(`#EndTripDate${id_n}`, false, "div");
                mandatoryInput(`#txtEndTripDate${id_n}`, false, "text");
            }
            subCatInputOnChange(
                inputValues,
                id_n,
                "ddlTicketType",
                handleInputChange,
                inputValues[`ddlTicketType${id_n}`],
                bindDDL,
                handleBindDDL,
            );
            break;
        case "txtNumberOfCashCard":
            if(!isNullOrEmpty(currentOnChangeInput)){
                let cashCardLimit = !isNullOrEmpty(localStorage.getItem("CashCardLimit")) ? localStorage.getItem("CashCardLimit") : "0";
                let amount = parseFloat((currentOnChangeInput? currentOnChangeInput.toString() : "0")) * parseFloat(cashCardLimit || "0");
                handleInputChange(`txtClaimAmount${id_n}`, smartRound(amount,decimalRemove()));
                subCatInputOnChange(
                inputValues,
                id_n,
                "txtClaimAmount",
                handleInputChange,
                amount.toFixed(decimalRemove()),
                bindDDL,
                handleBindDDL,
                );
                handleInputChange(`hidden_Init_claim_Amount${id_n}`, amount.toFixed(decimalRemove()));
                handleInputChange(`hidden_WHT_Amount${id_n}`, 0);
                handleInputChange(`hidden_WHT_Amount2${id_n}`, 0);
                handleInputChange(`hidden_VAT_Amount${id_n}`, 0);
                checkAndAllowZeroAttach(id_n,inputValues,handleInputChange);
            }
            break;
        case "ddlTicketType":
            if(!isNullOrEmpty(currentOnChangeInput)){
                if (currentOnChangeInput == '1') {
                    elementDisplay(`#RoundTripDay${id_n}`, true, "div" );
                    mandatoryInput(`#txtRoundTripDay${id_n}`, true, "text");
                    elementDisplay(`#AmountPerDay${id_n}`, true, "div");
                    mandatoryInput(`#txtAmountPerDay${id_n}`, true, "text");
                } else {
                    elementDisplay(`#RoundTripDay${id_n}`, false, "div");
                    mandatoryInput(`#txtRoundTripDay${id_n}`, false, "text");
                    elementDisplay(`#AmountPerDay${id_n}`, false, "div");
                    mandatoryInput(`#txtAmountPerDay${id_n}`, false, "text");
                }
            }
            break;
        case "txtRoundTripDay":
            if(!isNullOrEmpty(currentOnChangeInput)){
                let claimAmount = parseFloat(inputValues[`txtClaimAmount${id_n}`].toString() || "0");
                 if (claimAmount> 0) {
                    let amountperday = claimAmount / parseFloat(currentOnChangeInput.toString());
                    handleInputChange(`txtAmountPerDay${id_n}`, amountperday.toFixed(2));
                }
            }
            break;
        case "ddlWellnessType": {
            // CHN-22431 [TH] PDP: training date only for TH + category 50 + wellness type 11
            const inputCategoryValue = inputValues[`ddlCategory${id_n}`];
            const categoryValue = !isNullOrEmpty(inputCategoryValue)
                ? inputCategoryValue
                : objAttachment?.subcategory_id;
            const showTrainingDate = objectRequestor?.country_code == "TH"
                && categoryValue?.toString() == "50"
                && currentOnChangeInput?.toString() == "11";

            elementDisplay(`#TrainingDate${id_n}`, showTrainingDate, "div");
            mandatoryInput(`#txtTrainingDate${id_n}`, showTrainingDate, "text");

            if (!showTrainingDate) {
                handleInputChange(`txtTrainingDate${id_n}`, null);
            }

            // EEC source of truth: show dental disclaimer only for SG + wellness type 7 (Dental).
            // Auto-tick on initial bind/load only; user type-change leaves it unchecked.
            const isSgDentalDisclaimer =
                objectRequestor?.country_code == "SG" &&
                !isNullOrEmpty(currentOnChangeInput) &&
                currentOnChangeInput.toString() == "7";

            elementDisplay(`#divWellnessDentalDisclaimer_${id_n}`, isSgDentalDisclaimer, "div");
            handleInputChange(
                `chkWellnessDentalDisclaimer_${id_n}`,
                isSgDentalDisclaimer && isLoadRestore ? "1" : "0"
            );
            break;
        }
        case "rdExpenseNature":
            // handleInputChange(`txtClaimAmount${id_n}`, 0.00);
            loadTaxCol(id_n!, inputValues, handleInputChange, addValue, objAttachment, objectRequestor, inputValues[`isDateRange`] == "1" ? inputValues[`txtStartDate${id_n}`] : inputValues[`txtDate${id_n}`], handleBindDDL, bindDDL);
            break;
        case "rdServiceOrderType":
            if(!isNullOrEmpty(currentOnChangeInput)){
                soReset(currentOnChangeInput == "percentage" ? `txtSOPercentageSO${id_n}` : `txtSOAmountSO${id_n}`,  handleInputChange);
            }
            break;
        case "ddlEmployeeAttendanceExceeds":
            if(!isNullOrEmpty(currentOnChangeInput)){
                if(currentOnChangeInput == "1") {
                    elementDisplay(`#div_totalNumberOfEmployeeAttendance${id_n}`, true, "div");
                    elementDisplay(`#div_EmployeesAttendance${id_n}`, false, "div");
                    handleInputChange(`ddlEmployeeAttendance${id_n}`, "");
                    subCatInputOnChange(
                        inputValues,
                        id_n,
                        "ddlEmployeeAttendance",
                        handleInputChange,
                        "",
                        bindDDL,
                        handleBindDDL,
                    );
                }
                else {
                    elementDisplay(`#div_totalNumberOfEmployeeAttendance${id_n}`, false, "div");
                    elementDisplay(`#div_EmployeesAttendance${id_n}`, true, "div");
                    handleInputChange(`txtLocalReceive${id_n}`, "");
                }
            }
            break;
        case "ddlIsMealForBusinessPurpose":
            if(!isNullOrEmpty(currentOnChangeInput)){
                if(currentOnChangeInput == "2") {
                    elementDisplay(`#div_mealForBusinessPurposeAmount${id_n}`, true, "div");
                }
                else {
                    elementDisplay(`#div_mealForBusinessPurposeAmount${id_n}`, false, "div");
                    handleInputChange(`txtMealForBusinessPurposeAmount${id_n}`, "");
                }
            }
            break;
        case "ddlIsPersonalClaim":
            if(!isNullOrEmpty(currentOnChangeInput)){
                if(currentOnChangeInput == "1") {
                    elementDisplay(`#div_personalUseQuantumExpenditure${id_n}`, true, "div");
                    elementDisplay(`#div_personalUseReason${id_n}`, true, "div");

                }
                else {
                    elementDisplay(`#div_personalUseQuantumExpenditure${id_n}`, false, "div");
                    elementDisplay(`#div_personalUseReason${id_n}`, false, "div");

                    handleInputChange(`txtPersonalUseQuantumExpenditure${id_n}`, "");
                    handleInputChange(`txtPersonalUseReason${id_n}`, "");
                }
            }
            break;
        case "ddlRecoverable":
            if (currentOnChangeInput == 1) {
                if (objectRequestor.intercomp == 1) {
                    elementDisplay(`#divRadioRecoverable${id_n}`, true, "div");
                }
                //Saber,2026-10-09 , Default to Client radio so Recoverable Special GL is shown and required (blank caused posting key 21, claim EECMY260930612EC)
                if (inputValues[`radio_coverable2_${id_n}`] != 1) {
                    handleInputChange(`radio_coverable1_${id_n}`, 1);
            
                    //Showing list
                    elementDisplay(`#recoverable${id_n}`, true, "div");
                    mandatoryInput(`#txtRecoverable${id_n}`, true, "text");
                    elementDisplay(`#divRecoverabletxt${id_n}`, true, "div");
            
                    //enable recovery SPecial GL
                    elementDisplay(`#divRecoverableSpecialGL_${id_n}`, true, "div");
                    mandatoryInput(`#ddlRecoverableSpecialGL${id_n}`, true, "select");
            
                    //Hide list
                    elementDisplay(`#divRecoverableInterComp${id_n}`, false, "div");
                    mandatoryInput(`#txtInterCompRecoverable${id_n}`, false, "text");
                    handleInputChange(`txtInterCompRecoverable${id_n}`, '');
            
                } else if (inputValues[`radio_coverable2_${id_n}`] == 1) {
            
                    //Showing list
                    elementDisplay(`#divRecoverableInterComp${id_n}`, true, "div");
                    mandatoryInput(`#txtInterCompRecoverable${id_n}`, true, "text");
            
                    //hide list
                    elementDisplay(`#recoverable${id_n}`, false, "div");
                    mandatoryInput(`#txtRecoverable${id_n}`, false, "text");
                    handleInputChange(`txtRecoverable${id_n}`, '');
                    elementDisplay(`#divRecoverabletxt${id_n}`, false, "div");
            
                    //Saber,2026-10-09 , Fixed element id (removed underscore) so required flag and value clear apply to the real dropdown
                    elementDisplay(`#divRecoverableSpecialGL_${id_n}`, false, "div");
                    mandatoryInput(`#ddlRecoverableSpecialGL${id_n}`, false, "select");
                    handleInputChange(`ddlRecoverableSpecialGL${id_n}`, '');
            
                }
            
                elementDisplay(`#divCostCenter${id_n}`, false, "div");
                elementDisplay(`#divProjectCode_${id_n}`, false, "div");
            
                shrinkCostCenter(`ddlCC1_${id_n}`, 1, inputValues, handleInputChange);
                shrinkCostCenter(`ddlCC2_${id_n}`, 1, inputValues, handleInputChange);
                shrinkCostCenter(`ddlCC3_${id_n}`, 1, inputValues, handleInputChange);
                shrinkCostCenter(`ddlCC4_${id_n}`, 1, inputValues, handleInputChange);
                shrinkCostCenter(`ddlCC5_${id_n}`, 1, inputValues, handleInputChange);
                shrinkCostCenter(`ddlCC6_${id_n}`, 1, inputValues, handleInputChange);
            
                //20cc clear the value of the fields of cost center
                for (let iCounter = 1; iCounter < 7; iCounter++) {
                    handleInputChange(`ddlCC${iCounter}_${id_n}`, '');
                    handleInputChange(`txtCCPercent${iCounter}_${id_n}`, '');
                }
            
                //("Select yes if you are 4PL employee (claiming from client) or to recover from external party");
                elementDisplay(`#recoveryMessage`, true, "div");
            
                // RecoverableSpecialItem(objRequestor, arrayNumber);
            
            } else {
                elementDisplay(`#divCostCenter${id_n}`, true, "div");
                elementDisplay(`#divProjectCode_${id_n}`, true, "div");
            
                elementDisplay(`#recoverable${id_n}`, false, "div");
                mandatoryInput(`#txtRecoverable${id_n}`, false, "text");
                handleInputChange(`txtRecoverable${id_n}`, '');

                //Saber,2026-10-09 , Fixed element id (removed underscore)
                elementDisplay(`#divRecoverableSpecialGL_${id_n}`, false, "div");
                mandatoryInput(`#ddlRecoverableSpecialGL${id_n}`, false, "select");
                handleInputChange(`ddlRecoverable${id_n}`, 0);
                elementDisplay(`#divRadioRecoverable${id_n}`, false, "div");

                elementDisplay(`#divRecoverableInterComp${id_n}`, false, "div");
                mandatoryInput(`#txtInterCompRecoverable${id_n}`, false, "text");
                handleInputChange(`txtInterCompRecoverable${id_n}`, '');

                elementDisplay(`#divRadioRecoverable${id_n}`, false, "div");
            }
            break;
        case "ddlVAT":
            if (currentOnChangeInput == 1) {
                show_VAT_Section(id_n!, handleInputChange);
                //Hardcode tax rate and tax code
                disableInput(`#txtBaseAmount${id_n}`, true, "text");
                handleInputChange(`txtVAtPercentage${id_n}`, 7);
                disableInput(`#txtVAtPercentage${id_n}`, true, "text");
                document.querySelector(`#txtVAtPercentage${id_n}`)?.setAttribute('VATTaxCode', 'V7');
                enableBaseAmount(id_n,inputValues);

            }
            else{
                hide_VAT_Section(id_n!, handleInputChange);
                handleInputChange(`txtBaseAmount${id_n}`, 0);
                handleInputChange(`txtVAtPercentage${id_n}`, 0);
                document.querySelector(`#txtVAtPercentage${id_n}`)?.setAttribute('VATTaxCode', '');
            }
            calculate_ClaimAmount(id_n, "ddlVAT", {...inputValues, [`ddlVAT${id_n}`] : currentOnChangeInput}, handleInputChange);
            enableBaseAmount(id_n,inputValues);
            break;
        case "ddlWHT":
            if (currentOnChangeInput == 1) {
                show_WHT_Section(id_n!, {...inputValues, [`ddlWHT${id_n}`] : currentOnChangeInput}, handleInputChange);
                //Hardcode tax rate and tax code
                enableBaseAmount(id_n,inputValues);
                elementDisplay(`#div_WHT_ddl2${id_n}`, true, "div");
                handleInputChange(`ddlWHT2${id_n}`, 0);

            }
            else{
                hide_WHT_Section(id_n!, {...inputValues, [`ddlWHT${id_n}`] : currentOnChangeInput}, handleInputChange);
                handleInputChange(`txtWHTAmount${id_n}`, 0);
                document.querySelector(`#txtWHTPercentage${id_n}`)?.setAttribute('WHTTaxCode', '');
                elementDisplay(`#div_WHT_ddl2${id_n}`, false, "div");
            }
            handleInputChange(`txtPayToComp${id_n}`, 1);
            handleInputChange(`txtPayToPerson${id_n}`, 0);
            disableInput(`#txtWHTAmount${id_n}`, true, "text");

            document.querySelector(`#txtWHTPercentage${id_n}`)?.setAttribute('WHTTaxCode', 'VX');
            if(isElementVisible(`#divWHT_TypeOne${id_n}`)){
                handleInputChange(`txtWHTPercentage${id_n}`, 1);
                disableInput(`#txtWHTPercentage${id_n}`, true, "text");
            }
            else if ( isElementVisible(`#divWHT_TypeThree${id_n}`)) {
                handleInputChange(`txtWHTPercentage${id_n}`, 3);
                disableInput(`#txtWHTPercentage${id_n}`, true, "text");
            }
            else if ( isElementVisible(`#divWHT_TypeFive${id_n}`)) {
                handleInputChange(`txtWHTPercentage${id_n}`, 5);
                disableInput(`#txtWHTPercentage${id_n}`, true, "text");
            }
            calculate_ClaimAmount(id_n, "ddlWHT", {...inputValues, [`ddlWHT${id_n}`] : currentOnChangeInput}, handleInputChange);
            enableBaseAmount(id_n,inputValues);
            break;
        case "ddlWHT2":
            if (currentOnChangeInput == 1) {
                elementDisplay(`#divWHT_Type2${id_n}`, true, "div");
                elementDisplay(`#divWHT_TypeOne2${id_n}`, true, "div");
                elementDisplay(`#divWHT_TypeThree2${id_n}`, true, "div");
                elementDisplay(`#divWHT_TypeFive2${id_n}`, true, "div");
                elementDisplay(`#divWHT_BaseAmount2${id_n}`, true, "div");
                show_WHT_Rates(id_n, {...inputValues , [`ddlWHT2${id_n}`] : currentOnChangeInput}, handleInputChange);

                handleInputChange(`txtWHTAmount${id_n}`, '');
                handleInputChange(`txtWHTAmount2${id_n}`, '');

            }
            else{
                elementDisplay(`#divWHT_Type2${id_n}`, false, "div");
                elementDisplay(`#divWHT_TypeOne2${id_n}`, false, "div");
                elementDisplay(`#divWHT_TypeThree2${id_n}`, false, "div");
                elementDisplay(`#divWHT_TypeFive2${id_n}`, false, "div");
                elementDisplay(`#divWHT_BaseAmount2${id_n}`, false, "div");

                handleInputChange(`txtWHTAmount2${id_n}`, 0);
                handleInputChange(`txtWHTPercentage2${id_n}`, 0);
                document.querySelector(`#txtWHTPercentage2${id_n}`)?.setAttribute('WHTTaxCode', '');
            }
            document.querySelector(`#txtWHTPercentage2${id_n}`)?.setAttribute('WHTTaxCode', 'VX');
            calculate_ClaimAmount(id_n, "ddlWHT2", {...inputValues, [`ddlWHT2${id_n}`] : currentOnChangeInput}, handleInputChange);
            enableBaseAmount(id_n,{...inputValues , [`ddlWHT2${id_n}`] : currentOnChangeInput});
            break;
        case "PayToPerson":
            if (currentOnChangeInput == 1) {
                handleInputChange(`txtPayToPerson${id_n}`, 1);
                handleInputChange(`txtPayToComp${id_n}`, 0);
                elementDisplay(`#lblWHTPersonName${id_n}`, true, "div");
                elementDisplay(`#lblWHTCompName${id_n}`, false, "div");

                handleInputChange(`ddlWHT2${id_n}`, 0);
                subCatInputOnChange(
                    inputValues,
                    id_n,
                    "ddlWHT2",
                    handleInputChange,
                    0,
                    bindDDL,
                    handleBindDDL,
                );
                disableInput(`#ddlWHT2${id_n}`, true, "select");

            }
            else{
                 handleInputChange(`txtPayToComp${id_n}`, 1);
                 handleInputChange(`txtPayToPerson${id_n}`, 0);
                 elementDisplay(`#lblWHTPersonName${id_n}`, false, "div");
                 elementDisplay(`#lblWHTCompName${id_n}`, true, "div");

                disableInput(`#ddlWHT2${id_n}`, false, "select");
            }
            break;
        case "PayToComp":
            if (currentOnChangeInput == 1) {

                handleInputChange(`txtPayToComp${id_n}`, 1);
                handleInputChange(`txtPayToPerson${id_n}`, 0);
                elementDisplay(`#lblWHTPersonName${id_n}`, false, "div");
                elementDisplay(`#lblWHTCompName${id_n}`, true, "div");

                disableInput(`#ddlWHT2${id_n}`, false, "select");

            }
            else{
                handleInputChange(`txtPayToPerson${id_n}`, 1);
                handleInputChange(`txtPayToComp${id_n}`, 0);
                elementDisplay(`#lblWHTPersonName${id_n}`, true, "div");
                elementDisplay(`#lblWHTCompName${id_n}`, false, "div");
            }
            break;
        case "OnePer":
            if (currentOnChangeInput == 1) {
                handleInputChange(`txtOnePerc${id_n}`, 1);
                handleInputChange(`txtThreePerc${id_n}`, 0);
                handleInputChange(`txtFivePer${id_n}`, 0);
                handleInputChange(`txtWHTPercentage${id_n}`, 1);
                disableInput(`#txtWHTPercentage${id_n}`, true, "text");
                document.querySelector(`#txtWHTPercentage${id_n}`)?.setAttribute('WHTTaxCode', 'VX');
                calculate_ClaimAmount(id_n, "", {...inputValues, [`txtWHTPercentage${id_n}`] : 1}, handleInputChange);
            }
            break;
        case "ThreePer":
            if (currentOnChangeInput == 1) {
                handleInputChange(`txtOnePerc${id_n}`, 0);
                handleInputChange(`txtThreePerc${id_n}`, 1);
                handleInputChange(`txtFivePer${id_n}`, 0);
                handleInputChange(`txtWHTPercentage${id_n}`, 3);
                disableInput(`#txtWHTPercentage${id_n}`, true, "text");
                document.querySelector(`#txtWHTPercentage${id_n}`)?.setAttribute('WHTTaxCode', 'VX');
                calculate_ClaimAmount(id_n, "", {...inputValues, [`txtWHTPercentage${id_n}`] : 3}, handleInputChange);
            }
            break;
        case "FivePer":
            if (currentOnChangeInput == 1) {
                handleInputChange(`txtOnePerc${id_n}`, 0);
                handleInputChange(`txtThreePerc${id_n}`, 0);
                handleInputChange(`txtFivePer${id_n}`, 1);
                handleInputChange(`txtWHTPercentage${id_n}`, 5);
                disableInput(`#txtWHTPercentage${id_n}`, true, "text");
                document.querySelector(`#txtWHTPercentage${id_n}`)?.setAttribute('WHTTaxCode', 'VX');
                calculate_ClaimAmount(id_n, "", {...inputValues, [`txtWHTPercentage${id_n}`] : 5}, handleInputChange);
            }
            break;
        case "OnePer2":
            if (currentOnChangeInput == 1) {
                handleInputChange(`txtOnePerc2${id_n}`, 1);
                handleInputChange(`txtThreePerc2${id_n}`, 0);
                handleInputChange(`txtFivePer2${id_n}`, 0);
                handleInputChange(`txtWHTPercentage2${id_n}`, 1);
                disableInput(`#txtWHTPercentage2${id_n}`, true, "text");
                document.querySelector(`#txtWHTPercentage2${id_n}`)?.setAttribute('WHTTaxCode', 'VX');
                calculate_ClaimAmount(id_n, "", {...inputValues, [`txtWHTPercentage2${id_n}`] : 1}, handleInputChange);
            }
            break;
        case "ThreePer2":
            if (currentOnChangeInput == 1) {
                handleInputChange(`txtOnePerc2${id_n}`, 0);
                handleInputChange(`txtThreePerc2${id_n}`, 1);
                handleInputChange(`txtFivePer2${id_n}`, 0);
                handleInputChange(`txtWHTPercentage2${id_n}`, 3);
                disableInput(`#txtWHTPercentage2${id_n}`, true, "text");
                document.querySelector(`#txtWHTPercentage2${id_n}`)?.setAttribute('WHTTaxCode', 'VX');
                calculate_ClaimAmount(id_n, "", {...inputValues, [`txtWHTPercentage2${id_n}`] : 3}, handleInputChange);
            }
            break;
        case "FivePer2":
            if (currentOnChangeInput == 1) {
                handleInputChange(`txtOnePerc2${id_n}`, 0);
                handleInputChange(`txtThreePerc2${id_n}`, 0);
                handleInputChange(`txtFivePer2${id_n}`, 1);
                handleInputChange(`txtWHTPercentage2${id_n}`, 5);
                disableInput(`#txtWHTPercentage2${id_n}`, true, "text");
                document.querySelector(`#txtWHTPercentage2${id_n}`)?.setAttribute('WHTTaxCode', 'VX');
                calculate_ClaimAmount(id_n, "", {...inputValues, [`txtWHTPercentage2${id_n}`] : 5}, handleInputChange);
            }
            break;
        default:
            break;
    }

    return null;
};

export async function filterVendorCode(id_n: number, filterText:string, objectRequestor: any, handleBindDDL: (id: string, value?: any) => void){
    let recoverableContent =  filterText;
    
    if (!isNullOrEmpty(recoverableContent) && recoverableContent.length >= 3) {
        handleBindDDL(`vendorCodeDDL`, await dropdownMappings[DROPDOWN_NAME.VendorCode](objectRequestor, "", false, recoverableContent));
        // GetDDLDataVendorCode(recoverableContent, function (data) {

        //     data.sort(function (a, b) {
        //         return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
        //     });

        //     $(data).each(function (id_n, d1) {
        //         $('#lstRecoverableOthers' + cat_id_n).append($('<option></option>').attr('value', d1.id).attr('label', d1.text).html(d1.text));
        //     });

        //     elem.autocomplete({
        //         source: list.children().map(function () {
        //             return $(this).text();
        //         }).get()

        //         ,
        //         select: function (event, ui) {

        //             $('#txtRecoverable' + cat_id_n).val($('#lstRecoverableOthers' + cat_id_n + ' option[label="' + ui.item.value + '"]').attr('value'));

        //             if (ui.item.value == "Others") {

        //                 $("#divRecoverableOthers" + cat_id_n).show();
        //                 $('#ddlRecoverableOthers' + cat_id_n).prop('required', true);
        //             }
        //             else {

        //                 $("#divRecoverableOthers" + cat_id_n).hide();
        //                 $('#ddlRecoverableOthers' + cat_id_n).prop('required', false);
        //                 $('#ddlRecoverableOthers' + cat_id_n).removeClass('is-invalid');
        //             }

        //             return false;
        //         }
        //     });
        // });
    }
}
export function setSubCategoryInputIdValue(id_n: number | undefined, inputValues: { [key: string]: any | undefined }, inputId: number) {

    const objRequestor = localStorage.getItem("objRequestor") ? JSON.parse(localStorage.getItem("objRequestor")!) : null;
    const objClaimUserInfo = getObjectClaimUserInfo();
    switch (inputId) {
        case 1:
            return inputValues[`ddlTravelRefNo${id_n}`];
        case 2:
            return inputValues[`ddlCountry${id_n}`];
        case 3:
            return inputValues[`txtCountry${id_n}`];
        case 4:
            return inputValues[`ddlCity${id_n}`];
        case 5:
            return inputValues[`txtCity${id_n}`];
        case 7:
            return inputValues[`txtCostDescription${id_n}`];
        case 10:
            return inputValues[`ddlTransportType${id_n}`];
        case 11:
            return inputValues[`txtTransportType${id_n}`];
        case 12:
            return inputValues[`ddlHotel${id_n}`];
        case 13:
            return inputValues[`txtHotel${id_n}`];
        case 14:
            return format(inputValues[`txtCheckInDate${id_n}`], "MM/dd/yyyy");
        case 15:
            return format(inputValues[`txtCheckOutDate${id_n}`], "MM/dd/yyyy"); 
        case 16:
            return inputValues[`txtNumNight${id_n}`];
        case 17:
            return inputValues[`ddlGiftCountry${id_n}`];
        case 18:
            return inputValues[`txtGiftCountry${id_n}`];
        case 19:
            return inputValues[`ddlGiftCity${id_n}`];
        case 20:
            return inputValues[`txtGiftCity${id_n}`];
        case 21:
            return inputValues[`ddlLocalReceive${id_n}`];
        case 22:
            return inputValues[`txtLocalReceive${id_n}`];
        case 23:
            return inputValues[`ddlNonLocalReceive${id_n}`];
        case 24:
            return inputValues[`txtNonLocalReceive${id_n}`];
        case 25:
            return inputValues[`ddlNonDKSHReceive${id_n}`];
        case 26:
            return inputValues[`txtPublicReceive${id_n}`];
        case 27:
            return inputValues[`txtHealthcareReceive${id_n}`];
        case 28:
            return inputValues[`txtNonDKSHReceive${id_n}`];
        case 30:
            return inputValues[`ddlDKSHPrd${id_n}`];
        case 31:
            return inputValues[`txtGiftReason${id_n}`];
        case 32:
            return inputValues[`ddlLocalInvolve${id_n}`];
        case 33:
            return inputValues[`txtLocalInvolve${id_n}`];
        case 34:
            return inputValues[`ddlNonLocalInvolve${id_n}`];
        case 35:
            return inputValues[`txtNonLocalInvolve${id_n}`];
        case 36:
            return inputValues[`ddlNonDKSHInvolve${id_n}`];
        case 37:
            return inputValues[`txtPublicInvolve${id_n}`];
        case 38:
            return inputValues[`txtHealthcareInvolve${id_n}`];
        case 39:
            return inputValues[`txtNonDKSHInvolve${id_n}`];
        case 41:
            if (objRequestor.country_code != 'HK' && objRequestor.country_code != 'US' && objRequestor.country_code != 'MO') {
                return !isNullOrEmpty(inputValues[`txtDepartureDate${id_n}`]) ? format(inputValues[`txtDepartureDate${id_n}`], "MM/dd/yyyy") : null;
            }
            return;
        case 42:
            return inputValues[`ddlDepartureCountry${id_n}`];
        case 43:
            return inputValues[`txtDepartureCountry${id_n}`];
        case 44:
            return inputValues[`ddlDepartureCity${id_n}`];
        case 45:
            return inputValues[`txtDepartureCity${id_n}`];
        case 46:
            return inputValues[`ddlArrivalCountry${id_n}`];
        case 47:
            return inputValues[`txtArrivalCountry${id_n}`];
        case 48:
            return inputValues[`ddlArrivalCity${id_n}`];
        case 49:
            return inputValues[`txtArrivalCity${id_n}`];
        case 50:
            return inputValues[`ddlTravelClass${id_n}`];
        case 51:
            return inputValues[`ddlAirline${id_n}`];
        case 52:
            return inputValues[`txtAirline${id_n}`];
        case 53:
            return inputValues[`ddlAddFlightLeg${id_n}`];
        case 54:
            if (objRequestor.country_code != 'US') {
                return !isNullOrEmpty(inputValues[`txtAddDepartureDate${id_n}`]) ? format(inputValues[`txtAddDepartureDate${id_n}`], "MM/dd/yyyy") : null;
            }
            return;
        case 55:
            return inputValues[`ddlAddDepartureCountry${id_n}`];
        case 56:
            return inputValues[`txtAddDepartureCountry${id_n}`];
        case 57:
            return inputValues[`ddlAddDepartureCity${id_n}`];
        case 58:
            return inputValues[`txtAddDepartureCity${id_n}`];
        case 59:
            return inputValues[`ddlAddArrivalCountry${id_n}`];
        case 60:
            return inputValues[`txtAddArrivalCountry${id_n}`];
        case 61:
            return inputValues[`ddlAddArrivalCity${id_n}`];
        case 62:
            return inputValues[`txtAddArrivalCity${id_n}`];
        case 63:
            return inputValues[`ddlAddTravelClass${id_n}`];
        case 64:
            return inputValues[`ddlAddAirline${id_n}`];
        case 65:
            return inputValues[`txtAddAirline${id_n}`];
        case 66:
            return inputValues[`ddlPhoneType${id_n}`];
        case 67:
            return inputValues[`chkFlexiTransport${id_n}`];
        case 68:
            return inputValues[`chkFlexiFitness${id_n}`];
        case 69:
            return inputValues[`chkFlexiMobile${id_n}`];
        case 73:
            return format(inputValues[`txtStartDateTime${id_n}`], "MM/dd/yyyy"); 
        case 74:
            return format(inputValues[`txtEndDateTime${id_n}`], "MM/dd/yyyy");
        case 75:
            type APEvent = {
                [key: string]: any;
            };

            let objAPevent = [];
            const tempAPeventObj: APEvent = {};

            Array.from({ length: 15 }).forEach((_, ind) => {
                tempAPeventObj[`apc_event_id${ind + 1}`] = inputValues[`txtAPCeventID${ind + 1}_${id_n}`] || '';
                tempAPeventObj[`apc_event_id${ind + 1}_perc`] = setdefzeroval(inputValues[`txtAPeventPercent${ind + 1}_${id_n}`] || '0');

                if (inputValues[`txtClaimAmount${id_n}`] > 0) {
                    tempAPeventObj[`apc_amount${ind + 1}`] = tempAPeventObj[`apc_event_id${ind + 1}_perc`] == '0' ? 0 : (parseFloat(inputValues[`txtClaimAmount${id_n}`]) * (parseFloat(tempAPeventObj[`apc_event_id${ind + 1}_perc`]) / 100));
                }
            });

            objAPevent.push(tempAPeventObj);
            return objAPevent;
        case 76:
            return inputValues[`ddlCostElement${id_n}`];
        case 77:
            const objAttachment = JSON.parse(localStorage.getItem("objAttachment")!);
            if (objAttachment.iS_CC == 1 && objAttachment.personal_expense != null && objAttachment.personal_expense != "" && objAttachment.personal_expense != undefined) {
                return inputValues[`chkPersonalExpense${id_n}`];
            }
            return;
        case 78:
            return inputValues[`txtProjectRerence${id_n}`];
        case 79:
            return inputValues[`txtClient${id_n}`];
        case 80:
            return inputValues[`txtCustomer${id_n}`];
        case 81:
            type PerDiemObj = {
                [key: string]: any;
            };
            const tempPerDiemObj: PerDiemObj = {};

            let final_control_checking_user;

            if (!isNullOrEmpty(objClaimUserInfo)) {
                final_control_checking_user = objClaimUserInfo;
            } else if (!isNullOrEmpty(objRequestor)) {
                final_control_checking_user = objRequestor;
            }
            const country_per_diem_control = appConfig.PerDiemControlCountry.split(",");
            const perDiemColumn = appConfig.PerDiemColumn;

            if (country_per_diem_control.includes(final_control_checking_user.country_code)) {
                let objPerDiem = [];
                for (let ind = 1; ind <= perDiemColumn; ind++) {


                    if (document.querySelector<HTMLSelectElement>(`#txtPerDiemLocationSPR${ind}_${id_n}`)?.classList.contains("needValue")) {
                        tempPerDiemObj.country_pd = objRequestor.country_code;
                        tempPerDiemObj.company_pd = objRequestor.company_code;
                        // Begin, Saber, 20260820, INC-1023323 - base64-encode loaction_pd client-side to avoid
                        // Front Door WAF anomaly-scoring false positives on position labels containing
                        // parentheses/slashes (e.g. "...South of Thailand (Yala/Pattani, Narathiwat...)"), which
                        // were being blocked and surfaced to the browser as a misleading CORS error. Confirmed
                        // working end-to-end: the paired change in SPP_TXN_CLAIM_UPD decodes this back to the
                        // real plain text before it is persisted, so downstream consumers still see the real label.
                        const rawLocationText = inputValues[`txtPerDiemLocationSPR${ind}_${id_n}_text`];
                        tempPerDiemObj.loaction_pd = !isNullOrEmpty(rawLocationText)
                            ? btoa(unescape(encodeURIComponent(rawLocationText)))
                            : rawLocationText;
                        // End, Saber, 20260820
                        tempPerDiemObj.location_amount = inputValues[`txtPerDiemLocationSPR${ind}_${id_n}`];
                        tempPerDiemObj.entitlement_pd = inputValues[`txtPerDiemMealSPR${ind}_${id_n}_text`];
                        tempPerDiemObj.entitlement_percentage = inputValues[`txtPerDiemMealSPR${ind}_${id_n}`];
                        tempPerDiemObj.number_of_days = inputValues[`txtPerDiem_NumberofDaysSPR${ind}_${id_n}`];
                        tempPerDiemObj.total_amount_pd = inputValues[`txtPerDiem_AmountSPR${ind}_${id_n}`];
                        tempPerDiemObj.taxable_amount = inputValues[`hidtxtTaxable_amt_TH${ind}_${id_n}`];
                        tempPerDiemObj.location_amount_other = inputValues[`txtPerDiem_AmountOTHSPR${ind}_${id_n}`] == null || inputValues[`txtPerDiem_AmountOTHSPR${ind}_${id_n}`] == "" ? 0 : inputValues[`txtPerDiem_AmountOTHSPR${ind}_${id_n}`];
                        objPerDiem.push(tempPerDiemObj);
                    } else {
                        break;
                    }
                }
                return objPerDiem;
            }
            return null;
        case 82:
            return inputValues[`ddlinternal_order${id_n}`];
        case 83:
            return (objRequestor.country_code == 'TH' || objRequestor.country_code == 'LA' || objRequestor.country_code == 'JP') ? inputValues[`ddlDetailType${id_n}`] : null;
        case 89:
            //Service Order
            let objServiceOrder = [];
            let tempServiceOrderObj: any = {};
            let flagcontrol = '';
            tempServiceOrderObj.SOType = inputValues[`rdServiceOrderType${id_n}`];
            flagcontrol = inputValues[`rdServiceOrderType${id_n}`];

            tempServiceOrderObj.SOCode1 = inputValues[`ddlSO1_${id_n}`]; 
            tempServiceOrderObj.SOCode2 = inputValues[`ddlSO2_${id_n}`]; 
            tempServiceOrderObj.SOCode3 = inputValues[`ddlSO3_${id_n}`]; 
            tempServiceOrderObj.SOCode4 = inputValues[`ddlSO4_${id_n}`]; 
            tempServiceOrderObj.SOCode5 = inputValues[`ddlSO5_${id_n}`];
            tempServiceOrderObj.SOCode6 = inputValues[`ddlSO6_${id_n}`]; 
            tempServiceOrderObj.SOCode7 = inputValues[`ddlSO7_${id_n}`]; 
            tempServiceOrderObj.SOCode8 = inputValues[`ddlSO8_${id_n}`]; 
            tempServiceOrderObj.SOCode9 = inputValues[`ddlSO9_${id_n}`]; 
            tempServiceOrderObj.SOCode10 = inputValues[`ddlSO10_${id_n}`];
            tempServiceOrderObj.SOCode11 = inputValues[`ddlSO11_${id_n}`]; 
            tempServiceOrderObj.SOCode12 = inputValues[`ddlSO12_${id_n}`]; 
            tempServiceOrderObj.SOCode13 = inputValues[`ddlSO13_${id_n}`]; 
            tempServiceOrderObj.SOCode14 = inputValues[`ddlSO14_${id_n}`]; 
            tempServiceOrderObj.SOCode15 = inputValues[`ddlSO15_${id_n}`]; 
            tempServiceOrderObj.SOCode16 = inputValues[`ddlSO16_${id_n}`]; 
            tempServiceOrderObj.SOCode17 = inputValues[`ddlSO17_${id_n}`]; 
            tempServiceOrderObj.SOCode18 = inputValues[`ddlSO18_${id_n}`]; 
            tempServiceOrderObj.SOCode19 = inputValues[`ddlSO19_${id_n}`]; 
            tempServiceOrderObj.SOCode20 = inputValues[`ddlSO20_${id_n}`]; 


            if (flagcontrol == 'amount') {

                tempServiceOrderObj.SOAmount1 = setdefzeroval(inputValues[`txtSOPercent1_${id_n}`]);
                tempServiceOrderObj.SOAmount2 = setdefzeroval(inputValues[`txtSOPercent2_${id_n}`]);
                tempServiceOrderObj.SOAmount3 = setdefzeroval(inputValues[`txtSOPercent3_${id_n}`]);
                tempServiceOrderObj.SOAmount4 = setdefzeroval(inputValues[`txtSOPercent4_${id_n}`]);
                tempServiceOrderObj.SOAmount5 = setdefzeroval(inputValues[`txtSOPercent5_${id_n}`]);
                tempServiceOrderObj.SOAmount6 = setdefzeroval(inputValues[`txtSOPercent6_${id_n}`]);
                tempServiceOrderObj.SOAmount7 = setdefzeroval(inputValues[`txtSOPercent7_${id_n}`]);
                tempServiceOrderObj.SOAmount8 = setdefzeroval(inputValues[`txtSOPercent8_${id_n}`]);
                tempServiceOrderObj.SOAmount9 = setdefzeroval(inputValues[`txtSOPercent9_${id_n}`] );
                tempServiceOrderObj.SOAmount10 = setdefzeroval(inputValues[`txtSOPercent10_${id_n}`]);
                tempServiceOrderObj.SOAmount11 = setdefzeroval(inputValues[`txtSOPercent11_${id_n}`]);
                tempServiceOrderObj.SOAmount12 = setdefzeroval(inputValues[`txtSOPercent12_${id_n}`]);
                tempServiceOrderObj.SOAmount13 = setdefzeroval(inputValues[`txtSOPercent13_${id_n}`]);
                tempServiceOrderObj.SOAmount14 = setdefzeroval(inputValues[`txtSOPercent14_${id_n}`]);
                tempServiceOrderObj.SOAmount15 = setdefzeroval(inputValues[`txtSOPercent15_${id_n}`]);
                tempServiceOrderObj.SOAmount16 = setdefzeroval(inputValues[`txtSOPercent16_${id_n}`]);
                tempServiceOrderObj.SOAmount17 = setdefzeroval(inputValues[`txtSOPercent17_${id_n}`]);
                tempServiceOrderObj.SOAmount18 = setdefzeroval(inputValues[`txtSOPercent18_${id_n}`]);
                tempServiceOrderObj.SOAmount19 = setdefzeroval(inputValues[`txtSOPercent19_${id_n}`]);
                tempServiceOrderObj.SOAmount20 = setdefzeroval(inputValues[`txtSOPercent20_${id_n}`]);

                tempServiceOrderObj.SOpercentage1 = '0';
                tempServiceOrderObj.SOpercentage2 = '0';
                tempServiceOrderObj.SOpercentage3 = '0';
                tempServiceOrderObj.SOpercentage4 = '0';
                tempServiceOrderObj.SOpercentage5 = '0';
                tempServiceOrderObj.SOpercentage6 = '0';
                tempServiceOrderObj.SOpercentage7 = '0';
                tempServiceOrderObj.SOpercentage8 = '0';
                tempServiceOrderObj.SOpercentage9 = '0';
                tempServiceOrderObj.SOpercentage10 = '0';
                tempServiceOrderObj.SOpercentage11 = '0';
                tempServiceOrderObj.SOpercentage12 = '0';
                tempServiceOrderObj.SOpercentage13 = '0';
                tempServiceOrderObj.SOpercentage14 = '0';
                tempServiceOrderObj.SOpercentage15 = '0';
                tempServiceOrderObj.SOpercentage16 = '0';
                tempServiceOrderObj.SOpercentage17 = '0';
                tempServiceOrderObj.SOpercentage18 = '0';
                tempServiceOrderObj.SOpercentage19 = '0';
                tempServiceOrderObj.SOpercentage20 = '0';

            }
            else if (flagcontrol == 'percentage') {
                tempServiceOrderObj.SOpercentage1 = setdefzeroval(inputValues[`txtSOPercent1_${id_n}`]);
                tempServiceOrderObj.SOpercentage2 = setdefzeroval(inputValues[`txtSOPercent2_${id_n}`]);
                tempServiceOrderObj.SOpercentage3 = setdefzeroval(inputValues[`txtSOPercent3_${id_n}`]);
                tempServiceOrderObj.SOpercentage4 = setdefzeroval(inputValues[`txtSOPercent4_${id_n}`]);
                tempServiceOrderObj.SOpercentage5 = setdefzeroval(inputValues[`txtSOPercent5_${id_n}`]);
                tempServiceOrderObj.SOpercentage6 = setdefzeroval(inputValues[`txtSOPercent6_${id_n}`]);
                tempServiceOrderObj.SOpercentage7 = setdefzeroval(inputValues[`txtSOPercent7_${id_n}`]);
                tempServiceOrderObj.SOpercentage8 = setdefzeroval(inputValues[`txtSOPercent8_${id_n}`]);
                tempServiceOrderObj.SOpercentage9 = setdefzeroval(inputValues[`txtSOPercent9_${id_n}`] );
                tempServiceOrderObj.SOpercentage10 = setdefzeroval(inputValues[`txtSOPercent10_${id_n}`]);
                tempServiceOrderObj.SOpercentage11 = setdefzeroval(inputValues[`txtSOPercent11_${id_n}`]);
                tempServiceOrderObj.SOpercentage12 = setdefzeroval(inputValues[`txtSOPercent12_${id_n}`]);
                tempServiceOrderObj.SOpercentage13 = setdefzeroval(inputValues[`txtSOPercent13_${id_n}`]);
                tempServiceOrderObj.SOpercentage14 = setdefzeroval(inputValues[`txtSOPercent14_${id_n}`]);
                tempServiceOrderObj.SOpercentage15 = setdefzeroval(inputValues[`txtSOPercent15_${id_n}`]);
                tempServiceOrderObj.SOpercentage16 = setdefzeroval(inputValues[`txtSOPercent16_${id_n}`]);
                tempServiceOrderObj.SOpercentage17 = setdefzeroval(inputValues[`txtSOPercent17_${id_n}`]);
                tempServiceOrderObj.SOpercentage18 = setdefzeroval(inputValues[`txtSOPercent18_${id_n}`]);
                tempServiceOrderObj.SOpercentage19 = setdefzeroval(inputValues[`txtSOPercent19_${id_n}`]);
                tempServiceOrderObj.SOpercentage20 = setdefzeroval(inputValues[`txtSOPercent20_${id_n}`]);

                tempServiceOrderObj.SOAmount1 = getServiceOrderValue(1, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount2 = getServiceOrderValue(2, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount3 = getServiceOrderValue(3, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount4 = getServiceOrderValue(4, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount5 = getServiceOrderValue(5, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount6 = getServiceOrderValue(6, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount7 = getServiceOrderValue(7, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount8 = getServiceOrderValue(8, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount9 = getServiceOrderValue(9, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount10 = getServiceOrderValue(10, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount11 = getServiceOrderValue(11, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount12 = getServiceOrderValue(12, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount13 = getServiceOrderValue(13, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount14 = getServiceOrderValue(14, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount15 = getServiceOrderValue(15, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount16 = getServiceOrderValue(16, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount17 = getServiceOrderValue(17, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount18 = getServiceOrderValue(18, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount19 = getServiceOrderValue(19, id_n!, inputValues, tempServiceOrderObj);
                tempServiceOrderObj.SOAmount20 = getServiceOrderValue(20, id_n!, inputValues, tempServiceOrderObj);


            }

            objServiceOrder.push(tempServiceOrderObj);
            return objServiceOrder;
        case 90:
            let objProjectCode = [];
            let tempProjectCodeObj: any = {};

            tempProjectCodeObj.ProjectCode1 = inputValues[`txtProjectCode1_${id_n}`]; 
            tempProjectCodeObj.ProjectCode2 = inputValues[`txtProjectCode2_${id_n}`]; 
            tempProjectCodeObj.ProjectCode3 = inputValues[`txtProjectCode3_${id_n}`]; 
            tempProjectCodeObj.ProjectCode4 = inputValues[`txtProjectCode4_${id_n}`]; 
            tempProjectCodeObj.ProjectCode5 = inputValues[`txtProjectCode5_${id_n}`];
            tempProjectCodeObj.ProjectCode6 = inputValues[`txtProjectCode6_${id_n}`]; 
            tempProjectCodeObj.ProjectCode7 = inputValues[`txtProjectCode7_${id_n}`]; 
            tempProjectCodeObj.ProjectCode8 = inputValues[`txtProjectCode8_${id_n}`]; 
            tempProjectCodeObj.ProjectCode9 = inputValues[`txtProjectCode9_${id_n}`]; 
            tempProjectCodeObj.ProjectCode10 = inputValues[`txtProjectCode10_${id_n}`];
            tempProjectCodeObj.ProjectCode11 = inputValues[`txtProjectCode11_${id_n}`]; 
            tempProjectCodeObj.ProjectCode12 = inputValues[`txtProjectCode12_${id_n}`]; 
            tempProjectCodeObj.ProjectCode13 = inputValues[`txtProjectCode13_${id_n}`]; 
            tempProjectCodeObj.ProjectCode14 = inputValues[`txtProjectCode14_${id_n}`]; 
            tempProjectCodeObj.ProjectCode15 = inputValues[`txtProjectCode15_${id_n}`]; 
            tempProjectCodeObj.ProjectCode16 = inputValues[`txtProjectCode16_${id_n}`]; 
            tempProjectCodeObj.ProjectCode17 = inputValues[`txtProjectCode17_${id_n}`]; 
            tempProjectCodeObj.ProjectCode18 = inputValues[`txtProjectCode18_${id_n}`]; 
            tempProjectCodeObj.ProjectCode19 = inputValues[`txtProjectCode19_${id_n}`]; 
            tempProjectCodeObj.ProjectCode20 = inputValues[`txtProjectCode20_${id_n}`]; 

            tempProjectCodeObj.ProjectCode1_perc = setdefzeroval(inputValues[`txtPCPercent1_${id_n}`]);
            tempProjectCodeObj.ProjectCode2_perc = setdefzeroval(inputValues[`txtPCPercent2_${id_n}`]);
            tempProjectCodeObj.ProjectCode3_perc = setdefzeroval(inputValues[`txtPCPercent3_${id_n}`]);
            tempProjectCodeObj.ProjectCode4_perc = setdefzeroval(inputValues[`txtPCPercent4_${id_n}`]);
            tempProjectCodeObj.ProjectCode5_perc = setdefzeroval(inputValues[`txtPCPercent5_${id_n}`]);
            tempProjectCodeObj.ProjectCode6_perc = setdefzeroval(inputValues[`txtPCPercent6_${id_n}`]);
            tempProjectCodeObj.ProjectCode7_perc = setdefzeroval(inputValues[`txtPCPercent7_${id_n}`]);
            tempProjectCodeObj.ProjectCode8_perc = setdefzeroval(inputValues[`txtPCPercent8_${id_n}`]);
            tempProjectCodeObj.ProjectCode9_perc = setdefzeroval(inputValues[`txtPCPercent9_${id_n}`] );
            tempProjectCodeObj.ProjectCode10_perc = setdefzeroval(inputValues[`txtPCPercent10_${id_n}`]);
            tempProjectCodeObj.ProjectCode11_perc = setdefzeroval(inputValues[`txtPCPercent11_${id_n}`]);
            tempProjectCodeObj.ProjectCode12_perc = setdefzeroval(inputValues[`txtPCPercent12_${id_n}`]);
            tempProjectCodeObj.ProjectCode13_perc = setdefzeroval(inputValues[`txtPCPercent13_${id_n}`]);
            tempProjectCodeObj.ProjectCode14_perc = setdefzeroval(inputValues[`txtPCPercent14_${id_n}`]);
            tempProjectCodeObj.ProjectCode15_perc = setdefzeroval(inputValues[`txtPCPercent15_${id_n}`]);
            tempProjectCodeObj.ProjectCode16_perc = setdefzeroval(inputValues[`txtPCPercent16_${id_n}`]);
            tempProjectCodeObj.ProjectCode17_perc = setdefzeroval(inputValues[`txtPCPercent17_${id_n}`]);
            tempProjectCodeObj.ProjectCode18_perc = setdefzeroval(inputValues[`txtPCPercent18_${id_n}`]);
            tempProjectCodeObj.ProjectCode19_perc = setdefzeroval(inputValues[`txtPCPercent19_${id_n}`]);
            tempProjectCodeObj.ProjectCode20_perc = setdefzeroval(inputValues[`txtPCPercent20_${id_n}`]);

            objProjectCode.push(tempProjectCodeObj);
            return objProjectCode;
        case 95:
            return inputValues[`txtAddRecipientName${id_n}`];
        case 96:
            return inputValues[`txtExtInvolved${id_n}`];
        case 97:
            return inputValues[`txtNumExtInvolved${id_n}`];
        case 99:
            return inputValues[`ddlRecipientType${id_n}`];
        case 100:
            return inputValues[`txtAmountProvidedToExternalRecipient${id_n}`];
        case 101:
            return inputValues[`txtBusinessRationaleProvideToExternal${id_n}`];
        case 102:
            return inputValues[`ddlCashAdvanceType${id_n}`];
        case 103:
            return inputValues[`txtNumberOfCashCard${id_n}`];
        case 104:
            return inputValues[`ddlMedicalType${id_n}`];
        // Saber, 20260901, confirmed via STG DB (TBL_CLAIM_CAT_SUBCAT_INPUT_V2, JP, subcategory 29) that
        // these input_ids are configured for save, and SPP_TXN_CLAIM_UPD unconditionally overwrites these
        // columns with whatever is (or isn't) sent - missing cases here silently nulled them on every save.
        // fix: [ECL-661] Missing values and field in category Other Employee Benefits (INC-1028951)
        case 105:
            return inputValues[`txtFromStation${id_n}`];
        case 106:
            return inputValues[`txtToStation${id_n}`];
        case 107:
            return inputValues[`ddlTicketType${id_n}`];
        case 108:
            // MM/dd/yyyy (not dd/MM/yyyy) to match SQL Server's implicit varchar->datetime conversion for start_trip_date/end_trip_date
            return !isNullOrEmpty(inputValues[`txtStartTripDate${id_n}`]) ? format(inputValues[`txtStartTripDate${id_n}`], "MM/dd/yyyy") : null;
        case 109:
            return !isNullOrEmpty(inputValues[`txtEndTripDate${id_n}`]) ? format(inputValues[`txtEndTripDate${id_n}`], "MM/dd/yyyy") : null;
        case 110:
            return inputValues[`txtRoundTripDay${id_n}`];
        case 111:
            return inputValues[`txtAmountPerDay${id_n}`];
        case 112:
            return inputValues[`ddlWellnessType${id_n}`];
        case 140:     //HAZEL AMENDMENTS 20260724 - CHN-22431 [TH] Add PDP Related Educational Subcategory under Flexible Benefits
            return !isNullOrEmpty(inputValues[`txtTrainingDate${id_n}`])
                ? format(inputValues[`txtTrainingDate${id_n}`], "MM/dd/yyyy")
                : null;
        case 113:
            return inputValues[`ddlAccommodationType${id_n}`];
        // Hazel Amendments 20260113 #CHN-19146 - MM new category - Other oerating expense type 
        case 137:
            return inputValues[`ddlOtherOperatingExpenseType${id_n}`];   
        case 114:
            return inputValues[`ddlOtherType${id_n}`];
        case 115:
            return inputValues[`chkOtherPayment2K${id_n}`];
        case 116:
            return inputValues[`ddlEmployeeAttendanceExceeds${id_n}`];
        case 117:
            return inputValues[`txtTotalNumberOfEmployeeAttendance${id_n}`];
        case 120:
            return inputValues[`txtMealForBusinessPurposeAmount${id_n}`];
        case 121:
            return inputValues[`ddlIsMealSustenance${id_n}`];
        case 122:
            return inputValues[`ddlIsAlcoholInclude${id_n}`];
        case 124:
            return inputValues[`ddlIsPersonalClaim${id_n}`];
        case 126:
            return inputValues[`txtPersonalUseReason${id_n}`]; //hazel 20260127 Personal Use Reason field value didnt capture 
        case 127:
            return inputValues[`rdExpenseNature${id_n}`];//saber,20251013,revised validation checking  
        case 128:
            return inputValues[`txtVendorName_${id_n}`];
        case 129:
            return inputValues[`txtTpiNo_${id_n}`];
        case 130:
            return inputValues[`txtVendorAddress_${id_n}`];
        case 131:
            return format(inputValues[`txtAdvanceWithdrawalDate${id_n}`], "MM/dd/yyyy");
        case 133:
            return inputValues[`txtMedComplianceID${id_n}`]; //Hazel 20251109, MedCompli not save into DB
        case 135:
            return format(inputValues[`txtNetDueDate${id_n}`], "MM/dd/yyyy");
        case 136:
            return inputValues[`ddlCountryArea${id_n}`];
        default:
            break;
    }


    return null;


};


// export const subCatInputIdOnInput: React.FC<subCatInputIdOnInputProps> = ({ event, id, handleInputChange }): any => {
export function subCatInputIdOnInput(event: React.ChangeEvent<any>, id: string, handleInputChange: (id: string, value?: any) => Promise<void>) {
    if (event.target.validity.valid) {
        handleInputChange(id, event.target.value);
    }
};


export const calConvertAmt = (id_n: number, inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>, currentInput:any, rate:any) => {
    let exchangeRate = 0;
    const cat_id_n = id_n.toString().substr(-1) == "0" ? "10" : id_n.toString().substr(-1);
    const input_amount: number = parseFloat(currentInput);
    const input_decimal = checkInputDecimal(parseInt(id_n.toString()), inputValues); // Assuming input_decimal is defined somewhere
    const number_of_decimal = decimalRemove(); // Assuming number_of_decimal is defined somewhere

    // console.log("the input amount :" + input_amount);
    // console.log("the input rate :" + rate);
    // console.log("the input exchange rate :" + inputValues[`txtExchangeRate${id_n}`]);
    exchangeRate =
      parseFloat(input_amount.toFixed(input_decimal)) *
      parseFloat(!isNullOrEmpty(rate) ? rate : inputValues[`txtExchangeRate${id_n}`]);

    if (number_of_decimal == 0) {
      exchangeRate = Math.floor(exchangeRate);
    }

    // console.log("the input exchange amount :" + exchangeRate);

    const txtExchangeRateValue = parseFloat(inputValues[`txtExchangeRate${id_n}`]);
    // const objAttachment = [{ iS_CC: '1' }]; // Assuming objAttachment is defined somewhere
    const objAttachment = JSON.parse(localStorage.getItem("objAttachment")!);

    if (
      txtExchangeRateValue !== 1 ||
      (objAttachment && objAttachment?.iS_CC !== "1")
    ) {
      handleInputChange(`txtExchangeAmount${cat_id_n}`, exchangeRate.toFixed(number_of_decimal));
    }

    handleInputChange(`txtExchangeAmount${cat_id_n}`, exchangeRate.toFixed(number_of_decimal));
  };

export function validateClaimAmount(id_n: number , inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>, amount:any) {
        if (inputValues[`ddlCategory${id_n}`] && inputValues[`ddlCategory${id_n}`].toString() == "48") {
            return true;
        }
        if (isNullOrEmpty(amount)) {
            document.querySelector<HTMLInputElement>(`#txtClaimAmount${id_n}`)?.focus();
            myToast.warning(translate("Amount Can't be empty or 0.00"));
            return false;
        } else if (amount < 0.01) {
            if(inputValues[`txtCreditCard${id_n}`] == 1){
                return true;
            }
            document.querySelector<HTMLInputElement>(`#txtClaimAmount${id_n}`)?.focus();
            myToast.warning(translate("Invoice / receipt amount must more than zero"));
            return false;
        }
        return true;
}


export function getNumberOfNight(id_n: number | undefined, inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>, startDate: Date, endDate: Date) {
    let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

    // let startDate = inputValues[`txtCheckInDate${id_n}`];
    // let endDate = inputValues[`txtCheckOutDate${id_n}`];

    if (!isNullOrEmpty(startDate) && !isNullOrEmpty(endDate)) {
        if (startDate > endDate) {
            handleInputChange(`txtNumNight${id_n}`, "0");
        } else {
            let diffDays = Math.round(Math.abs((endDate.getTime() - startDate.getTime()) / (oneDay)));
            handleInputChange(`txtNumNight${id_n}`, diffDays.toString());
        }
    }

}


export function showInternalCode(id_n: number | undefined, inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>,
    currentOnChangeInput: any, objectRequestor?: any, objAttachment?: any) {

    let companyCode = objectRequestor ? objectRequestor.company_code : null;

    console.log(companyCode);


    if (companyCode.startsWith('PT')) {
        if (companyCode.startsWith('PT') &&
            (currentOnChangeInput == '2' || currentOnChangeInput == '4' || currentOnChangeInput == '6'
                || currentOnChangeInput == '7' || currentOnChangeInput == '8' || currentOnChangeInput == '9' || currentOnChangeInput == '10')) {
            handleInputChange(`ddlinternal_order${id_n}`, objAttachment.anpinternalcode);
            elementDisplay(`#APInternal_order${id_n}`, true, 'div');
            elementDisplay(`#ddlinternal_order${id_n}`, true, 'select');
            mandatoryInput(`#ddlinternal_order${id_n}`, true, 'select');
            disableInput(`#ddlinternal_order${id_n}`, false, 'select');

        }
        else {
            handleInputChange(`ddlinternal_order${id_n}`, '');
            elementDisplay(`#APInternal_order${id_n}`, false, 'div');
            mandatoryInput(`#ddlinternal_order${id_n}`, false, 'select');
            disableInput(`#ddlinternal_order${id_n}`, true, 'select');
        }
    }
}


export function shrinkCostCenter(cat_id: string, n: number, inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>) {

    let cat_id_n = cat_id.substring(-1) == "0" ? "10" : cat_id.substring(-1);

    for (let ccCounter = n; ccCounter < 21; ccCounter++) {

        let nextRow = ccCounter + 1;
        handleInputChange(`ddlCC${ccCounter}_${cat_id_n}`, inputValues[`ddlCC${nextRow}_${cat_id_n}`]);
        handleInputChange(`txtCCPercent${ccCounter}_${cat_id_n}`, inputValues[`txtCCPercent${nextRow}_${cat_id_n}`]);
        handleInputChange(`ddlCC${nextRow}_${cat_id_n}`, '');
        handleInputChange(`ddlCC${nextRow}_${cat_id_n}`, '');

    }

    for (let ccCounter = 20; ccCounter > 0; ccCounter--) {

        let nextRow = ccCounter;
        let currentCostCenter = document.querySelector<HTMLElement>(`#cc${nextRow}_${cat_id_n}`);
        if (!isNullOrEmpty(currentCostCenter) && !currentCostCenter?.classList.contains(`d-none`)) {

            let ccValue = inputValues[`ddlCC${nextRow}_${cat_id_n}`];
            let ccPercentageValue = inputValues[`txtCCPercent${nextRow}_${cat_id_n}`];

            if (ccValue.length == 0 && (ccPercentageValue == 0 || ccPercentageValue == "")) {

                if (nextRow > 1) {
                    elementDisplay(`#cc${nextRow}_${cat_id_n}`, false, 'div');
                    break;
                }
            }
        }
    }

}


export function loadClaimDetails(id_n: number | undefined, inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>, mode: string, objRequestor: any, objAttachment: any, locationQueryStr?: string) {
    
    if (inputValues[`txtlocal${id_n}`] == 1) {
        handleInputChange(`ddlCurrency${id_n}`, objRequestor.currency_code);
        handleInputChange(`txtExchangeRate${id_n}`, parseFloat("1.00").toFixed(5));
    }

    //Reset Tax column
    setDefaultTax(id_n!, inputValues, handleInputChange, window.location, objAttachment, objRequestor);


    if (mode.toLowerCase() == "new") {

        handleInputChange(`ddlCurrency${id_n}`, objRequestor.currency_code);
        handleInputChange(`txtExchangeRate${id_n}`, parseFloat("1.00").toFixed(5));
        elementDisplay(`#divProjectName_${id_n}`, false, "div");
        elementDisplay(`#divForm_${id_n}`, false, "div");
    }

    //  if (objQuickAdd.category != "" && objQuickAdd.category != undefined) {

    //         if (current_module == 'QuickAdd' && objAttachment.txn_no !== "") {
    //             BindClaimInfo(1, function () {

    //             });
    //         }

    //         //AnP
    //         if (IsExceedraEnabledCompany(objRequestor.company_code) && ($("#ddlCategory" + i).val() == "17" || $("#ddlCategory" + i).val() == "3" || $("#ddlCategory" + i).val() == "45")) //GRC
    //             EnableRecoverable(false, i);
    //         else
    //             EnableRecoverable(true, i);

    //         //Check for OT Meals message//Other Employee Benefits for OT Meal
    //         let tempcountrychk = OTMealsCountry.split(",")
    //         if (tempcountrychk.includes(objRequestor.country_code) && $("#ddlCategory" + i).val() == "3" && objRequestor.country_code != "") {
    //             $("#divOTMealInfo" + i).show();
    //         } else {
    //             $("#divOTMealInfo" + i).hide();
    //         }

    //         //Chinea per diem special message shown
    //         if (objRequestor.country_code == 'CN' && $("#ddlCategory" + i).val() == '16') {
    //             $("#divchinaperdieminfo" + i).show();
    //         } else {
    //             $("#divchinaperdieminfo" + i).hide();
    //         }

    //         //Myammar per diem special message shown
    //         //Myammer disable currency code
    //         if (objRequestor.country_code == 'MM' && $("#ddlCategory" + i).val() == '16') {
    //                 if (objRequestor.company_code == 'MM80' || objRequestor.company_code == 'MM83') {
    //                     $("#divMMperdieminfo" + i).show();
    //                 }
    //                 else if (final_control_checking_user.company_code == 'MM82') {
    //                     $("#divMMperdieminfo2" + i).show();
    //                 }
    //             $("#ddlCurrency" + i).prop("disabled", true);

    //             //Append value into invoice/receipt date
    //             $('#txtDate' + i).data('daterangepicker').setStartDate($("#txtStartDateTime" + i).val());
    //             $('#txtDate' + i).data('daterangepicker').setEndDate($("#txtEndDateTime" + i).val());
    //             $('#txtDate' + i).daterangepicker({
    //                 locale: {
    //                     format: 'DD/MM/YYYY'
    //                 }
    //             });
    //             $('#txtDate' + i).change();
    //         } else {
    //             $("#divMMperdieminfo" + i).hide();
    //             $("#divmmperdieminfo2" + i).hide();
    //             $("#ddlCurrency" + i).prop("disabled", false);
    //         }

    //         //Per diem claim - invoice/receipt date will hidden from user (global changes)
    //         if ($("#ddlCategory" + i).val() == '16' || $("#ddlCategory" + i).val() == '41' || $("#ddlCategory" + i).val() == '42' || $("#ddlCategory" + i).val() == '51') {  //Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic.
    //             $("#div_invoice_date" + i).hide();
    //         } else {
    //             $("#div_invoice_date" + i).show();
    //         }

    //         //LoadCatTypeDisplay('#ddlCategory' + id_n, objQuickAdd.category);
    // }


}

export function bindClaimInfo(id_n: number | undefined, inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>, mode: string, objRequestor: any, objAttachment: any, bindDDL?: { [key: string]: any | undefined }, handleBindDDL?: (id: string, value?: any) => void, locationQueryStr?: string) {

    let form_mode = mode.toLowerCase();
    let number_of_decimal = decimalRemove();
    let input_decimal = 0;
    ////console.log(objAttachment);

    // if (form_mode == "view" && objAttachment.subcategory_id == 17 && new Date(objAttachment.created_date) < new Date('2022-06-14')) { //GRC temporary fixes for AnP
    //     $('#ddlCategory' + i).append(`<option value="17">Advertising and Promotion</option>`);
    // }

    // if (form_mode == "view" && objAttachment.subcategory_id == 1 && objRequestor.country_code == "MY" && objRequestor.company_code != "MY98") { //Fixes for old flight claims because category disabled for MY on 2
    //     $('#ddlCategory' + i).append(`<option value="1">Flight ( for internal use only )</option>`);
    // }

    // if (form_mode == "view" && objAttachment.subcategory_id == 22 && objRequestor.country_code == "SG") { //Terk Amendment 20240205 : Fixes for old Dental claims because category disabled for Dental SG and switched to under SG Wellness Flex
    //     $('#ddlCategory' + i).append(`<option value="22">Dental</option>`);
    // }

    // helper: safe numeric parsing (remove commas) + finite guard
    const toNum = (v: any) => {
        const n = parseFloat((v ?? '').toString().replace(/,/g, ''));
        return Number.isFinite(n) ? n : 0;
    };

    handleInputChange(`ddlCategory${id_n}`, objAttachment.subcategory_id);
    let categoryId = objAttachment.subcategory_id;

    // Begin,Saber,20261006,INC-1030470 - Legacy only checks "tax is not applicable" when the
    // credit-card currency is missing from the dropdown. A listed currency (e.g. JPY) must keep
    // the imported tax amount instead of being forced to zero.
    const isCreditCardCurrencyMissing = (currency: any, ddl?: { [key: string]: any | undefined }) => {
        const code = (currency ?? "").toString().trim();
        if (!code) return false;
        const options = ddl?.[`currencyDDL`] ?? ddl?.[`ddlCurrency`] ?? ddl?.[`currency`];
        if (!Array.isArray(options) || options.length === 0) return false;
        return !options.some((item: any) => (item?.value ?? item?.id ?? "").toString().trim() === code);
    };

    const markCreditCardTaxNotApplicable = (
        index: number | undefined,
        setValue: (id: string, value?: any) => Promise<void>
    ) => {
        for (let taxCol = 1; taxCol <= 4; taxCol++) {
            disableInput(`#hideTaxChk${taxCol}_${index}`, true, "select");
            setValue(`hideTaxChk${taxCol}_${index}`, 1);
        }
    };
    // End,Saber,20261006,INC-1030470

    handleInputChange(`txtlocal${id_n}`, objAttachment.is_local);
    handleInputChange(`txtAbroad${id_n}`, objAttachment.is_local);
    handleInputChange(`txtCash${id_n}`, objAttachment.iS_CC);
    handleInputChange(`txtCreditCard${id_n}`, objAttachment.iS_CC);

    // //Terk Amendment 20240312 [#CHN-9651] : Additional Checkbox checking to define expense nature (which tax code to be used).
    // loadTaxExpenseNature(objRequestor.country_code, id_n, objAttachment.taxcode1);
    // //Terk Amendment 20240323 [#CHN-9651] : load PH Tax Additional Field for LightHouse.
    // //Terk Amendment 20240712 [#CHN-9651] : load PH Tax Additional Field for LightHouse for Finance
    // let claimCountry = objAttachment.txn_no.split("-")[0];
    // claimCountry = (claimCountry != null && claimCountry != undefined) ? claimCountry : objRequestor.country_code;
    // loadTaxAdditionalFieldPH(claimCountry, id_n, objAttachment.vendor_name, objAttachment.vendor_address, objAttachment.tpi_no);

    //Begin, saber,20251023, INC-833658 for credit currency disable and bind value
    
    // Normalize CC flag (handles both number 1 and string "1")
    const isCC = objAttachment?.iS_CC === 1 || objAttachment?.iS_CC === "1";

    if (isCC) {
        // Ensure ddlCurrency has the correct value (no reinjection here)
        const desiredCurrency = (
            (objAttachment?.foreign_currency ?? objAttachment?.currency_code) ?? ""
        ).toString().trim();

        if (desiredCurrency && inputValues[`ddlCurrency${id_n}`] !== desiredCurrency) {
            handleInputChange(`ddlCurrency${id_n}`, desiredCurrency);
            disableInput(`#ddlCurrency${id_n}`, true, 'select');
        }
        if (objAttachment.iS_CC == 1){
            // Bind CC statement dropdown value
            handleInputChange(`ddlCreditCardStatement${id_n}`, objAttachment.cc_ref_no);
            handleInputChange(`ddlCreditCardStatementText${id_n}`, objAttachment.cc_display_text);
            elementDisplay(`#cc_statement${id_n}`, true, 'div');
            disableInput(`#ddlCreditCardStatement${id_n}`, true, 'select');
            disableInput(`#txtClaimAmount${id_n}`, true, 'text');
            disableInput(`#txtDate${id_n}`, true, 'text');

            // Bind Merchant Name from CC statement data (txn_desc)
            const ccStatementItems = bindDDL?.[`ccStatement`];
            if (!isNullOrEmpty(ccStatementItems)) {
                const ccRefNo = objAttachment?.cc_ref_no;
                const matchedCC = ccStatementItems.find((item: any) => item.value == ccRefNo || item.id == ccRefNo);
                handleInputChange(`txtMerchantName${id_n}`, matchedCC?.txn_desc ?? ccStatementItems[0]?.txn_desc ?? "");
            }
        }
    } else {
        // Non-CC: keep CC statement selector locked hidden/inactive.
        // Merchant name comes from getClaimDtl (SPP_TXN_CLAIM_DTL), not the credit-card statement.
        disableInput(`#ddlCreditCardStatement${id_n}`, true, "select");
        handleInputChange(`txtMerchantName${id_n}`, objAttachment?.merchant_name ?? "");
    }
    //End, saber,20251023, INC-833658 for credit currency disable and bind value

    if (objAttachment.receiptstartdate != objAttachment.receiptenddate) {
        handleInputChange(`isDateRange`, 1);
        handleInputChange(`txtStartDate${id_n}`, parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()));
        handleInputChange(`txtEndDate${id_n}`, parse(objAttachment.receiptenddate, 'dd/MM/yyyy', new Date()));
        handleInputChange(`txtDateRange${id_n}`, parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()));
    }
    else {
        handleInputChange(`isDateRange`, 0);
        handleInputChange(`txtDate${id_n}`, parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()));
    }


    if (objAttachment.foreign_currency == '' || objAttachment.foreign_currency == null) {

        handleInputChange(
          `ddlCurrency${id_n}`,
          objAttachment.currency_code || objRequestor.currency_code
        );
        handleInputChange(`txtExchangeRate${id_n}`, parseFloat((1.00).toFixed(5)));
        handleInputChange(`txtExchangeAmount${id_n}`, parseFloat((1.00).toFixed(number_of_decimal)));

    } else if (objAttachment.exchange_rate == 0.00) {
        if (objAttachment.iS_CC == 1) {
            handleInputChange(`ddlCurrency${id_n}`, objAttachment.foreign_currency);
            handleInputChange(`txtExchangeRate${id_n}`, parseFloat(objAttachment.exchange_rate.toString()).toFixed(5));
            handleInputChange(`txtExchangeAmount${id_n}`, parseFloat(objAttachment.total_amount.toString()).toFixed(number_of_decimal));

            // Begin,Saber,20261006,INC-1030470
            const currencyMissingFromList = isCreditCardCurrencyMissing(objAttachment.foreign_currency, bindDDL);
            if (currencyMissingFromList) {
                handleInputChange(`ddlCurrency${id_n}`, objAttachment.foreign_currency);
                markCreditCardTaxNotApplicable(id_n, handleInputChange);
            }
            // End,Saber,20261006,INC-1030470

        } else {
            handleInputChange(`ddlCurrency${id_n}`, objAttachment.foreign_currency);
            handleInputChange(`txtExchangeRate${id_n}`, parseFloat((1.00).toFixed(5)));
            handleInputChange(`txtExchangeAmount${id_n}`, parseFloat(objAttachment.total_amount).toFixed(number_of_decimal));
        }

    } else {
        handleInputChange(`ddlCurrency${id_n}`, objAttachment.foreign_currency);
        handleInputChange(`txtExchangeRate${id_n}`, parseFloat(objAttachment.exchange_rate).toFixed(5));
        handleInputChange(`txtExchangeAmount${id_n}`, parseFloat(objAttachment.total_amount).toFixed(number_of_decimal));


        if (objAttachment.iS_CC == 1) {
            // Begin,Saber,20261006,INC-1030470
            const currencyMissingFromList = isCreditCardCurrencyMissing(objAttachment.foreign_currency, bindDDL);
            if (currencyMissingFromList) {
                handleInputChange(`ddlCurrency${id_n}`, objAttachment.foreign_currency);
                markCreditCardTaxNotApplicable(id_n, handleInputChange);
            }
            // End,Saber,20261006,INC-1030470
        }
    }
// ====== Claim amount binding (safe) ======
    const amtFC = toNum(objAttachment.amount_foreign_currency);
    const totalAmt = toNum(objAttachment.total_amount);
    const initAmt = toNum(objAttachment.initial_claim_amount);

    if (objAttachment.company_code != undefined) {
        if (objAttachment.company_code.includes("JP")) {
            handleInputChange(`txtClaimAmount${id_n}`, smartRound(amtFC, 2));
        } else {
            handleInputChange(`txtClaimAmount${id_n}`, smartRound(amtFC, number_of_decimal));
        }
    } else if (objAttachment.subcategory_id == 46 || objAttachment.subcategory_id == 47) {
        handleInputChange(`txtClaimAmount${id_n}`, smartRound(amtFC, number_of_decimal));
    } else if (objAttachment.subcategory_id == 48) {
        handleInputChange(`txtClaimAmount${id_n}`, smartRound(totalAmt, number_of_decimal));
    } else {
        handleInputChange(`txtClaimAmount${id_n}`, smartRound(amtFC, number_of_decimal));
    }

    handleInputChange(`hidden_ClaimAmount${id_n}`, smartRound(amtFC, number_of_decimal));
    handleInputChange(`hidden_Init_claim_Amount${id_n}`, smartRound(initAmt || amtFC, number_of_decimal));
    // =========================================
    // if (objAttachment.company_code != undefined) {
    //     if (objAttachment.company_code.includes("JP")) {
    //         handleInputChange(`txtClaimAmount${id_n}`, smartRound(parseFloat(objAttachment.amount_foreign_currency),2));
    //     } else {
    //         handleInputChange(`txtClaimAmount${id_n}`, parseFloat(objAttachment.amount_foreign_currency));
    //     }
    // } else if (objAttachment.subcategory_id == 46 || objAttachment.subcategory_id == 47) {
    //     handleInputChange(`txtClaimAmount${id_n}`, smartRound(parseFloat(objAttachment.amount_foreign_currency),input_decimal));
    // } else if (objAttachment.subcategory_id == 48) {
    //     handleInputChange(`txtClaimAmount${id_n}`, smartRound(parseFloat(objAttachment.total_amount),input_decimal));
    // }

    // // ////console.log(objAttachment.exchange_rate.toFixed(5) + "$$$" + objAttachment.amount_foreign_currency.toFixed(2) + "$$$" + objAttachment.total_amount.toFixed(2))
    // handleInputChange(`hidden_ClaimAmount${id_n}`, smartRound(parseFloat(objAttachment.amount_foreign_currency),input_decimal));
    // handleInputChange(`hidden_Init_claim_Amount${id_n}`, parseFloat(objAttachment.initial_claim_amount));

    enable_Disable_VAT_WHT_OnLoad(
        id_n, 
        inputValues,
        handleInputChange, 
        objAttachment, 
    );
    //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
    if (objRequestor.country_code == "DE" || objRequestor.country_code == "PL" || objRequestor.company_code == "CH87" || objRequestor.country_code == "VN") {
        enableTaxDetailsForDE(
            id_n, 
            inputValues[`ddlCategory${id_n}`],
            inputValues,
            handleInputChange, 
            objRequestor, 
            objAttachment, 
            bindDDL!,
            handleBindDDL!,
            1, //Important for rendering the amount in local currency,
            0
        );
        
    }

    //Load & display fields for India Customization.
    load_IN_CustomFields(
        id_n ,
        handleInputChange, 
        objAttachment,
        "1"
    );

    // ****************************  Input Id Bind Input Syntax all here ******************************** //
    handleInputChange(`ddlCountry${id_n}`, objAttachment.country);
    handleInputChange(`txtCountry${id_n}`, objAttachment.other_country);
    // if (objAttachment.subcategory_id != $('#ddlCategory' + cat_id_n).val()) {
    //     $('#ddlCountry' + cat_id_n).val('')
    //     $('#ddlCity' + cat_id_n).val('');
    // }
    // if (objAttachment && typeof objAttachment.country === 'undefined') {
    //     $('#ddlCountry' + cat_id_n).val(objRequestor.country_code);
    // }
    // ****************************  Input Id Bind Input Syntax all here ********************************  //


  
    handleInputChange(`ddlRecoverable${id_n}`, !isNullOrEmpty(objAttachment.client_recoverable) ? objAttachment.client_recoverable : "0");
 

    //handling of show/hide cost center based on recoverable field //20cc
    if (inputValues[`ddlRecoverable${id_n}`] == 1) {
        elementDisplay(`#divCostCenter${id_n}`, false, "div");
        elementDisplay(`#divProjectCode_${id_n}`, false, "div");

        for (let ccCounter = 1; ccCounter < 21; ccCounter++) {
            shrinkCostCenter(`ddlCC${ccCounter}_${id_n}`, 1, inputValues, handleInputChange);
        }
    }

    if (objAttachment.client_recoverable == 1) {

        handleInputChange(`txtRecoverable${id_n}`, objAttachment.recoverable_name);
        elementDisplay(`#recoverable${id_n}`, true, "div");

        // filterVendorCode(i);

        let currentUserLocal = objRequestor;
        if (currentUserLocal.intercomp == 1) {
            elementDisplay(`#divRadioRecoverable${id_n}`, true, "div");
        }


        if (objAttachment.recoverableSpecialGLCode != null && objAttachment.recoverableSpecialGLCode != undefined && objAttachment.recoverableSpecialGLCode != "") {
            //Showing list
            elementDisplay(`#recoverable${id_n}`, true, "div");
            mandatoryInput(`#txtRecoverable${id_n}`, true, "text");
            elementDisplay(`#divRecoverabletxt${id_n}`, true, "div");

            //enable recovery SPecial GL
            elementDisplay(`#divRecoverableSpecialGL_${id_n}`, true, "div");
            mandatoryInput(`#ddlRecoverableSpecialGL${id_n}`, true, "select");

            //Check your radio one button
            handleInputChange(`radio_coverable1_${id_n}`, "1");

            //Saber,2026-10-09 , Hide intercomp div (was hiding Special GL div by mistake)
            elementDisplay(`#divRecoverableInterComp${id_n}`, false, "div");
            mandatoryInput(`#txtInterCompRecoverable${id_n}`, false, "text");

            //Bind special GL code value
            handleInputChange(`ddlRecoverableSpecialGL${id_n}`, objAttachment.recoverableSpecialGLCode);
        }


        //Intercomp Recoverable
        let currentUser = objRequestor;
        if (currentUser.intercomp == 1) {
            if (objAttachment.intercomprecoverable != null && objAttachment.intercomprecoverable != undefined && objAttachment.intercomprecoverable != "") {
                //Showing list
                elementDisplay(`#divRecoverableInterComp${id_n}`, true, "div");
                mandatoryInput(`#txtInterCompRecoverable${id_n}`, true, "text");

                //Check your radio two button
                handleInputChange(`radio_coverable2_${id_n}`, "1");

                //Hide Special GL Code
                elementDisplay(`#divRecoverableSpecialGL_${id_n}`, false, "div");
                mandatoryInput(`#ddlRecoverableSpecialGL${id_n}`, false, "select");
                elementDisplay(`#recoverable${id_n}`, false, "div");
                mandatoryInput(`#txtRecoverable${id_n}`, false, "text");
                document.querySelector<HTMLInputElement>(`#txtRecoverable${id_n}`) && document.querySelector<HTMLInputElement>(`#txtRecoverable${id_n}`)?.classList.remove(`is-invalid`);
                handleInputChange(`txtRecoverable${id_n}`, "");
                elementDisplay(`#divRecoverabletxt${id_n}`, false, "div");

                //Bind value intercomp value
                handleInputChange(`txtInterCompRecoverable${id_n}`, objAttachment.intercomprecoverable);
            }
        }


        if (objAttachment.recoverable_name == "Others") {
            elementDisplay(`#divRecoverableOthers${id_n}`, true, "div");
            handleInputChange(`ddlRecoverableOthers${id_n}`, objAttachment.recoverable_others);
            mandatoryInput(`#ddlRecoverableOthers${id_n}`, true, "select");
        }
        else {
            elementDisplay(`#divRecoverableOthers${id_n}`, false, "div");
            handleInputChange(`ddlRecoverableOthers${id_n}`, "");
            mandatoryInput(`#ddlRecoverableOthers${id_n}`, false, "select");
        }
    } else {

        elementDisplay(`#recoverable${id_n}`, false, "div");
        mandatoryInput(`#ddlRecoverableOthers${id_n}`, false, "select");
        elementDisplay(`#divRecoverableOthers${id_n}`, false, "div");
        handleInputChange(`ddlRecoverableOthers${id_n}`, "");

        elementDisplay(`#divRecoverableInterComp${id_n}`, false, "div");
        mandatoryInput(`#txtInterCompRecoverable${id_n}`, false, "text");
        document.querySelector<HTMLInputElement>(`#txtInterCompRecoverable${id_n}`) && document.querySelector<HTMLInputElement>(`#txtInterCompRecoverable${id_n}`)?.classList.remove(`is-invalid`);
        handleInputChange(`txtInterCompRecoverable${id_n}`, "");

        elementDisplay(`#divRadioRecoverable${id_n}`, false, "div");
    }


    handleInputChange(`ddlPrj${id_n}`, objAttachment.project_code);

    if (isNullOrEmpty(inputValues[`ddlPrj${id_n}`])) {
        if (locationQueryStr == '?mode=team') {
            elementDisplay(`.div_proj${id_n}`, true, "div");
            //  $('#ddlPrj' + i).append($('<option>', {
            //     value: objAttachment.project_code,
            //     text: objAttachment.project_name
            // }));
            handleInputChange(`ddlPrj${id_n}`, objAttachment.project_code);
        }
    }

    handleInputChange(`ddlCC1_${id_n}`, objAttachment.costcenter1);
    handleInputChange(`txtCCPercent1_${id_n}`, objAttachment.costcenter1_percent);

    handleInputChange(`ddlCC2_${id_n}`, objAttachment.costcenter2);
    handleInputChange(`txtCCPercent2_${id_n}`, objAttachment.costcenter2_percent);

    handleInputChange(`ddlCC3_${id_n}`, objAttachment.costcenter3);
    handleInputChange(`txtCCPercent3_${id_n}`, objAttachment.costcenter3_percent);

    handleInputChange(`ddlCC4_${id_n}`, objAttachment.costcenter4);
    handleInputChange(`txtCCPercent4_${id_n}`, objAttachment.costcenter4_percent);

    handleInputChange(`ddlCC5_${id_n}`, objAttachment.costcenter5);
    handleInputChange(`txtCCPercent5_${id_n}`, objAttachment.costcenter5_percent);

    handleInputChange(`ddlCC6_${id_n}`, objAttachment.costcenter6);
    handleInputChange(`txtCCPercent6_${id_n}`, objAttachment.costcenter6_percent);

    handleInputChange(`ddlCC7_${id_n}`, objAttachment.costcenter7);
    handleInputChange(`txtCCPercent7_${id_n}`, objAttachment.costcenter7_percent);

    handleInputChange(`ddlCC8_${id_n}`, objAttachment.costcenter8);
    handleInputChange(`txtCCPercent8_${id_n}`, objAttachment.costcenter8_percent);

    handleInputChange(`ddlCC9_${id_n}`, objAttachment.costcenter9);
    handleInputChange(`txtCCPercent9_${id_n}`, objAttachment.costcenter9_percent);

    handleInputChange(`ddlCC10_${id_n}`, objAttachment.costcenter10);
    handleInputChange(`txtCCPercent10_${id_n}`, objAttachment.costcenter10_percent);


    handleInputChange(`ddlCC11_${id_n}`, objAttachment.costcenter11);
    handleInputChange(`txtCCPercent11_${id_n}`, objAttachment.costcenter11_percent);

    handleInputChange(`ddlCC12_${id_n}`, objAttachment.costcenter12);
    handleInputChange(`txtCCPercent12_${id_n}`, objAttachment.costcenter12_percent);

    handleInputChange(`ddlCC13_${id_n}`, objAttachment.costcenter13);
    handleInputChange(`txtCCPercent13_${id_n}`, objAttachment.costcenter13_percent);

    handleInputChange(`ddlCC14_${id_n}`, objAttachment.costcenter14);
    handleInputChange(`txtCCPercent14_${id_n}`, objAttachment.costcenter14_percent);

    handleInputChange(`ddlCC15_${id_n}`, objAttachment.costcenter15);
    handleInputChange(`txtCCPercent15_${id_n}`, objAttachment.costcenter15_percent);

    handleInputChange(`ddlCC16_${id_n}`, objAttachment.costcenter16);
    handleInputChange(`txtCCPercent16_${id_n}`, objAttachment.costcenter16_percent);

    handleInputChange(`ddlCC17_${id_n}`, objAttachment.costcenter17);
    handleInputChange(`txtCCPercent17_${id_n}`, objAttachment.costcenter17_percent);

    handleInputChange(`ddlCC18_${id_n}`, objAttachment.costcenter18);
    handleInputChange(`txtCCPercent18_${id_n}`, objAttachment.costcenter18_percent);

    handleInputChange(`ddlCC19_${id_n}`, objAttachment.costcenter19);
    handleInputChange(`txtCCPercent19_${id_n}`, objAttachment.costcenter19_percent);

    handleInputChange(`ddlCC20_${id_n}`, objAttachment.costcenter20);
    handleInputChange(`txtCCPercent20_${id_n}`, objAttachment.costcenter20_percent);

    //20cc


    handleInputChange(`txtRemarks${id_n}`, objAttachment.remark);

    if ((objAttachment.is_local == 1) && (objAttachment.foreign_currency == objRequestor.currency_code)) {
        handleInputChange(`txtExchangeRate${id_n}`, parseFloat((1.00).toFixed(5)));
    }

    // Travel other//
    if (objAttachment.subcategory_id == 5) {
        handleInputChange(`txtCostDescription${id_n}`, objAttachment.cost_desc);
    }
    // Travel other//

    //Accommodation//
    if (objAttachment.subcategory_id == 2 && objRequestor.country_code != "US" && objRequestor.country_code != "HK" && objRequestor.country_code != "MO") {
        if (!document.querySelector<HTMLInputElement>(`#txtCheckInDate${id_n}`)?.classList.contains(`d-none`)) {
            handleInputChange(`txtCheckInDate${id_n}`, parse(objAttachment.checkindate, 'dd/MM/yyyy', new Date()));
        }
        if (!document.querySelector<HTMLInputElement>(`#txtCheckInDate${id_n}`)?.classList.contains(`d-none`)) {
            handleInputChange(`txtCheckOutDate${id_n}`, parse(objAttachment.checkoutdate, 'dd/MM/yyyy', new Date()));
        }
        handleInputChange(`txtNumNight${id_n}`, objAttachment.num_night);
    }
    //Accommodation//

    //Flights//
    if (objAttachment.subcategory_id == 1) {
        if (!document.querySelector<HTMLInputElement>(`#txtDepartureDate1_${id_n}`)?.classList.contains(`d-none`)) {
            handleInputChange(`txtDepartureDate1_${id_n}`, parse(objAttachment.departuredate, 'dd/MM/yyyy', new Date()));
        }
        handleInputChange(`ddlTravelClass${id_n}`, objAttachment.travel_class);
        handleInputChange(`ddlAirline${id_n}`, objAttachment.airline);
        handleInputChange(`txtAirline${id_n}`, objAttachment.other_airline);
        handleInputChange(`ddlAddFlightLeg${id_n}`, objAttachment.add_flight);

        if (!document.querySelector<HTMLInputElement>(`#txtDepartureDate2_${id_n}`)?.classList.contains(`d-none`)) {
            handleInputChange(`txtDepartureDate2_${id_n}`, parse(objAttachment.adddeparturedate, 'dd/MM/yyyy', new Date()));
        }
        handleInputChange(`ddlAddTravelClass${id_n}`, objAttachment.add_travel_class);
        handleInputChange(`ddlAddAirline${id_n}`, objAttachment.add_airline);
        handleInputChange(`txtAddAirline${id_n}`, objAttachment.add_other_airline);
    }

    //Gifts//
    //Hazel Amendments - 20260120 - Fixes for Gift(Customary) field binding issue
    if (objAttachment.subcategory_id == 6) {
        //console.clear();
        //console.log('=== Binding Subcategory 6 (Gifts) Fields ===');
        
        // Build merged inputValues with all gift fields for subCatInputOnChange logic
        const giftInputValues = {
            ...inputValues,
            [`ddlDKSHInvolve${id_n}`]: objAttachment.dksh_involve || "0",
            [`ddlLocalReceive${id_n}`]: objAttachment.local_receive || "0",
            [`txtLocalReceive${id_n}`]: objAttachment.num_local_receive || "",
            [`ddlNonLocalReceive${id_n}`]: objAttachment.non_local_receive || "0",
            [`txtNonLocalReceive${id_n}`]: objAttachment.num_non_local_receive || "",
            [`ddlNonDKSHReceive${id_n}`]: objAttachment.non_dksh_receive || "0",
            [`txtPublicReceive${id_n}`]: objAttachment.num_public_officials_receive || "",
            [`txtHealthcareReceive${id_n}`]: objAttachment.num_hec_pro_receive || "",
            [`txtNonDKSHReceive${id_n}`]: objAttachment.num_non_dksh_receive || "",
            [`ddlDKSHPrd${id_n}`]: objAttachment.gift_dksh_prd || "",
            [`txtGiftReason${id_n}`]: objAttachment.gift_reason || "",
            [`txtAddRecipientName${id_n}`]: objAttachment.gift_company_recipient_name || "",
            [`ddlRecipientType${id_n}`]: objAttachment.recipient_type || "",
            [`txtAmountProvidedToExternalRecipient${id_n}`]: objAttachment.amount_provided_to_external || "",
            [`txtBusinessRationaleProvideToExternal${id_n}`]: objAttachment.business_rationale_provide_to_external || "",
            [`ddlExceedraNoCode${id_n}`]: objAttachment.isNoExceedraCode || "",
            [`txtExceedraNoCodeRemarks${id_n}`]: objAttachment.exceedraRemarks || "",
            [`txtHeadCountPOHCPInvolve${id_n}`]: objAttachment.headcount_PO_HCP_involve || "",
        };
        //console.log('Created merged giftInputValues:', giftInputValues);
        
        // Step 1: Bind ONLY dropdown values (parent fields that control visibility)
        if (objAttachment.dksh_involve) {
            handleInputChange(`ddlDKSHInvolve${id_n}`, objAttachment.dksh_involve);
        }
        if (objAttachment.local_receive) {
            handleInputChange(`ddlLocalReceive${id_n}`, objAttachment.local_receive);
        }
        if (objAttachment.non_local_receive) {
            handleInputChange(`ddlNonLocalReceive${id_n}`, objAttachment.non_local_receive);
        }
        if (objAttachment.non_dksh_receive) {
            handleInputChange(`ddlNonDKSHReceive${id_n}`, objAttachment.non_dksh_receive);
        }
        if (objAttachment.gift_dksh_prd) {
            handleInputChange(`ddlDKSHPrd${id_n}`, objAttachment.gift_dksh_prd);
        }
        if (objAttachment.recipient_type) {
            handleInputChange(`ddlRecipientType${id_n}`, objAttachment.recipient_type);
        }
        if (objAttachment.isNoExceedraCode) {
            handleInputChange(`ddlExceedraNoCode${id_n}`, objAttachment.isNoExceedraCode);
        }
        
        // Step 2: Bind fields that are always visible (not dependent on dropdown values)
        handleInputChange(`txtGiftReason${id_n}`, objAttachment.gift_reason);
        handleInputChange(`txtAddRecipientName${id_n}`, objAttachment.gift_company_recipient_name);
        handleInputChange(`txtExceedraNoCodeRemarks${id_n}`, objAttachment.exceedraRemarks);
        handleInputChange(`txtHeadCountPOHCPInvolve${id_n}`, objAttachment.headcount_PO_HCP_involve);
        handleInputChange(`txtAmountProvidedToExternalRecipient${id_n}`, objAttachment.amount_provided_to_external);
        handleInputChange(`txtBusinessRationaleProvideToExternal${id_n}`, objAttachment.business_rationale_provide_to_external);
        
        //console.log('=== Triggering onChange handlers and binding dependent field values ===');
        
        // Step 3: Trigger onChange to show fields, then bind their values (single pass)
        setTimeout(() => {
            // Use giftInputValues to ensure the latest values are bound, because inputValues is not fully populated when subCatOnChange is triggered, which would cause display errors.
            // 1.) When DKSHInvolve is "1", trigger LocalReceive and NonLocalReceive onChange + display 
            //    - When LocalReceive is "1", bind txtLocalReceive value
            //    - When NonLocalReceive is "1", bind txtNonLocalReceive value
            //2.) When NonDKSHReceive is "1", bind all dependent text fields + trigger RecipientType onChange
            //     - Bind txtNonDKSHReceive, txtPublicReceive, txtHealthcareReceive
            //     - Trigger RecipientType onChange

            if (objAttachment.dksh_involve) {
                subCatInputOnChange(giftInputValues, id_n, "ddlDKSHInvolve", handleInputChange, objAttachment.dksh_involve, bindDDL, handleBindDDL);
                
                if (objAttachment.dksh_involve.toString() === "1") {
                    if (objAttachment.local_receive) {
                        subCatInputOnChange(giftInputValues, id_n, "ddlLocalReceive", handleInputChange, objAttachment.local_receive, bindDDL, handleBindDDL);
                        if (objAttachment.local_receive.toString() === "1") {
                            handleInputChange(`txtLocalReceive${id_n}`, objAttachment.num_local_receive);
                        }
                    }
                    
                    if (objAttachment.non_local_receive) {
                        subCatInputOnChange(giftInputValues, id_n, "ddlNonLocalReceive", handleInputChange, objAttachment.non_local_receive, bindDDL, handleBindDDL);
                        if (objAttachment.non_local_receive.toString() === "1") {
                            handleInputChange(`txtNonLocalReceive${id_n}`, objAttachment.num_non_local_receive);
                        }
                    }
                }
            }
            
            // Trigger ddlNonDKSHReceive onChange and bind related text fields
            if (objAttachment.non_dksh_receive) {
                subCatInputOnChange(giftInputValues, id_n, "ddlNonDKSHReceive", handleInputChange, objAttachment.non_dksh_receive, bindDDL, handleBindDDL);
                
                if (objAttachment.non_dksh_receive.toString() === "1") {
                    // Bind all dependent text fields after showing them
                    handleInputChange(`txtNonDKSHReceive${id_n}`, objAttachment.num_non_dksh_receive);
                    handleInputChange(`txtPublicReceive${id_n}`, objAttachment.num_public_officials_receive);
                    handleInputChange(`txtHealthcareReceive${id_n}`, objAttachment.num_hec_pro_receive);
                    
                    // Trigger ddlRecipientType onChange
                    if (objAttachment.recipient_type) {
                        subCatInputOnChange(giftInputValues, id_n, "ddlRecipientType", handleInputChange, objAttachment.recipient_type, bindDDL, handleBindDDL);
                    }
                }
            }
            
            //console.log('=== End Subcategory 6 Field Binding ===');
        }, 100);
    }
    //Gifts//

    //Meals, Entertainment//
    if (objAttachment.subcategory_id == 3 || objAttachment.subcategory_id == 30 || objAttachment.subcategory_id == 17 || objAttachment.subcategory_id == 45) {

        if (objAttachment.local_involve) {
            handleInputChange(`ddlLocalInvolve${id_n}`, objAttachment.local_involve);
        }

        handleInputChange(`txtLocalInvolve${id_n}`, objAttachment.num_local_involve);

        if (objAttachment.non_local_involve) {
            handleInputChange(`ddlNonLocalInvolve${id_n}`, objAttachment.non_local_involve);
        }
        handleInputChange(`txtNonLocalInvolve${id_n}`, objAttachment.num_non_local_involve);

        if (objAttachment.non_dksh_involve) {
            handleInputChange(`ddlNonDKSHInvolve${id_n}`, objAttachment.non_dksh_involve);
        }

        if (objAttachment.dksh_involve) {
            handleInputChange(`ddlDKSHInvolve${id_n}`, objAttachment.dksh_involve);
        }

        handleInputChange(`txtNonLocalInvolve${id_n}`, objAttachment.num_non_local_involve);
        handleInputChange(`txtPublicInvolve${id_n}`, objAttachment.num_public_officials_involve);
        handleInputChange(`txtHealthcareInvolve${id_n}`, objAttachment.num_hec_pro_involve);
        handleInputChange(`txtNonDKSHInvolve${id_n}`, objAttachment.num_non_dksh_involve);
        handleInputChange(`txtNumExtInvolved${id_n}`, objAttachment.ent_external_people_involved);
        handleInputChange(`txtExtInvolved${id_n}`, objAttachment.ent_num_involved);
        handleInputChange(`ddlRecipientType${id_n}`, objAttachment.recipient_type);
        handleInputChange(`txtHeadCountPOHCPInvolve${id_n}`, objAttachment.headcount_PO_HCP_involve);
        handleInputChange(`txtAmountProvidedToExternalRecipient${id_n}`, objAttachment.amount_provided_to_external);
        handleInputChange(`txtBusinessRationaleProvideToExternal${id_n}`, objAttachment.business_rationale_provide_to_external);
        handleInputChange(`ddlExceedraNoCode${id_n}`, objAttachment.isNoExceedraCode);
        handleInputChange(`txtExceedraNoCodeRemarks${id_n}`, objAttachment.exceedraRemarks);

    }

    if (objAttachment.subcategory_id == 3) {

        let tempcountrychk = appConfig.OTMealsCountry.split(",")
        if (tempcountrychk.includes(objRequestor.country_code) && objRequestor.country_code != "") {
            elementDisplay(`#divOTMealInfo${id_n}`, true, "div");
        } else {
            elementDisplay(`#divOTMealInfo${id_n}`, false, "div");
        }

        if (objRequestor.country_code != 'MM') {
            elementDisplay(`#APCevent_percent${id_n}`, false, "div");
            elementDisplay(`#APCevent_button${id_n}`, false, "div");
            elementDisplay(`#lblAPCeventIDpercentage${id_n}`, false, "div");
        }
    }

    //Meals, Entertainment//

    //Transport//
    if (objAttachment.subcategory_id == 4) {
        handleInputChange(`ddlTransportType${id_n}`, objAttachment.transport_type);
        handleInputChange(`txtTransportType${id_n}`, objAttachment.other_transport_type);

        if (objAttachment.is_flexi == 1) {
            handleInputChange(`chkFlexiTransport${id_n}`, "1");
        }

    }
    //Transport//

    //Flexi Claim Fitness//
    if (objAttachment.subcategory_id == 23) {
        //$('#chkFlexiFitness' + i).prop('checked', objAttachment.is_flexi == 1 ? false : true);
        if (objAttachment.is_flexi == 1) {
            handleInputChange(`chkFlexiFitness${id_n}`, "1");
        }
    }
    //Flexi Claim Fitness//

    //Phone//
    if (objAttachment.subcategory_id == 26) {
        handleInputChange(`ddlPhoneType${id_n}`, objAttachment.phone_type_id);
        if (objAttachment.is_flexi == 1) {
            handleInputChange(`chkFlexiMobile${id_n}`, "1");
        }
    }
    //Phone//

    // Begin, Saber, 20260925, SR-1044263 - Payment to K-Reach (input 115). EEC Plus binds this on subcategory 28; PWA did not,
    // so the saved flag never appeared checked on the approver screen.
    if (objAttachment.subcategory_id == 28) {
        const otherPayment2K = objAttachment.otherPayment2K ?? objAttachment.OtherPayment2K;
        const isChecked = otherPayment2K == 1 || otherPayment2K == "1" || otherPayment2K === true;
        handleInputChange(`chkOtherPayment2K${id_n}`, isChecked ? "1" : "0");
    }
    // End, Saber, 20260925, SR-1044263

    if (objAttachment.subcategory_id == 50) {
        handleInputChange(`ddlWellnessType${id_n}`, objAttachment.wellness_type_id);
    //HAZEL AMENDMENTS 20260724 - CHN-22431 [TH] Add PDP Related Educational Subcategory under Flexible Benefits
        const trainingDate = objAttachment.training_date;
        const trainingDateText = !isNullOrEmpty(trainingDate) ? trainingDate.toString() : "";
        const parsedISOTrainingDate = trainingDateText ? parseISO(trainingDateText) : null;
        const parsedTrainingDate = !isNullOrEmpty(trainingDate)
            ? trainingDate instanceof Date
                ? trainingDate
                : parsedISOTrainingDate && !Number.isNaN(parsedISOTrainingDate.getTime())
                    ? parsedISOTrainingDate
                    : parse(trainingDateText, 'dd/MM/yyyy', new Date())
            : null;

        handleInputChange(
            `txtTrainingDate${id_n}`,
            parsedTrainingDate && !Number.isNaN(parsedTrainingDate.getTime())
                ? parsedTrainingDate
                : null
        );
    }

    //Per Diem//
    if (objAttachment.subcategory_id == 16 || objAttachment.subcategory_id == 51) {  //Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic.

        // Begin, Saber, 20260820, INC-1023323 - Fix "RangeError: Invalid time value" crash on load/edit.
        // The previous fallback re-parsed `today.toString()` (e.g. "Thu Aug 20 2026...") using the
        // "dd/MM/yyyy" format, which never matches and silently produced an Invalid Date. That Invalid
        // Date was then passed straight into react-datepicker's `selected` prop (Input Id 73/74), which
        // throws when rendering it. Per diem entries without an abroad start/end date (e.g. TH position
        // based Daily Hardship allowance) hit this every time. Guard with isValid() and only fall back
        // to `new Date()` (a real, valid date) when the value is missing/unparsable.
        const parsedStartDateTime = objAttachment.startdatetime
            ? parse(objAttachment.startdatetime, 'dd/MM/yyyy', new Date())
            : null;
        handleInputChange(
            `txtStartDateTime${id_n}`,
            parsedStartDateTime && isValid(parsedStartDateTime) ? parsedStartDateTime : new Date()
        );

        const parsedEndDateTime = objAttachment.enddatetime
            ? parse(objAttachment.enddatetime, 'dd/MM/yyyy', new Date())
            : null;
        handleInputChange(
            `txtEndDateTime${id_n}`,
            parsedEndDateTime && isValid(parsedEndDateTime) ? parsedEndDateTime : new Date()
        );
        // End, Saber, 20260820
    }
    //Per Diem//


    //Disputed Transaction//
    if (objAttachment.subcategory_id == 8) {
        //$('#chkFlexiFitness' + i).prop('checked', objAttachment.is_flexi == 1 ? false : true);
        if (objAttachment.personal_expense == 1) {
            handleInputChange(`chkPersonalExpense${id_n}`, "1");
        }

    }
    //Disputed Transaction//

    //Cash Advance//
    if (objAttachment.subcategory_id == 46) {
        handleInputChange(`ddlCashAdvanceType${id_n}`, objAttachment.casH_ADVANCE_TYPE);
    }

    //Cash Card//
    if (objAttachment.subcategory_id == 47) {
        handleInputChange(`txtNumberOfCashCard${id_n}`, objAttachment.num_cash_card);
    }

    //Other Employee Benefit
    if (objAttachment.subcategory_id == 29) {
        handleInputChange(`txtFromStation${id_n}`, objAttachment.from_station);
        handleInputChange(`txtToStation${id_n}`, objAttachment.to_station);
        handleInputChange(`ddlTicketType${id_n}`, objAttachment.ticket_type);

        if (!document.querySelector<HTMLInputElement>(`#txtStartTripDate${id_n}`)?.classList.contains(`d-none`)) {
            handleInputChange(`txtStartTripDate${id_n}`, parse(objAttachment.start_trip_date, 'dd/MM/yyyy', new Date()));
        }
        if (!document.querySelector<HTMLInputElement>(`#txtEndTripDate${id_n}`)?.classList.contains(`d-none`)) {
            handleInputChange(`txtEndTripDate${id_n}`, parse(objAttachment.end_trip_date, 'dd/MM/yyyy', new Date()));
        }
        handleInputChange(`txtRoundTripDay${id_n}`, objAttachment.roundtrip_day);
        handleInputChange(`txtAmountPerDay${id_n}`, objAttachment.amount_per_day);
    }

    // callback();

    //in expense report, if the claim is not in editing mode, show the close icon

    let controllerName = window.location.pathname.split("/")[2].toLowerCase();
    if (controllerName == "expreport") {
        elementDisplay(`#btnCloseNav`, true, "div");
    }


    if (!isNullOrEmpty(inputValues[`txtRemarks${id_n}`])) {
        elementDisplay(`#clRmk${id_n}`, true, "div");
    }

    //AnP
    if (isExceedraEnabledCompany(objRequestor) && (categoryId == "17" || categoryId == "45"))
        enableRecoverable(false, id_n!, inputValues, handleInputChange,objAttachment.subcategory_id, objAttachment, objRequestor);
    else
        enableRecoverable(true, id_n!, inputValues, handleInputChange,objAttachment.subcategory_id, objAttachment, objRequestor);

    //Other Employee Benefits for OT meals
    let tempcountrychk = appConfig.OTMealsCountry.split(",")
    if (tempcountrychk.includes(objRequestor.country_code) && categoryId == "3" && objRequestor.country_code != "") {
        elementDisplay(`#divOTMealInfo${id_n}`, true, "div");
    } else {
        elementDisplay(`#divOTMealInfo${id_n}`, false, "div");
    }

     //Chinea per diem special message shown
    if (objRequestor.country_code == 'CN' && categoryId.toString() == '16') {
        elementDisplay("#divchinaperdieminfo", true, "div");
    } else {
        elementDisplay("#divchinaperdieminfo", false, "div");
    }

    //Per Diem Control

    //Control Checking for country who can access per diem calculation function
    const temprequestor = !isNullOrEmpty(localStorage.getItem("objRequestor")) ? JSON.parse(localStorage.getItem("objRequestor")!) : null;
    const objClaimUserInfo = !isNullOrEmpty(localStorage.getItem("objClaimUserInfo")) ? JSON.parse(localStorage.getItem("objClaimUserInfo")!) : null;
    let final_control_checking_user;

    if (!isNullOrEmpty(objClaimUserInfo)) {
        final_control_checking_user = objClaimUserInfo;
    } else if (!isNullOrEmpty(temprequestor)) {
        final_control_checking_user = temprequestor;
    }

    //Myammar per diem special message shown
    //Myammer disable currency code
    if (final_control_checking_user.country_code == 'MM' && categoryId.toString() == '16') {
            if (final_control_checking_user.company_code == 'MM80' || final_control_checking_user.company_code == 'MM83') {
                elementDisplay(`#divMMperdieminfo${id_n}`, true, "div");
            }
            else if (final_control_checking_user.company_code == 'MM82') {
                elementDisplay(`#divMMperdieminfo2${id_n}`, true, "div");
            }
        disableInput(`#ddlCurrency${id_n}`, true, "select");

    } else {
        elementDisplay(`#divMMperdieminfo${id_n}`, false, "div");
        elementDisplay(`#divMMperdieminfo2${id_n}`, false, "div");
        // disableInput(`#ddlCurrency${id_n}`, false, "select"); 
    }

    //Per diem claim - invoice/receipt date will hidden from user (global changes)
    if (categoryId && (categoryId.toString() == '16' || categoryId.toString() == '41' || categoryId.toString() == '42' || categoryId.toString() == '51')) {  //Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic.
        elementDisplay(`#div_invoice_date${id_n}`, false, "div");
    } else {
        elementDisplay(`#div_invoice_date${id_n}`, true, "div");
    }

    //Check Decimal input when all value has been binded
    input_decimal = checkInputDecimal(id_n!, inputValues);

    //Check Zero atatchment Condition when user bind claim information
    checkAndAllowZeroAttach(id_n, inputValues, handleInputChange, '');

    let isGermanyDisabledAmountField = false;

    //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
    if ((final_control_checking_user.country_code == "DE" || final_control_checking_user.country_code == "PL" || final_control_checking_user.company_code == "CH87" || objRequestor.country_code == "VN") &&
        document.querySelector<HTMLInputElement>('#txtClaimAmount' + id_n)?.disabled == true) {
        isGermanyDisabledAmountField = true;
    }

    // //TH - Transport -> Mileage
    hideShowTaxableFields(
        id_n, 
        inputValues,
        handleInputChange, 
        objRequestor, 
        appConfig.HideShowTaxableFieldsCountry,
        inputValues[`form_mode`]
    );

    // Begin, Saber, 20260911 - Bind null instead of "NaN"/0 when taxable/nontaxable is missing.
    // Number(null) === 0 in JS, so the previous Number() bind turned DB null into 0 and
    // updateClaimDetail then posted 0. parseFloat(null).toFixed() produced "NaN" and
    // failed SPP_TXN_CLAIM_UPD decimal conversion (400 "Cannot find table 0.").
    const toBoundTaxAmount = (raw: any): string | null => {
      if (raw == null || raw === "" || raw === "NaN") {
        return null;
      }
      const amount = Number(raw);
      return Number.isFinite(amount) ? amount.toFixed(input_decimal) : null;
    };
    handleInputChange(`txtTaxableamount${id_n}`, toBoundTaxAmount(objAttachment.taxable_amt));
    handleInputChange(`txtNontaxableamount${id_n}`, toBoundTaxAmount(objAttachment.nontaxable_amt));
    // End, Saber, 20260911

    if (document.querySelector<HTMLInputElement>('#txtClaimAmount' + id_n)?.disabled == false && isGermanyDisabledAmountField == true) {
        disableInput(`#txtClaimAmount${id_n}`, true, "text");
    }

    if (final_control_checking_user.country_code == 'TH' && document.querySelector<HTMLInputElement>('#txtClaimAmount' + id_n)?.disabled == false && objAttachment.iS_CC == "1") {
        disableInput(`#txtClaimAmount${id_n}`, true, "text");
    }

    //Employee children education fee new fields
    employeeChildrenEducationFee(
        id_n, 
        handleInputChange, 
        objRequestor, 
        objRequestor.country_code,
        categoryId
    )
    //$('#ddlMaitalStatus' + i).val(objAttachment.marital_status);

    handleInputChange(`txtBirthYear${id_n}`, objAttachment.birth_year);
    if ((controllerName == "expreport" || form_mode == "View") && (categoryId == '46' || categoryId == '47' || categoryId == '48')) {
        disableInput(`#txtClaimAmount`, true, "text");

    }
    //Courier
    // if (objRequestor.country_code == 'IN' && objAttachment.subcategory_id == 15) {
    //     $('#chkbx_TaxNotApply_' + i).trigger("change");
    // }
    //Courier

    //Cash Card / Cash Advance / Cash Refund
    // if (form_mode != "New" && ($('#ddlCategory' + i).val() == "46" || $('#ddlCategory' + i).val() == "47" || $('#ddlCategory' + i).val() == "48")) {
    //     $('#ddlCategory' + i).attr('disabled', 'true');
    // } else if (form_mode == "Edit") {
    //     $("#ddlCategory" + i + " option[value='46']").remove();
    //     $("#ddlCategory" + i + " option[value='47']").remove();
    //     $("#ddlCategory" + i + " option[value='48']").remove();
    // }

    if (document.querySelector<HTMLElement>('#lblStatusValue')) {
        let status_name = document.querySelector<HTMLElement>('#lblStatusValue')?.innerHTML;

        if (categoryId == "48" && status_name != "Processed") {
            disableInput(`#QuickFile${id_n}`, false, "div");
            elementDisplay(`#btnExit${id_n}`, true, "div");
            disableInput(`#btnExit${id_n}`, false, "div");
        }
    }


    //Cash Advance//
    // if (objAttachment.subcategory_id == 46) {
    //     $('#ddlCashAdvanceType' + i).change();
    // }
    //Cash Advance//

}

 export function checkAndDisablePersonalExpense(id_n:number | undefined, inputValues: { [key: string]: any | undefined }, objAttachment:any) {

    disableInput(`#chkPersonalExpense${id_n}`, false, "text");

    if (inputValues[`ddlCategory${id_n}`] == "8") {
        if (!isNullOrEmpty(objAttachment)) {
            if (objAttachment.iS_CC == "1") {
                if (inputValues[`txtClaimAmount${id_n}`] < 0) {
                    disableInput(`#chkPersonalExpense${id_n}`, true, "text");
                }
            }
        }
    }

}

export function setPaymentType2_visibility(
    cat_id: number | undefined,
    transport_type_id: number | undefined,
    id_n: number | undefined,
    inputValues: { [key: string]: any | undefined },
    handleInputChange: (id: string, value?: any) => Promise<void>,
    numberOfPage: number | undefined,
    objRequestor: any,
    objAttachment: any,
    objCreditCard: any,
    handleBindDDL?: (id: string, value?: any) => void,
    bindDDL?: { [key: string]: any | undefined }
) {

    const currentUrlPath = window.location.pathname;

    elementDisplay(`#cc_statement${numberOfPage}`, false, "div");

    if (inputValues[`chkCreditCard${id_n}`] == 0) {
        elementDisplay(`#cc_statement${numberOfPage}`, false, "div");
    }

    if (objAttachment.iS_CC == "1") {
        elementDisplay(`#cc_statement${numberOfPage}`, true, "div");
    }

    if (currentUrlPath.includes("ExpReport") && objAttachment.iS_CC == "1") {

        if (cat_id == 16 || cat_id == 51 || (cat_id == 4 && transport_type_id?.toString() == "2" && objRequestor.company_code != 'NZ94' && objRequestor.company_code != 'NZ95')) {//Terk Amendment 20240327 [#CHN-9923] : Daily Allowance for red zone provinces copy the Per diem logic.
            toast.warning("Not applicable for corporate credit card transactions.");

            cat_id = 0;
            transport_type_id = 0;
        }
    }

    //handleInputChange(`isDateRange`, 0);

    if (!numberOfPage) {
        numberOfPage = 1;
    }

    switch (cat_id) {
        case 4: //Transport
        case 55: ////Other Office Expenses
            transport_type_id = isNullOrEmpty(transport_type_id) ? 0 : transport_type_id;
            switch (transport_type_id?.toString()) {
                case "2": //Mileage
                    if ((inputValues[`isDateRange`] == 0 && inputValues[`txtCreditCard${id_n}`] != 1) ||
                        (objAttachment.subcategory_id?.toString() != inputValues[`ddlCategory${id_n}`] && inputValues[`txtCreditCard${id_n}`] != 1)) {
                        handleInputChange(`txtDate${id_n}`, '');
                        handleInputChange(`isDateRange`, 1);
                        handleInputChange(`txtStartDate${id_n}`, !isNullOrEmpty(objAttachment.receiptstartdate) ? parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()) : new Date());
                        handleInputChange(`txtEndDate${id_n}`, !isNullOrEmpty(objAttachment.receiptenddate) ? parse(objAttachment.receiptenddate, 'dd/MM/yyyy', new Date()) : new Date());
                        handleInputChange(`txtDateRange${id_n}`, !isNullOrEmpty(objAttachment.receiptstartdate) ? parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()) : new Date());

                    }
                    else {
                        if(!isNullOrEmpty(objCreditCard)){
                            for (let ind = 0; ind < objCreditCard.length; ind++) {
                                if (objCreditCard[ind].id == inputValues[`ddlCreditCardStatement${id_n}`]) {
                                    handleInputChange(`txtStartDate${id_n}`, objCreditCard[ind].txn_date);
                                    handleInputChange(`txtEndDate${id_n}`, objCreditCard[ind].txn_date);
                                    handleInputChange(`isDateRange`, 1);
                                    handleInputChange(`txtDateRange${id_n}`, objCreditCard[ind].txn_date);
                                }
                            }

                        }

                    }

                    if (inputValues[`isDateRange`] == 1 && (!isNullOrEmpty(inputValues[`txtStartDate${id_n}`]) || !isNullOrEmpty(inputValues[`txtEndDate${id_n}`]))
                        || (inputValues[`isDateRange`] == 0 && !isNullOrEmpty(inputValues[`txtDate${id_n}`]))) {
                        //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
                        if (objRequestor.country_code != "DE" && objRequestor.country_code != "PL" && objRequestor.company_code != 'CH87' && objRequestor.country_code != "VN") {
                            //Apply Check Tax Column Function
                            // loadtaxcol($(this).attr("runningNumber"), $(this).val());
                            loadTaxCol(id_n!, inputValues, handleInputChange, window.location, objAttachment, objRequestor, inputValues[`txtStartDate${id_n}`], handleBindDDL, bindDDL);
                            // let lastnumber = $(this).attr("id").slice(-1) == 0 ? 10 : $(this).attr("id").slice(-1);

                            //If More than one tax rate is present, this wont automatically till user choose one
                            // CheckAndAutoCalTax(lastnumber, objAttachment);
                            checkAndAutoCalTax(id_n!, inputValues, handleInputChange, objRequestor, objAttachment);
                        }

                    }

                    if (inputValues[`txtCreditCard${id_n}`] != 1) {
                        elementDisplay(`#cc_statement${id_n}`, false, 'div');
                        handleInputChange(`chkCash${id_n}`, 1);
                        disableInput(`#chkCreditCard${id_n}`, true, 'text');
                    }
                    break;
                case "6":  //Parking and toll
                case "9":  //Parking
                case "10":  //toll
                    if ((inputValues[`txtCreditCard${id_n}`] != 1) ||
                        (objAttachment.subcategory_id?.toString() != inputValues[`ddlCategory${id_n}`] && inputValues[`txtCreditCard${id_n}`] != 1)) {
                        handleInputChange(`txtDate${id_n}`, '');
                        handleInputChange(`isDateRange`, 1);
                        handleInputChange(`txtStartDate${id_n}`, !isNullOrEmpty(objAttachment.receiptstartdate) ? parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()) : new Date());
                        handleInputChange(`txtEndDate${id_n}`, !isNullOrEmpty(objAttachment.receiptenddate) && (objAttachment.receiptenddate != objAttachment.receiptstartdate) ? parse(objAttachment.receiptenddate, 'dd/MM/yyyy', new Date()) : new Date());
                        handleInputChange(`txtDateRange${id_n}`, !isNullOrEmpty(objAttachment.receiptstartdate) ? parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()) : new Date());
                    }
                    else {
                        if (!isNullOrEmpty(objCreditCard)) {
                            for (let ind = 0; ind < objCreditCard.length; ind++) {
                                if (objCreditCard[ind].id == inputValues[`ddlCreditCardStatement${id_n}`]) {
                                    handleInputChange(`txtStartDate${id_n}`, objCreditCard[ind].txn_date);
                                    handleInputChange(`txtEndDate${id_n}`, objCreditCard[ind].txn_date);
                                    handleInputChange(`isDateRange`, 1);
                                    handleInputChange(`txtDateRange${id_n}`, objCreditCard[ind].txn_date);
                                }
                            }
                        }
                        handleInputChange(`txtDate${id_n}`, '');
                        handleInputChange(`isDateRange`, 1);
                        handleInputChange(`txtStartDate${id_n}`, !isNullOrEmpty(objAttachment.receiptstartdate) ? parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()) : new Date());
                        handleInputChange(`txtEndDate${id_n}`, !isNullOrEmpty(objAttachment.receiptenddate) && (objAttachment.receiptenddate != objAttachment.receiptstartdate) ? parse(objAttachment.receiptenddate, 'dd/MM/yyyy', new Date()) : new Date());
                        handleInputChange(`txtDateRange${id_n}`, !isNullOrEmpty(objAttachment.receiptstartdate) ? parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()) : new Date());
                    }

                    if (inputValues[`isDateRange`] == 1 && (!isNullOrEmpty(inputValues[`txtStartDate${id_n}`]) || !isNullOrEmpty(inputValues[`txtEndDate${id_n}`]))
                        || (inputValues[`isDateRange`] == 0 && !isNullOrEmpty(inputValues[`txtDate${id_n}`]))) {
                        //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
                        if (objRequestor.country_code != "DE" && objRequestor.country_code != "PL" && objRequestor.company_code != 'CH87' && objRequestor.country_code != "VN") {
                            //Apply Check Tax Column Function
                            // loadtaxcol($(this).attr("runningNumber"), $(this).val());
                            loadTaxCol(id_n!, inputValues, handleInputChange, window.location, objAttachment, objRequestor, inputValues[`isDateRange`] == 1 ? inputValues[`txtStartDate${id_n}`] : inputValues[`txtDate${id_n}`],handleBindDDL, bindDDL);
                            // let lastnumber = $(this).attr("id").slice(-1) == 0 ? 10 : $(this).attr("id").slice(-1);

                            //If More than one tax rate is present, this wont automatically till user choose one
                            // CheckAndAutoCalTax(lastnumber, objAttachment);
                            checkAndAutoCalTax(id_n!, inputValues, handleInputChange, objRequestor, objAttachment);
                        }

                    }

                    if (inputValues[`txtCreditCard${id_n}`] != 1) {
                        elementDisplay(`#cc_statement${id_n}`, false, 'div');
                    }
                    break;
                default: {
                    // Begin, Saber, 20260722, INC-1000442: From dual date to single date, receipt date not populated.
                    const selectedCreditCardStatement = bindDDL?.ccStatement?.find(
                        (statement: any) => statement.id == inputValues[`ddlCreditCardStatement${id_n}`]
                    );
                    const currentRangeStartDate = inputValues[`isDateRange`] == 1
                        ? inputValues[`txtStartDate${id_n}`]
                        : null;
                    const singleDate = !isNullOrEmpty(selectedCreditCardStatement?.txn_date)
                        ? selectedCreditCardStatement.txn_date instanceof Date
                            ? selectedCreditCardStatement.txn_date
                            : parse(selectedCreditCardStatement.txn_date, 'dd/MM/yyyy', new Date())
                        : !isNullOrEmpty(currentRangeStartDate)
                            ? currentRangeStartDate
                            : !isNullOrEmpty(objAttachment.subcategory_id) && objAttachment.subcategory_id?.toString() != inputValues[`ddlCategory${id_n}`] && inputValues[`txtCreditCard${id_n}`] != 1
                                ? !isNullOrEmpty(objAttachment.receiptstartdate)
                                    ? parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date())
                                    : new Date()
                                : null;

                    handleInputChange(`isDateRange`, 0);
                    if (!isNullOrEmpty(singleDate)) {
                        handleInputChange(`txtDate${id_n}`, singleDate);
                    }
                    // End, Saber, 20260722, INC-1000442: From dual date to single date, receipt date not populated.

                    if (inputValues[`isDateRange`] == 1 && (!isNullOrEmpty(inputValues[`txtStartDate${id_n}`]) || !isNullOrEmpty(inputValues[`txtEndDate${id_n}`]))
                        || (inputValues[`isDateRange`] == 0 && !isNullOrEmpty(inputValues[`txtDate${id_n}`]))) {
                        //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
                        if (objRequestor.country_code != "DE" && objRequestor.country_code != "PL" && objRequestor.company_code != 'CH87' && objRequestor.country_code != "VN") {
                            //Apply Check Tax Column Function
                            // loadtaxcol($(this).attr("runningNumber"), $(this).val());
                            loadTaxCol(id_n!, inputValues, handleInputChange, window.location, objAttachment, objRequestor, singleDate, handleBindDDL, bindDDL);
                            // let lastnumber = $(this).attr("id").slice(-1) == 0 ? 10 : $(this).attr("id").slice(-1);

                            //If More than one tax rate is present, this wont automatically till user choose one
                            // CheckAndAutoCalTax(lastnumber, objAttachment);
                            checkAndAutoCalTax(id_n!, inputValues, handleInputChange, objRequestor, objAttachment);
                        }

                    }

                    if (inputValues[`txtCreditCard${id_n}`] != 1) {
                        elementDisplay(`#cc_statement${id_n}`, false, 'div');
                    }
                    break;
                }
            }
            break;
        case 8: //Disputed transaction
            ////console.log("CC592");
            elementDisplay(`#cc_statement${id_n}`, true, 'div');

            disableInput(`#chkCash${id_n}`, true, 'text');

            handleInputChange(`chkCreditCard${id_n}`, 1);
            handleInputChange(`isDateRange`, 0);
            handleInputChange(`txtDate${id_n}`, new Date());
            handleInputChange(`maxDate`, new Date());

            break;
        case 16:  //Per diem
            //$(".paymentMode2").hide();
            // $('input[name=paymentMode1][value=cc]').prop("checked", true);

            if (objAttachment.subcategory_id?.toString() != inputValues[`ddlCategory${id_n}`]) {
                handleInputChange(`isDateRange`, 1);
                handleInputChange(`txtStartDate${id_n}`, '');
                handleInputChange(`txtEndDate${id_n}`, '');
                handleInputChange(`maxDate`, new Date());
                handleInputChange(`txtDateRange${id_n}`, '');

            }
            else {
                handleInputChange(`isDateRange`, 1);
                handleInputChange(`txtStartDate${id_n}`, !isNullOrEmpty(objAttachment.receiptstartdate) ? parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()) : new Date());
                handleInputChange(`txtEndDate${id_n}`, !isNullOrEmpty(objAttachment.receiptenddate) ? parse(objAttachment.receiptenddate, 'dd/MM/yyyy', new Date()) : new Date());
                handleInputChange(`txtDateRange${id_n}`, !isNullOrEmpty(objAttachment.receiptstartdate) ? parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()) : new Date());
                handleInputChange(`maxDate`, new Date());
            }

            if (inputValues[`isDateRange`] == 1 && (!isNullOrEmpty(inputValues[`txtStartDate${id_n}`]) || !isNullOrEmpty(inputValues[`txtEndDate${id_n}`]))
                || (inputValues[`isDateRange`] == 0 && !isNullOrEmpty(inputValues[`txtDate${id_n}`]))) {
                //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
                if (objRequestor.country_code != "DE" && objRequestor.country_code != "PL" && objRequestor.company_code != 'CH87' && objRequestor.country_code != "VN") {
                    //Apply Check Tax Column Function
                    // loadtaxcol($(this).attr("runningNumber"), $(this).val());
                    loadTaxCol(id_n!, inputValues, handleInputChange, window.location, objAttachment, objRequestor, inputValues[`txtStartDate${id_n}`],handleBindDDL, bindDDL);
                    // let lastnumber = $(this).attr("id").slice(-1) == 0 ? 10 : $(this).attr("id").slice(-1);

                    //If More than one tax rate is present, this wont automatically till user choose one
                    // CheckAndAutoCalTax(lastnumber, objAttachment);
                    checkAndAutoCalTax(id_n!, inputValues, handleInputChange, objRequestor, objAttachment);

                    // Do NOT call changePerDiemTax here: legacy only invokes it from the live
                    // date-picker "apply" event, never from loading/restoring a saved item, so it
                    // won't clobber the checked state that checkAndBind/bindTaxCol just restored
                    // from the saved objAttachment data.
                }

            }

            elementDisplay(`#cc_statement${id_n}`, false, 'div');
            handleInputChange(`chkCash${id_n}`, 1);
            disableInput(`#chkCreditCard${id_n}`, true, 'text');
            break;
        default:
            if (!isNullOrEmpty(objAttachment.subcategory_id) && objAttachment.subcategory_id?.toString() != inputValues[`ddlCategory${id_n}`] && inputValues[`txtCreditCard${id_n}`] != 1) {
                handleInputChange(`isDateRange`, 0);
                handleInputChange(`txtDate${id_n}`, !isNullOrEmpty(objAttachment.receiptstartdate) ? parse(objAttachment.receiptstartdate, 'dd/MM/yyyy', new Date()) : new Date());

            }
            else {
                
                inputValues[`txtCreditCard${id_n}`] != 1 && handleInputChange(`isDateRange`, 0);
            }

            if (inputValues[`isDateRange`] == 1 && (!isNullOrEmpty(inputValues[`txtStartDate${id_n}`]) || !isNullOrEmpty(inputValues[`txtEndDate${id_n}`]))
                || (inputValues[`isDateRange`] == 0 && !isNullOrEmpty(inputValues[`txtDate${id_n}`]))) {
                //Hazel Amendments  - #CHN18855 : PL80 Poland: Carat & Martin set up ( Copy DE settings)
                if (objRequestor.country_code != "DE" && objRequestor.country_code != "PL" && objRequestor.company_code != 'CH87' && objRequestor.country_code != "VN") {
                    //Apply Check Tax Column Function
                    // loadtaxcol($(this).attr("runningNumber"), $(this).val());
                    loadTaxCol(id_n!, inputValues, handleInputChange, window.location, objAttachment, objRequestor, inputValues[`txtStartDate${id_n}`],handleBindDDL, bindDDL);
                    // let lastnumber = $(this).attr("id").slice(-1) == 0 ? 10 : $(this).attr("id").slice(-1);

                    //If More than one tax rate is present, this wont automatically till user choose one
                    // CheckAndAutoCalTax(lastnumber, objAttachment);
                    checkAndAutoCalTax(id_n!, inputValues, handleInputChange, objRequestor, objAttachment);
                }

            }
            break;
    }

}
export function checkRecoverableType( //Saber,09/10/2025, Missing function from EEC Plus
  id_n: number | undefined,
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>
) {
  if (inputValues[`radio_coverable1_${id_n}`] == 1) {
    // Show main recoverable fields
    elementDisplay(`#recoverable${id_n}`, true, "div");
    mandatoryInput(`#txtRecoverable${id_n}`, true, "text");
    elementDisplay(`#divRecoverabletxt${id_n}`, true, "div");
    //Saber,2026-10-09 , Fixed element id (removed underscore)
    elementDisplay(`#divRecoverableSpecialGL_${id_n}`, true, "div");
    mandatoryInput(`#ddlRecoverableSpecialGL${id_n}`, true, "select");

    // Hide intercompany fields
    elementDisplay(`#divRecoverableInterComp${id_n}`, false, "div");
    mandatoryInput(`#txtInterCompRecoverable${id_n}`, false, "text");
    handleInputChange(`txtInterCompRecoverable${id_n}`, "");
  } else if (inputValues[`radio_coverable2_${id_n}`] == 1) {
    // Show intercompany fields
    elementDisplay(`#divRecoverableInterComp${id_n}`, true, "div");
    mandatoryInput(`#txtInterCompRecoverable${id_n}`, true, "text");

    // Hide main recoverable fields
    elementDisplay(`#recoverable${id_n}`, false, "div");
    mandatoryInput(`#txtRecoverable${id_n}`, false, "text");
    handleInputChange(`txtRecoverable${id_n}`, "");
    elementDisplay(`#divRecoverabletxt${id_n}`, false, "div");

    //Saber,2026-10-09 , Fixed element id (removed underscore)
    elementDisplay(`#divRecoverableSpecialGL_${id_n}`, false, "div");
    mandatoryInput(`#ddlRecoverableSpecialGL${id_n}`, false, "select");
    handleInputChange(`ddlRecoverableSpecialGL${id_n}`, "");
  }
}

// export async function updateDetailType(
//   id_n: number,
//   newValue: string,
//   inputValues: { [key: string]: any | undefined },
//   handleInputChange: (id: string, value?: any) => Promise<void>,
//   objAttachment: any
// ) {
//   // Persist latest selection
//   await handleInputChange(`ddlDetailType${id_n}`, newValue);

//   // Refresh cached value reference
//   const nextValues = { ...inputValues, [`ddlDetailType${id_n}`]: newValue };

//   // Requestor info
//   const reqStr = localStorage.getItem('objRequestor');
//   const objRequestor = reqStr ? JSON.parse(reqStr) : null;

//   // Re-run TH VAT/WHT + invoice visibility
//   if (objRequestor?.country_code === 'TH') {
//     enable_Disable_VAT_WHT_OnLoad(id_n, nextValues, handleInputChange, objAttachment);
//     loadInvoice_Number(id_n, nextValues, handleInputChange, objAttachment);
//   }

// }

export async function updateDetailType(
  id_n: number,
  newValue: string,
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>,
  objAttachment: any,
  bindDDL?: { [key: string]: any | undefined }        // added optional DDL source
) {
  await handleInputChange(`ddlDetailType${id_n}`, newValue);

  const nextValues = { ...inputValues, [`ddlDetailType${id_n}`]: newValue };

  // Death benefit visibility (restored logic)
  if (newValue) {
    let selectedText = bindDDL?.[`detailTypeDDL`]?.find((option: any) => option.value.toString() == newValue).label;
    if (!isNullOrEmpty(selectedText) && selectedText.replace(/'/g, "") == "Death benefit for staffs family") { //Terk Amendment 20250624 #SR-752550 // //Terk Amendment 20250624 #SR-804750
        elementDisplay(".divIdOfDeceasedPerson" , true , "div");
    }
    else {
        elementDisplay(".divIdOfDeceasedPerson" , false , "div");
        handleInputChange(`txtIdofDeceasedPerson${id_n}`, "");
    }
    // const selectedText = bindDDL?.[`ddlDetailType${id_n}`]
    //   ?.find((option: any) => option.value?.toString() === newValue)?.label;

    // if (
    //   selectedText &&
    //   selectedText.replace(/'/g, '') === 'Death benefit for staffs family'
    // ) {
    //   elementDisplay('.divIdOfDeceasedPerson', true, 'div');
    //   // Make deceased person id mandatory if required (uncomment if needed)
    //   // mandatoryInput(`#txtIdofDeceasedPerson${id_n}`, true, 'text');
    // } else {
    //   elementDisplay('.divIdOfDeceasedPerson', false, 'div');
    //   handleInputChange(`txtIdofDeceasedPerson${id_n}`, '');
    //   // mandatoryInput(`#txtIdofDeceasedPerson${id_n}`, false, 'text');
    // }
  } else {
    elementDisplay('.divIdOfDeceasedPerson', false, 'div');
    handleInputChange(`txtIdofDeceasedPerson${id_n}`, '');
  }

  const reqStr = localStorage.getItem('objRequestor');
  const objRequestor = reqStr ? JSON.parse(reqStr) : null;

  if (objRequestor?.country_code === 'TH') {
    enable_Disable_VAT_WHT_OnLoad(id_n, nextValues, handleInputChange, objAttachment);
    loadInvoice_Number(id_n, nextValues, handleInputChange, objAttachment);
  }

    if (objRequestor?.country_code === 'KH') {
    loadInvoice_Number(id_n, nextValues, handleInputChange, objAttachment);
  }

    // Begin, Saber, 20260514, SR-959286, CHN-20860, Load invoice number for MY (except MY98)
    if (objRequestor?.country_code === 'MY' || (window.location.pathname.includes("ExpReport") && objAttachment?.country === 'MY')) {
    loadInvoice_Number(id_n, nextValues, handleInputChange, objAttachment, window.location.pathname.includes("ExpReport"));
  }
    // End, Saber, 20260514, SR-959286, CHN-20860

    // Begin, Saber, 20260519, CHN-21547, Load invoice number for BN
    if (objRequestor?.country_code === 'BN' || (window.location.pathname.includes("ExpReport") && objAttachment?.country === 'BN')) {
    loadInvoice_Number(id_n, nextValues, handleInputChange, objAttachment, window.location.pathname.includes("ExpReport"));
  }
    // End, Saber, 20260519, CHN-21547, Load invoice number for BN

    if (objRequestor?.country_code === 'CN' || (window.location.pathname.includes("ExpReport") && objAttachment?.country === 'CN')) {
        loadInvoice_Number(id_n, nextValues, handleInputChange, objAttachment, window.location.pathname.includes("ExpReport"));
    }


    if (!isNullOrEmpty(objAttachment?.detail_type)) {
        handleInputChange(`ddlDetailType${id_n}`, objAttachment?.detail_type);
    }

    if (!isNullOrEmpty(objAttachment?.idofdeceasedperson)) {
        handleInputChange(`txtIdofDeceasedPerson${id_n}`, objAttachment?.idofdeceasedperson);
        let selectedText = bindDDL?.[`detailTypeDDL`]?.find((option: any) => option.value.toString() == objAttachment?.idofdeceasedperson).label;
        if (!isNullOrEmpty(selectedText) && selectedText.replace(/'/g, "") == "Death benefit for staffs family") { //Terk Amendment 20250624 #SR-752550 // //Terk Amendment 20250624 #SR-804750
            mandatoryInput(`#txtIdofDeceasedPerson${id_n}` , true , "text");
        }
    }
}
